import * as yr from "react";
import zt, { createContext as An, useContext as Pn, useState as q, useCallback as ut, useEffect as Ie, useRef as rt, useMemo as $t, Fragment as Da } from "react";
import Te from "@mui/material/Box";
import Fa from "@mui/material/Avatar";
import Ma from "@mui/material/Menu";
import yn from "@mui/material/MenuItem";
import Ur from "@mui/material/ListItemIcon";
import bi from "@mui/material/Divider";
import Si from "@mui/material/IconButton";
import er from "@mui/material/Tooltip";
import Va from "@mui/icons-material/Person";
import Ga from "@mui/material/AppBar";
import Ha from "@mui/material/Toolbar";
import { Box as ae, CircularProgress as jn, Typography as ze, Button as $e, Breadcrumbs as za, CardActionArea as $a, Card as tr, CardContent as nr, Stack as qt, Chip as wi, IconButton as rr, TextField as Wt, FormControlLabel as yi, Checkbox as Ri, Link as Ts, Alert as Rn, List as Ba, ListItemButton as qa, ListItemText as Wa, MenuItem as Ja, Table as Za, TableHead as Ya, TableRow as Cs, TableCell as yt, TableBody as Ka, Divider as Qa, Dialog as Yn, DialogTitle as Rr, DialogContent as Kn, DialogActions as Nr, Snackbar as Xa, Tooltip as eo } from "@mui/material";
import { colors as _t, Logo as xi } from "brand";
import { AuthProvider as to, useAuth as Et } from "react-oidc-context";
import { Delete as no, ArrowBack as ro, Add as so, People as io, Edit as ao } from "@mui/icons-material";
import sr from "@mui/material/Skeleton";
import ir from "@mui/material/Stack";
import { ThemeProvider as oo, styled as fr, useTheme as uo, useColorScheme as Ii } from "@mui/material/styles";
import lo from "@mui/material/CssBaseline";
import co from "@mui/material/List";
import ho from "@mui/material/ListItem";
import fo from "@mui/material/ListItemText";
import _i from "@mui/icons-material/Home";
import Ti from "@mui/icons-material/Settings";
import po from "@mui/icons-material/ChevronLeft";
import vo from "@mui/icons-material/ChevronRight";
import { Navigate as Ci, useLocation as go } from "react-router-dom";
import xn from "@mui/material/Typography";
import Ei from "@mui/material/Select";
import Es from "@mui/material/Switch";
import Os from "@mui/material/FormControlLabel";
import mo from "@mui/icons-material/Event";
import bo from "@mui/material/useMediaQuery";
import Lr from "@mui/material/Chip";
import So from "@mui/icons-material/Business";
import ks from "@mui/icons-material/AdminPanelSettings";
import { useTranslation as wo } from "i18n-fe";
import Oi from "@mui/icons-material/Brightness4";
import ki from "@mui/icons-material/Brightness7";
import Ai from "@mui/icons-material/Logout";
import * as Pi from "axios";
import yo from "axios";
import Ro from "@mui/icons-material/DeleteOutline";
import xo from "@mui/icons-material/Lock";
var Dr = { exports: {} }, un = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var As;
function Io() {
  if (As) return un;
  As = 1;
  var e = zt, s = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, t = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(o, u, l) {
    var c, d = {}, h = null, m = null;
    l !== void 0 && (h = "" + l), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (m = u.ref);
    for (c in u) i.call(u, c) && !t.hasOwnProperty(c) && (d[c] = u[c]);
    if (o && o.defaultProps) for (c in u = o.defaultProps, u) d[c] === void 0 && (d[c] = u[c]);
    return { $$typeof: s, type: o, key: h, ref: m, props: d, _owner: n.current };
  }
  return un.Fragment = r, un.jsx = a, un.jsxs = a, un;
}
var ln = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ps;
function _o() {
  return Ps || (Ps = 1, process.env.NODE_ENV !== "production" && function() {
    var e = zt, s = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), t = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), o = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), j = Symbol.iterator, E = "@@iterator";
    function M(b) {
      if (b === null || typeof b != "object")
        return null;
      var U = j && b[j] || b[E];
      return typeof U == "function" ? U : null;
    }
    var W = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function B(b) {
      {
        for (var U = arguments.length, F = new Array(U > 1 ? U - 1 : 0), Y = 1; Y < U; Y++)
          F[Y - 1] = arguments[Y];
        be("error", b, F);
      }
    }
    function be(b, U, F) {
      {
        var Y = W.ReactDebugCurrentFrame, he = Y.getStackAddendum();
        he !== "" && (U += "%s", F = F.concat([he]));
        var Se = F.map(function(se) {
          return String(se);
        });
        Se.unshift("Warning: " + U), Function.prototype.apply.call(console[b], console, Se);
      }
    }
    var ee = !1, ue = !1, de = !1, Z = !1, ye = !1, Ve;
    Ve = Symbol.for("react.module.reference");
    function et(b) {
      return !!(typeof b == "string" || typeof b == "function" || b === i || b === t || ye || b === n || b === l || b === c || Z || b === m || ee || ue || de || typeof b == "object" && b !== null && (b.$$typeof === h || b.$$typeof === d || b.$$typeof === a || b.$$typeof === o || b.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      b.$$typeof === Ve || b.getModuleId !== void 0));
    }
    function ct(b, U, F) {
      var Y = b.displayName;
      if (Y)
        return Y;
      var he = U.displayName || U.name || "";
      return he !== "" ? F + "(" + he + ")" : F;
    }
    function dt(b) {
      return b.displayName || "Context";
    }
    function We(b) {
      if (b == null)
        return null;
      if (typeof b.tag == "number" && B("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof b == "function")
        return b.displayName || b.name || null;
      if (typeof b == "string")
        return b;
      switch (b) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case t:
          return "Profiler";
        case n:
          return "StrictMode";
        case l:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof b == "object")
        switch (b.$$typeof) {
          case o:
            var U = b;
            return dt(U) + ".Consumer";
          case a:
            var F = b;
            return dt(F._context) + ".Provider";
          case u:
            return ct(b, b.render, "ForwardRef");
          case d:
            var Y = b.displayName || null;
            return Y !== null ? Y : We(b.type) || "Memo";
          case h: {
            var he = b, Se = he._payload, se = he._init;
            try {
              return We(se(Se));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var _e = Object.assign, Re = 0, Ut, Nt, sn, Un, Nn, an, Ln;
    function Dn() {
    }
    Dn.__reactDisabledLog = !0;
    function Fn() {
      {
        if (Re === 0) {
          Ut = console.log, Nt = console.info, sn = console.warn, Un = console.error, Nn = console.group, an = console.groupCollapsed, Ln = console.groupEnd;
          var b = {
            configurable: !0,
            enumerable: !0,
            value: Dn,
            writable: !0
          };
          Object.defineProperties(console, {
            info: b,
            log: b,
            warn: b,
            error: b,
            group: b,
            groupCollapsed: b,
            groupEnd: b
          });
        }
        Re++;
      }
    }
    function Mn() {
      {
        if (Re--, Re === 0) {
          var b = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: _e({}, b, {
              value: Ut
            }),
            info: _e({}, b, {
              value: Nt
            }),
            warn: _e({}, b, {
              value: sn
            }),
            error: _e({}, b, {
              value: Un
            }),
            group: _e({}, b, {
              value: Nn
            }),
            groupCollapsed: _e({}, b, {
              value: an
            }),
            groupEnd: _e({}, b, {
              value: Ln
            })
          });
        }
        Re < 0 && B("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var je = W.ReactCurrentDispatcher, Ge;
    function tt(b, U, F) {
      {
        if (Ge === void 0)
          try {
            throw Error();
          } catch (he) {
            var Y = he.stack.trim().match(/\n( *(at )?)/);
            Ge = Y && Y[1] || "";
          }
        return `
` + Ge + b;
      }
    }
    var ht = !1, Ot;
    {
      var ft = typeof WeakMap == "function" ? WeakMap : Map;
      Ot = new ft();
    }
    function kt(b, U) {
      if (!b || ht)
        return "";
      {
        var F = Ot.get(b);
        if (F !== void 0)
          return F;
      }
      var Y;
      ht = !0;
      var he = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Se;
      Se = je.current, je.current = null, Fn();
      try {
        if (U) {
          var se = function() {
            throw Error();
          };
          if (Object.defineProperty(se.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(se, []);
            } catch (Qe) {
              Y = Qe;
            }
            Reflect.construct(b, [], se);
          } else {
            try {
              se.call();
            } catch (Qe) {
              Y = Qe;
            }
            b.call(se.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Qe) {
            Y = Qe;
          }
          b();
        }
      } catch (Qe) {
        if (Qe && Y && typeof Qe.stack == "string") {
          for (var ne = Qe.stack.split(`
`), Je = Y.stack.split(`
`), Ue = ne.length - 1, Le = Je.length - 1; Ue >= 1 && Le >= 0 && ne[Ue] !== Je[Le]; )
            Le--;
          for (; Ue >= 1 && Le >= 0; Ue--, Le--)
            if (ne[Ue] !== Je[Le]) {
              if (Ue !== 1 || Le !== 1)
                do
                  if (Ue--, Le--, Le < 0 || ne[Ue] !== Je[Le]) {
                    var nt = `
` + ne[Ue].replace(" at new ", " at ");
                    return b.displayName && nt.includes("<anonymous>") && (nt = nt.replace("<anonymous>", b.displayName)), typeof b == "function" && Ot.set(b, nt), nt;
                  }
                while (Ue >= 1 && Le >= 0);
              break;
            }
        }
      } finally {
        ht = !1, je.current = Se, Mn(), Error.prepareStackTrace = he;
      }
      var Dt = b ? b.displayName || b.name : "", At = Dt ? tt(Dt) : "";
      return typeof b == "function" && Ot.set(b, At), At;
    }
    function vr(b, U, F) {
      return kt(b, !1);
    }
    function pa(b) {
      var U = b.prototype;
      return !!(U && U.isReactComponent);
    }
    function Vn(b, U, F) {
      if (b == null)
        return "";
      if (typeof b == "function")
        return kt(b, pa(b));
      if (typeof b == "string")
        return tt(b);
      switch (b) {
        case l:
          return tt("Suspense");
        case c:
          return tt("SuspenseList");
      }
      if (typeof b == "object")
        switch (b.$$typeof) {
          case u:
            return vr(b.render);
          case d:
            return Vn(b.type, U, F);
          case h: {
            var Y = b, he = Y._payload, Se = Y._init;
            try {
              return Vn(Se(he), U, F);
            } catch {
            }
          }
        }
      return "";
    }
    var on = Object.prototype.hasOwnProperty, hs = {}, fs = W.ReactDebugCurrentFrame;
    function Gn(b) {
      if (b) {
        var U = b._owner, F = Vn(b.type, b._source, U ? U.type : null);
        fs.setExtraStackFrame(F);
      } else
        fs.setExtraStackFrame(null);
    }
    function va(b, U, F, Y, he) {
      {
        var Se = Function.call.bind(on);
        for (var se in b)
          if (Se(b, se)) {
            var ne = void 0;
            try {
              if (typeof b[se] != "function") {
                var Je = Error((Y || "React class") + ": " + F + " type `" + se + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof b[se] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Je.name = "Invariant Violation", Je;
              }
              ne = b[se](U, se, Y, F, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ue) {
              ne = Ue;
            }
            ne && !(ne instanceof Error) && (Gn(he), B("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Y || "React class", F, se, typeof ne), Gn(null)), ne instanceof Error && !(ne.message in hs) && (hs[ne.message] = !0, Gn(he), B("Failed %s type: %s", F, ne.message), Gn(null));
          }
      }
    }
    var ga = Array.isArray;
    function gr(b) {
      return ga(b);
    }
    function ma(b) {
      {
        var U = typeof Symbol == "function" && Symbol.toStringTag, F = U && b[Symbol.toStringTag] || b.constructor.name || "Object";
        return F;
      }
    }
    function ba(b) {
      try {
        return ps(b), !1;
      } catch {
        return !0;
      }
    }
    function ps(b) {
      return "" + b;
    }
    function vs(b) {
      if (ba(b))
        return B("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ma(b)), ps(b);
    }
    var gs = W.ReactCurrentOwner, Sa = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ms, bs;
    function wa(b) {
      if (on.call(b, "ref")) {
        var U = Object.getOwnPropertyDescriptor(b, "ref").get;
        if (U && U.isReactWarning)
          return !1;
      }
      return b.ref !== void 0;
    }
    function ya(b) {
      if (on.call(b, "key")) {
        var U = Object.getOwnPropertyDescriptor(b, "key").get;
        if (U && U.isReactWarning)
          return !1;
      }
      return b.key !== void 0;
    }
    function Ra(b, U) {
      typeof b.ref == "string" && gs.current;
    }
    function xa(b, U) {
      {
        var F = function() {
          ms || (ms = !0, B("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", U));
        };
        F.isReactWarning = !0, Object.defineProperty(b, "key", {
          get: F,
          configurable: !0
        });
      }
    }
    function Ia(b, U) {
      {
        var F = function() {
          bs || (bs = !0, B("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", U));
        };
        F.isReactWarning = !0, Object.defineProperty(b, "ref", {
          get: F,
          configurable: !0
        });
      }
    }
    var _a = function(b, U, F, Y, he, Se, se) {
      var ne = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: s,
        // Built-in properties that belong on the element
        type: b,
        key: U,
        ref: F,
        props: se,
        // Record the component responsible for creating this element.
        _owner: Se
      };
      return ne._store = {}, Object.defineProperty(ne._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ne, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Y
      }), Object.defineProperty(ne, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: he
      }), Object.freeze && (Object.freeze(ne.props), Object.freeze(ne)), ne;
    };
    function Ta(b, U, F, Y, he) {
      {
        var Se, se = {}, ne = null, Je = null;
        F !== void 0 && (vs(F), ne = "" + F), ya(U) && (vs(U.key), ne = "" + U.key), wa(U) && (Je = U.ref, Ra(U, he));
        for (Se in U)
          on.call(U, Se) && !Sa.hasOwnProperty(Se) && (se[Se] = U[Se]);
        if (b && b.defaultProps) {
          var Ue = b.defaultProps;
          for (Se in Ue)
            se[Se] === void 0 && (se[Se] = Ue[Se]);
        }
        if (ne || Je) {
          var Le = typeof b == "function" ? b.displayName || b.name || "Unknown" : b;
          ne && xa(se, Le), Je && Ia(se, Le);
        }
        return _a(b, ne, Je, he, Y, gs.current, se);
      }
    }
    var mr = W.ReactCurrentOwner, Ss = W.ReactDebugCurrentFrame;
    function Lt(b) {
      if (b) {
        var U = b._owner, F = Vn(b.type, b._source, U ? U.type : null);
        Ss.setExtraStackFrame(F);
      } else
        Ss.setExtraStackFrame(null);
    }
    var br;
    br = !1;
    function Sr(b) {
      return typeof b == "object" && b !== null && b.$$typeof === s;
    }
    function ws() {
      {
        if (mr.current) {
          var b = We(mr.current.type);
          if (b)
            return `

Check the render method of \`` + b + "`.";
        }
        return "";
      }
    }
    function Ca(b) {
      return "";
    }
    var ys = {};
    function Ea(b) {
      {
        var U = ws();
        if (!U) {
          var F = typeof b == "string" ? b : b.displayName || b.name;
          F && (U = `

Check the top-level render call using <` + F + ">.");
        }
        return U;
      }
    }
    function Rs(b, U) {
      {
        if (!b._store || b._store.validated || b.key != null)
          return;
        b._store.validated = !0;
        var F = Ea(U);
        if (ys[F])
          return;
        ys[F] = !0;
        var Y = "";
        b && b._owner && b._owner !== mr.current && (Y = " It was passed a child from " + We(b._owner.type) + "."), Lt(b), B('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', F, Y), Lt(null);
      }
    }
    function xs(b, U) {
      {
        if (typeof b != "object")
          return;
        if (gr(b))
          for (var F = 0; F < b.length; F++) {
            var Y = b[F];
            Sr(Y) && Rs(Y, U);
          }
        else if (Sr(b))
          b._store && (b._store.validated = !0);
        else if (b) {
          var he = M(b);
          if (typeof he == "function" && he !== b.entries)
            for (var Se = he.call(b), se; !(se = Se.next()).done; )
              Sr(se.value) && Rs(se.value, U);
        }
      }
    }
    function Oa(b) {
      {
        var U = b.type;
        if (U == null || typeof U == "string")
          return;
        var F;
        if (typeof U == "function")
          F = U.propTypes;
        else if (typeof U == "object" && (U.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        U.$$typeof === d))
          F = U.propTypes;
        else
          return;
        if (F) {
          var Y = We(U);
          va(F, b.props, "prop", Y, b);
        } else if (U.PropTypes !== void 0 && !br) {
          br = !0;
          var he = We(U);
          B("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", he || "Unknown");
        }
        typeof U.getDefaultProps == "function" && !U.getDefaultProps.isReactClassApproved && B("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ka(b) {
      {
        for (var U = Object.keys(b.props), F = 0; F < U.length; F++) {
          var Y = U[F];
          if (Y !== "children" && Y !== "key") {
            Lt(b), B("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Y), Lt(null);
            break;
          }
        }
        b.ref !== null && (Lt(b), B("Invalid attribute `ref` supplied to `React.Fragment`."), Lt(null));
      }
    }
    var Is = {};
    function _s(b, U, F, Y, he, Se) {
      {
        var se = et(b);
        if (!se) {
          var ne = "";
          (b === void 0 || typeof b == "object" && b !== null && Object.keys(b).length === 0) && (ne += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Je = Ca();
          Je ? ne += Je : ne += ws();
          var Ue;
          b === null ? Ue = "null" : gr(b) ? Ue = "array" : b !== void 0 && b.$$typeof === s ? (Ue = "<" + (We(b.type) || "Unknown") + " />", ne = " Did you accidentally export a JSX literal instead of a component?") : Ue = typeof b, B("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ue, ne);
        }
        var Le = Ta(b, U, F, he, Se);
        if (Le == null)
          return Le;
        if (se) {
          var nt = U.children;
          if (nt !== void 0)
            if (Y)
              if (gr(nt)) {
                for (var Dt = 0; Dt < nt.length; Dt++)
                  xs(nt[Dt], b);
                Object.freeze && Object.freeze(nt);
              } else
                B("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xs(nt, b);
        }
        if (on.call(U, "key")) {
          var At = We(b), Qe = Object.keys(U).filter(function(La) {
            return La !== "key";
          }), wr = Qe.length > 0 ? "{key: someKey, " + Qe.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Is[At + wr]) {
            var Na = Qe.length > 0 ? "{" + Qe.join(": ..., ") + ": ...}" : "{}";
            B(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, wr, At, Na, At), Is[At + wr] = !0;
          }
        }
        return b === i ? ka(Le) : Oa(Le), Le;
      }
    }
    function Aa(b, U, F) {
      return _s(b, U, F, !0);
    }
    function Pa(b, U, F) {
      return _s(b, U, F, !1);
    }
    var ja = Pa, Ua = Aa;
    ln.Fragment = i, ln.jsx = ja, ln.jsxs = Ua;
  }()), ln;
}
process.env.NODE_ENV === "production" ? Dr.exports = Io() : Dr.exports = _o();
var g = Dr.exports;
function To({ menuItems: e }) {
  const [s, r] = yr.useState(null), i = !!s, n = (a) => {
    r(a.currentTarget);
  }, t = () => {
    r(null);
  };
  return /* @__PURE__ */ g.jsxs(yr.Fragment, { children: [
    /* @__PURE__ */ g.jsx(Te, { sx: { display: "flex", alignItems: "center", textAlign: "center" }, children: /* @__PURE__ */ g.jsx(er, { title: "Account settings", children: /* @__PURE__ */ g.jsx(
      Si,
      {
        onClick: n,
        size: "small",
        sx: { ml: 2 },
        "aria-controls": i ? "account-menu" : void 0,
        "aria-haspopup": "true",
        "aria-expanded": i ? "true" : void 0,
        children: /* @__PURE__ */ g.jsx(Fa, { sx: { width: 32, height: 32 }, children: /* @__PURE__ */ g.jsx(Va, {}) })
      }
    ) }) }),
    /* @__PURE__ */ g.jsx(
      Ma,
      {
        anchorEl: s,
        id: "account-menu",
        open: i,
        onClose: t,
        onClick: t,
        disableScrollLock: !0,
        slotProps: {
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0
              }
            }
          }
        },
        transformOrigin: { horizontal: "right", vertical: "top" },
        anchorOrigin: { horizontal: "right", vertical: "bottom" },
        children: e.map((a, o) => /* @__PURE__ */ g.jsxs(yr.Fragment, { children: [
          a.divider && /* @__PURE__ */ g.jsx(bi, {}),
          a.href ? /* @__PURE__ */ g.jsxs(yn, { component: "a", href: a.href, onClick: t, children: [
            a.icon && /* @__PURE__ */ g.jsx(Ur, { children: a.icon }),
            a.text
          ] }) : /* @__PURE__ */ g.jsxs(
            yn,
            {
              onClick: () => {
                var u;
                (u = a.onClick) == null || u.call(a), t();
              },
              children: [
                a.icon && /* @__PURE__ */ g.jsx(Ur, { children: a.icon }),
                a.text
              ]
            }
          )
        ] }, o))
      }
    )
  ] });
}
const Co = 64, Eo = ({ rightContent: e = null, brandLogo: s = null, sx: r = {} }) => /* @__PURE__ */ g.jsx(Ga, { sx: { ...r }, position: "fixed", elevation: 1, children: /* @__PURE__ */ g.jsxs(
  Ha,
  {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      pl: 0,
      minHeight: `${Co}px !important`
    },
    children: [
      s,
      /* @__PURE__ */ g.jsx(Te, { sx: { display: "flex", alignItems: "center", gap: 2 }, children: e })
    ]
  }
) }), Ad = ({ children: e, sx: s = {} }) => /* @__PURE__ */ g.jsx(
  Te,
  {
    component: "footer",
    sx: {
      position: "fixed",
      left: 0,
      bottom: 0,
      width: "100%",
      height: "56px",
      borderTop: 1,
      borderColor: "divider",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: (r) => r.zIndex.appBar,
      ...s
    },
    children: e
  }
), Oo = 64, ko = ({ children: e }) => /* @__PURE__ */ g.jsx(
  Te,
  {
    component: "main",
    sx: {
      p: "20px",
      pb: 0,
      flexGrow: 1,
      mb: "56px",
      // space for footer
      minHeight: `calc(100vh - ${Oo}px - 56px)`,
      overflow: "auto"
    },
    children: e || /* @__PURE__ */ g.jsx("div", { children: "MainContent (stub)" })
  }
), ji = "common-fe.navRailExpanded", Ui = 72, Ao = 200, Po = () => {
  try {
    return window.localStorage.getItem(ji) === "true";
  } catch {
    return !1;
  }
}, jo = (e) => {
  try {
    window.localStorage.setItem(ji, String(e));
  } catch {
  }
}, Ni = An({
  expanded: !1,
  width: Ui,
  toggleExpanded: () => {
  }
}), Uo = ({ children: e }) => {
  const [s, r] = q(Po), i = ut(() => {
    r((t) => {
      const a = !t;
      return jo(a), a;
    });
  }, []), n = s ? Ao : Ui;
  return /* @__PURE__ */ g.jsx(Ni.Provider, { value: { expanded: s, width: n, toggleExpanded: i }, children: e });
}, Li = () => Pn(Ni), xr = 64, No = { xs: 2, sm: 4, md: 8 }, Lo = ({ appFooterEnabled: e, children: s, appFooter: r, appBar: i, navRail: n }) => {
  const { width: t } = Li();
  return /* @__PURE__ */ g.jsxs(Te, { sx: { minHeight: "100vh", width: "100%" }, children: [
    /* @__PURE__ */ g.jsx(
      Te,
      {
        sx: {
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          zIndex: 1300
        },
        children: i
      }
    ),
    /* @__PURE__ */ g.jsxs(
      Te,
      {
        sx: {
          display: "flex",
          flexDirection: "row",
          pt: `${xr}px`
        },
        children: [
          n && /* @__PURE__ */ g.jsx(
            Te,
            {
              sx: {
                width: t,
                flexShrink: 0,
                position: "fixed",
                height: `calc(100vh - ${xr}px)`,
                top: xr,
                left: 0,
                zIndex: 1200,
                transition: "width 0.15s ease"
              },
              children: n
            }
          ),
          /* @__PURE__ */ g.jsx(
            Te,
            {
              sx: {
                flexGrow: 1,
                minWidth: 0,
                ml: n ? `${t}px` : 0,
                px: No,
                transition: "margin-left 0.15s ease"
              },
              children: /* @__PURE__ */ g.jsx(ko, { children: s })
            }
          )
        ]
      }
    ),
    e && r
  ] });
}, Pd = ({
  appFooterEnabled: e = !0,
  children: s,
  appFooter: r = null,
  appBar: i = null,
  navRail: n = null
}) => /* @__PURE__ */ g.jsx(Uo, { children: /* @__PURE__ */ g.jsx(
  Lo,
  {
    appFooterEnabled: e,
    appFooter: r,
    appBar: i,
    navRail: n,
    children: s
  }
) });
function Fr({ message: e }) {
  return /* @__PURE__ */ g.jsxs(
    ae,
    {
      sx: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "background.default",
        zIndex: 13e3
        // higher than MUI modal
      },
      children: [
        /* @__PURE__ */ g.jsx(jn, { sx: { color: _t.foxOrange } }),
        e && /* @__PURE__ */ g.jsx(ze, { variant: "h6", sx: { mt: 2 }, children: e })
      ]
    }
  );
}
function Di(e = "") {
  return ["/", `${e}/callback`, `${e}/logout`, `${e}/logged-out`];
}
function Do(e, s = "") {
  return typeof e == "string" && e.startsWith("/") && !Di(s).includes(e);
}
function Fo(e = "") {
  return [`${e}/logout`, `${e}/logged-out`];
}
function Mo(e, s = "") {
  return Fo(s).includes(e);
}
function jd(e) {
  if (typeof e != "string" || e === "") return "";
  let s;
  try {
    s = new URL(e).pathname;
  } catch {
    return "";
  }
  const r = "/callback";
  return s.endsWith(r) ? s.slice(0, -r.length) : "";
}
function Ud({ navigateFunction: e, location: s, basename: r = "" }) {
  return Ie(() => {
    const i = setTimeout(() => {
      const n = localStorage.getItem("redirect_url");
      localStorage.removeItem("redirect_url");
      const t = Do(n, r) ? n : "/";
      e(t, { replace: !0 });
    }, 500);
    return () => clearTimeout(i);
  }, [e, s, r]), /* @__PURE__ */ g.jsx(Fr, { message: "Signing you in..." });
}
let Fi = !1;
function Nd() {
  Fi = !0;
}
function js() {
  return Fi;
}
function Vo() {
  return typeof window < "u" && !!window.Cypress;
}
async function Go({ navigate: e = () => window.location.replace("/") } = {}) {
  Ns(Us(() => window.localStorage)), Ns(Us(() => window.sessionStorage)), await zo(), await $o(), e();
}
function Us(e) {
  try {
    return e();
  } catch {
    return null;
  }
}
const Ho = "oidc.";
function Ns(e) {
  if (e)
    try {
      const s = [];
      for (let r = 0; r < e.length; r++) {
        const i = e.key(r);
        i && i.startsWith(Ho) && s.push(i);
      }
      s.forEach((r) => e.removeItem(r));
    } catch {
    }
}
async function zo() {
  var e, s;
  try {
    const r = await ((s = (e = navigator.serviceWorker) == null ? void 0 : e.getRegistrations) == null ? void 0 : s.call(e));
    if (!r) return;
    await Promise.all(r.map((i) => i.unregister()));
  } catch {
  }
}
async function $o() {
  var e, s;
  try {
    const r = await ((s = (e = window.caches) == null ? void 0 : e.keys) == null ? void 0 : s.call(e));
    if (!r) return;
    await Promise.all(r.map((i) => window.caches.delete(i)));
  } catch {
  }
}
function Mi(e) {
  return e ?? (typeof __BUILD_ID__ < "u" ? __BUILD_ID__ : "dev");
}
function Bo({ error: e }) {
  const s = Mi();
  return /* @__PURE__ */ g.jsxs(
    ae,
    {
      sx: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        px: 3,
        bgcolor: "background.default",
        zIndex: 13e3
        // higher than MUI modal, matches FullScreenLoader
      },
      children: [
        /* @__PURE__ */ g.jsx(ze, { variant: "h6", sx: { mb: 1 }, children: "Encountering error..." }),
        /* @__PURE__ */ g.jsx(
          ze,
          {
            "data-testid": "auth-error-message",
            variant: "body2",
            sx: { mb: 3, maxWidth: 480, fontFamily: "monospace", color: "text.secondary" },
            children: e == null ? void 0 : e.message
          }
        ),
        /* @__PURE__ */ g.jsx(
          $e,
          {
            "data-testid": "auth-error-start-over",
            variant: "contained",
            onClick: () => Go(),
            sx: { bgcolor: _t.foxOrange, "&:hover": { bgcolor: _t.foxOrange } },
            children: "Start over"
          }
        ),
        /* @__PURE__ */ g.jsxs(
          ze,
          {
            "data-testid": "auth-error-build-id",
            variant: "caption",
            sx: { mt: 3, color: "text.secondary", fontFamily: "monospace" },
            children: [
              "Build ",
              s
            ]
          }
        )
      ]
    }
  );
}
function qo({ children: e, basename: s = "" }) {
  var a;
  const r = Et(), i = Mo(window.location.pathname, s), n = rt(!1), t = ((a = r.error) == null ? void 0 : a.source) === "signinSilent" && !r.isAuthenticated;
  return Ie(() => {
    const o = window.location.pathname;
    Di(s).includes(o) || localStorage.setItem("redirect_url", o);
  }, [s]), Ie(() => {
    var o;
    if (!r.isLoading && !r.isAuthenticated && (!r.error || t) && !js() && !i) {
      if (!r.error && ((o = r.user) != null && o.refresh_token) && !n.current) {
        n.current = !0, r.signinSilent();
        return;
      }
      r.signinRedirect();
    }
  }, [
    r.isLoading,
    r.isAuthenticated,
    r.error,
    r,
    i,
    t
  ]), r.isLoading ? /* @__PURE__ */ g.jsx(Fr, { message: "Loading..." }) : r.error && !r.isAuthenticated && !js() && !t ? /* @__PURE__ */ g.jsx(Bo, { error: r.error }) : !r.isAuthenticated && !i ? /* @__PURE__ */ g.jsx(Fr, { message: "Redirecting to login..." }) : e;
}
function Ld({ cognitoAuthConfig: e, basename: s = "", children: r }) {
  const i = Vo() ? { ...e, automaticSilentRenew: !1, monitorSession: !1 } : e;
  return /* @__PURE__ */ g.jsx(to, { ...i, children: /* @__PURE__ */ g.jsx(qo, { basename: s, children: r }) });
}
const Dd = ({
  onConfirm: e,
  onCancel: s,
  confirmText: r = "Confirm",
  cancelText: i = "Cancel",
  buttonText: n = "Delete",
  buttonIcon: t = /* @__PURE__ */ g.jsx(no, {}),
  variant: a = "outlined",
  color: o = "error",
  size: u = "small",
  disabled: l = !1,
  "data-testid": c,
  confirmButtonTestId: d,
  cancelButtonTestId: h
}) => {
  const [m, j] = q(!1), E = () => {
    j(!0);
  }, M = () => {
    j(!1), e();
  }, W = () => {
    j(!1), s && s();
  };
  return m ? /* @__PURE__ */ g.jsxs(ae, { sx: { display: "flex", gap: 1 }, children: [
    /* @__PURE__ */ g.jsx(
      $e,
      {
        variant: "contained",
        color: o,
        size: u,
        onClick: M,
        "data-testid": d,
        children: r
      }
    ),
    /* @__PURE__ */ g.jsx(
      $e,
      {
        variant: "outlined",
        size: u,
        onClick: W,
        "data-testid": h,
        children: i
      }
    )
  ] }) : /* @__PURE__ */ g.jsx(
    $e,
    {
      variant: a,
      color: o,
      size: u,
      startIcon: t,
      onClick: E,
      disabled: l,
      "data-testid": c,
      children: n
    }
  );
};
function Fd({
  rows: e = 5,
  columns: s = 1,
  showHeader: r = !0,
  dense: i = !1,
  sx: n,
  ...t
}) {
  const a = i ? 28 : 40, o = i ? 0.75 : 1.25, u = Math.max(1, s), l = (c, d) => /* @__PURE__ */ g.jsx(ir, { direction: "row", spacing: o, sx: { width: "100%" }, children: Array.from({ length: u }).map((h, m) => /* @__PURE__ */ g.jsx(
    sr,
    {
      variant: "rounded",
      height: d,
      sx: { flex: 1, borderRadius: 1 }
    },
    m
  )) }, c);
  return /* @__PURE__ */ g.jsx(
    Te,
    {
      role: "progressbar",
      "aria-busy": "true",
      "aria-label": "Loading",
      "data-testid": "table-skeleton",
      sx: { width: "100%", ...n },
      ...t,
      children: /* @__PURE__ */ g.jsxs(ir, { spacing: o, children: [
        r && l("header", a * 0.7),
        Array.from({ length: Math.max(1, e) }).map(
          (c, d) => l(`row-${d}`, a)
        )
      ] })
    }
  );
}
function Md() {
  const e = Et();
  return /* @__PURE__ */ g.jsxs(
    ae,
    {
      "data-testid": "logged-out-page",
      component: "main",
      sx: {
        minHeight: "75vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        px: 3,
        bgcolor: "background.default"
      },
      children: [
        /* @__PURE__ */ g.jsx(ae, { sx: { color: _t.darkGrey, mb: 4, lineHeight: 0 }, children: /* @__PURE__ */ g.jsx(
          xi,
          {
            "data-testid": "logged-out-logo",
            role: "img",
            "aria-label": "Fox Village",
            style: { width: 280, maxWidth: "100%", height: "auto" }
          }
        ) }),
        /* @__PURE__ */ g.jsx(ze, { variant: "h5", gutterBottom: !0, children: "You have been signed out" }),
        /* @__PURE__ */ g.jsx(
          ze,
          {
            variant: "body1",
            sx: { mb: 4, maxWidth: 480, color: "text.secondary" },
            children: "Your session has ended. Sign in again to continue."
          }
        ),
        /* @__PURE__ */ g.jsx(
          $e,
          {
            "data-testid": "logged-out-sign-in",
            variant: "contained",
            size: "large",
            onClick: () => e.signinRedirect(),
            sx: {
              bgcolor: _t.foxOrange,
              color: _t.darkRed,
              fontWeight: 700,
              textTransform: "none",
              px: 4,
              py: 1.25,
              "&:hover": {
                bgcolor: _t.foxOrange,
                filter: "brightness(0.92)"
              }
            },
            children: "Sign in again"
          }
        )
      ]
    }
  );
}
function Vd({ navigateFunction: e }) {
  const s = Et();
  return Ie(() => {
    let r = !0;
    async function i() {
      await s.removeUser(), r && e("/logged-out", { replace: !0 });
    }
    return i(), () => {
      r = !1;
    };
  }, [s, e]), /* @__PURE__ */ g.jsx("div", { children: "You have been logged out." });
}
function Gd({ theme: e, children: s }) {
  return !e || typeof e != "object" ? (console.error("Invalid theme object provided to MuiThemeProvider"), s) : /* @__PURE__ */ g.jsxs(oo, { theme: e, children: [
    /* @__PURE__ */ g.jsx(lo, {}),
    s
  ] });
}
const Wo = fr(Te)(({ theme: e, backgroundColor: s, color: r, width: i }) => ({
  width: i,
  height: "100%",
  backgroundColor: s || e.palette.background.paper,
  color: r || e.palette.text.primary,
  borderRight: `1px solid ${e.palette.divider}`,
  display: "flex",
  flexDirection: "column",
  paddingTop: e.spacing(1),
  overflow: "hidden",
  transition: "width 0.15s ease"
})), Jo = fr(Si)(({ theme: e, backgroundColor: s, color: r }) => ({
  position: "absolute",
  top: e.spacing(1.5),
  right: 0,
  transform: "translateX(50%)",
  width: 20,
  height: 20,
  padding: 0,
  borderRadius: 4,
  backgroundColor: s || e.palette.background.paper,
  color: r || e.palette.text.primary,
  border: `1px solid ${e.palette.divider}`,
  zIndex: 1,
  "&:hover": {
    backgroundColor: s || e.palette.background.paper,
    opacity: 0.8
  }
})), Hd = ({
  navItems: e,
  backgroundColor: s = "#1a1a1a",
  color: r = "inherit"
}) => {
  const { expanded: i, width: n, toggleExpanded: t } = Li(), a = [
    {
      icon: /* @__PURE__ */ g.jsx(_i, {}),
      text: "Home",
      onClick: () => {
      }
    },
    {
      icon: /* @__PURE__ */ g.jsx(Ti, {}),
      text: "Settings",
      onClick: () => {
      }
    }
  ], o = e && e.length > 0 ? e : a;
  return /* @__PURE__ */ g.jsxs(Te, { sx: { position: "relative", width: "100%", height: "100%" }, children: [
    /* @__PURE__ */ g.jsx(Wo, { backgroundColor: s, color: r, width: n, children: /* @__PURE__ */ g.jsx(co, { sx: { width: "100%", p: 0 }, children: o.map((u, l) => {
      const c = /* @__PURE__ */ g.jsxs(
        ho,
        {
          onClick: u.onClick,
          sx: {
            flexDirection: i ? "row" : "column",
            justifyContent: i ? "flex-start" : "center",
            py: 1,
            px: i ? 2 : 0,
            gap: i ? 1.5 : 0,
            color: "inherit",
            // #582 — nav items are clickable; show the pointer (hand) cursor
            // on hover (ListItem alone doesn't imply a button cursor).
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "transparent",
              opacity: 0.8
            }
          },
          children: [
            /* @__PURE__ */ g.jsx(
              Ur,
              {
                sx: {
                  minWidth: "auto",
                  color: "inherit"
                },
                children: u.icon
              }
            ),
            i && /* @__PURE__ */ g.jsx(
              fo,
              {
                primary: u.text,
                primaryTypographyProps: {
                  variant: "caption",
                  align: "left",
                  sx: {
                    fontSize: "0.75rem",
                    color: "inherit",
                    whiteSpace: "nowrap"
                  }
                }
              }
            )
          ]
        },
        l
      );
      return i ? c : /* @__PURE__ */ g.jsx(er, { title: u.text, placement: "right", children: c }, l);
    }) }) }),
    /* @__PURE__ */ g.jsx(er, { title: i ? "Collapse navigation" : "Expand navigation", children: /* @__PURE__ */ g.jsx(
      Jo,
      {
        onClick: t,
        "aria-label": i ? "Collapse navigation" : "Expand navigation",
        backgroundColor: s,
        color: r,
        children: i ? /* @__PURE__ */ g.jsx(po, { sx: { fontSize: 14 } }) : /* @__PURE__ */ g.jsx(vo, { sx: { fontSize: 14 } })
      }
    ) })
  ] });
};
function zd({ children: e }) {
  return Et().isAuthenticated ? e : /* @__PURE__ */ g.jsx(Ci, { to: "/callback", replace: !0 });
}
const $d = ({
  children: e,
  maxWidth: s = 600,
  minWidth: r = 320,
  backTo: i,
  backLabel: n,
  breadcrumbs: t,
  onBack: a
}) => {
  const o = () => {
    a && a();
  };
  return /* @__PURE__ */ g.jsxs(
    ae,
    {
      maxWidth: s,
      minWidth: r,
      mt: 4,
      pb: 8,
      sx: {
        overflowX: "auto"
      },
      children: [
        /* @__PURE__ */ g.jsx(
          ae,
          {
            sx: {
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
              mb: 3
            },
            children: /* @__PURE__ */ g.jsxs(ae, { sx: { display: "flex", alignItems: "center", gap: 2, flex: 1 }, children: [
              i && /* @__PURE__ */ g.jsx(
                $e,
                {
                  startIcon: /* @__PURE__ */ g.jsx(ro, {}),
                  onClick: o,
                  variant: "outlined",
                  size: "small",
                  children: n || "Back"
                }
              ),
              t && /* @__PURE__ */ g.jsx(za, { separator: "", children: zt.Children.map(t, (u, l) => {
                const c = zt.Children.count(t);
                let d = "middle";
                return c === 1 ? d = "single" : l === 0 ? d = "first" : l === c - 1 && (d = "last"), zt.cloneElement(u, { position: d });
              }) })
            ] })
          }
        ),
        e
      ]
    }
  );
}, it = "12px", Zo = fr(Te, {
  shouldForwardProp: (e) => e !== "position"
})(({ theme: e, position: s }) => {
  const r = () => {
    switch (s) {
      case "first":
        return `polygon(0 0, 100% 0, calc(100% - ${it}) 100%, 0 100%)`;
      case "middle":
        return `polygon(${it} 0, 100% 0, calc(100% - ${it}) 100%, 0 100%)`;
      case "last":
        return `polygon(${it} 0, calc(100% - ${it}) 0, 100% 50%, calc(100% - ${it}) 100%, 0 100%)`;
      case "single":
      default:
        return `polygon(0 0, calc(100% - ${it}) 0, 100% 50%, calc(100% - ${it}) 100%, 0 100%)`;
    }
  };
  return {
    position: "relative",
    display: "flex",
    alignItems: "center",
    height: "24px",
    backgroundColor: e.palette.mode === "dark" ? e.palette.grey[800] : e.palette.grey[200],
    color: e.palette.getContrastText(
      e.palette.mode === "dark" ? e.palette.grey[800] : e.palette.grey[200]
    ),
    cursor: "pointer",
    textDecoration: "none",
    clipPath: r(),
    // Nudge the items together to overlap
    marginLeft: s === "middle" || s === "last" ? `-${it}` : 0,
    // Adjust padding to make space for the clipped areas
    paddingLeft: s === "middle" || s === "last" ? `calc(${it} + ${e.spacing(1)})` : e.spacing(2),
    paddingRight: `calc(${it} + ${e.spacing(1)})`,
    "&:hover, &:focus-within": {
      backgroundColor: e.palette.mode === "dark" ? e.palette.grey[700] : e.palette.grey[300]
    }
  };
}), Yo = fr(xn)({
  whiteSpace: "nowrap",
  fontSize: "0.8125rem",
  fontWeight: 400,
  color: "inherit"
}), Bd = ({ label: e, component: s = "a", ...r }) => /* @__PURE__ */ g.jsx(Zo, { component: s, ...r, children: /* @__PURE__ */ g.jsx(Yo, { children: e }) }), qd = ({ onClick: e, label: s, "data-testid": r }) => /* @__PURE__ */ g.jsx(
  $a,
  {
    onClick: e,
    sx: {
      height: "100%",
      minHeight: 140,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: (i) => i.palette.mode === "dark" ? i.palette.grey[800] : i.palette.grey[200],
      borderRadius: (i) => i.shape.borderRadius,
      padding: 2,
      "&:hover": {
        backgroundColor: (i) => i.palette.mode === "dark" ? i.palette.grey[700] : i.palette.grey[300]
      }
    },
    "data-testid": r || "new-item-card-button",
    children: /* @__PURE__ */ g.jsxs(
      ae,
      {
        sx: {
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          border: "3px dashed",
          borderColor: "grey.500",
          borderRadius: "10px",
          padding: "20px",
          color: "grey.500"
        },
        children: [
          /* @__PURE__ */ g.jsx(
            ae,
            {
              sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 48,
                height: 48,
                borderRadius: "50%",
                border: "3px solid",
                borderColor: "inherit",
                mb: 1
              },
              children: /* @__PURE__ */ g.jsx(so, { sx: { fontSize: 32 } })
            }
          ),
          /* @__PURE__ */ g.jsx(ze, { variant: "button", component: "span", children: s })
        ]
      }
    )
  }
), Wd = ({ title: e, icon: s, tags: r = [], onEdit: i, showEdit: n, onMembers: t, showMembers: a, "data-testid": o, editButtonTestId: u, membersButtonTestId: l }) => /* @__PURE__ */ g.jsxs(
  tr,
  {
    sx: {
      position: "relative",
      minHeight: 120,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      borderRadius: 0,
      backgroundColor: (c) => c.palette.mode === "dark" ? c.palette.grey[900] : c.palette.background.paper
    },
    "data-testid": o,
    elevation: 1,
    children: [
      /* @__PURE__ */ g.jsx(nr, { sx: { pb: 1 }, children: /* @__PURE__ */ g.jsxs(ae, { sx: { display: "flex", alignItems: "center", mb: 2 }, children: [
        s && zt.cloneElement(s, { sx: { mr: 1.5, color: "text.secondary" } }),
        /* @__PURE__ */ g.jsx(ze, { variant: "h6", component: "div", noWrap: !0, children: e })
      ] }) }),
      /* @__PURE__ */ g.jsx(nr, { sx: { pt: 0, flexGrow: 1 }, children: /* @__PURE__ */ g.jsx(qt, { direction: "row", spacing: 1, children: r.map((c, d) => /* @__PURE__ */ g.jsx(
        wi,
        {
          label: c.label,
          color: c.color || "default",
          size: c.size || "small",
          variant: "outlined"
        },
        d
      )) }) }),
      /* @__PURE__ */ g.jsxs(ae, { sx: { position: "absolute", top: 8, right: 8, display: "flex", gap: 0.5 }, children: [
        a && /* @__PURE__ */ g.jsx(
          rr,
          {
            "aria-label": `manage members for ${e}`,
            onClick: t,
            sx: {
              color: "text.secondary"
            },
            "data-testid": l,
            children: /* @__PURE__ */ g.jsx(io, {})
          }
        ),
        n && /* @__PURE__ */ g.jsx(
          rr,
          {
            "aria-label": `edit ${e}`,
            onClick: i,
            sx: {
              color: "text.secondary"
            },
            "data-testid": u,
            children: /* @__PURE__ */ g.jsx(ao, {})
          }
        )
      ] })
    ]
  }
);
class mn extends Error {
}
mn.prototype.name = "InvalidTokenError";
function Ko(e) {
  return decodeURIComponent(atob(e).replace(/(.)/g, (s, r) => {
    let i = r.charCodeAt(0).toString(16).toUpperCase();
    return i.length < 2 && (i = "0" + i), "%" + i;
  }));
}
function Qo(e) {
  let s = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (s.length % 4) {
    case 0:
      break;
    case 2:
      s += "==";
      break;
    case 3:
      s += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return Ko(s);
  } catch {
    return atob(s);
  }
}
function Vi(e, s) {
  if (typeof e != "string")
    throw new mn("Invalid token specified: must be a string");
  s || (s = {});
  const r = s.header === !0 ? 0 : 1, i = e.split(".")[r];
  if (typeof i != "string")
    throw new mn(`Invalid token specified: missing part #${r + 1}`);
  let n;
  try {
    n = Qo(i);
  } catch (t) {
    throw new mn(`Invalid token specified: invalid base64 for part #${r + 1} (${t.message})`);
  }
  try {
    return JSON.parse(n);
  } catch (t) {
    throw new mn(`Invalid token specified: invalid json for part #${r + 1} (${t.message})`);
  }
}
const Mr = "common-fe.activeOrgId", Xo = "426e8750-5b55-59f4-90c7-835b46d6a990", eu = (e) => {
  const s = e.filter((r) => r.id !== Xo);
  return s.length ? s : e;
}, tu = (e) => {
  if (!e) return !1;
  try {
    const s = Vi(e), r = s["custom:super"] ?? s.super;
    return r === "true" || r === !0;
  } catch {
    return !1;
  }
}, Gi = An({
  orgs: [],
  activeOrgId: null,
  setActiveOrgId: () => {
  },
  loading: !1,
  error: null,
  isSuper: !1,
  orgResolved: !1
}), nu = () => {
  try {
    return window.localStorage.getItem(Mr) || null;
  } catch {
    return null;
  }
}, ru = (e) => {
  try {
    e ? window.localStorage.setItem(Mr, e) : window.localStorage.removeItem(Mr);
  } catch {
  }
}, Jd = ({ listOrgs: e, children: s }) => {
  var E;
  const i = (E = Et().user) == null ? void 0 : E.access_token, n = tu(i), [t, a] = q([]), [o, u] = q(!0), [l, c] = q(null), [d, h] = q(() => nu()), m = ut((M) => {
    h(M), ru(M);
  }, []);
  Ie(() => {
    if (!e) {
      u(!1);
      return;
    }
    let M = !1;
    const W = new AbortController();
    return (async () => {
      try {
        u(!0), c(null);
        const B = await e(n, W.signal);
        if (M) return;
        a(eu(Array.isArray(B) ? B : []));
      } catch (B) {
        if (M) return;
        console.error("Failed to load orgs for switcher:", B), c(B), a([]);
      } finally {
        M || u(!1);
      }
    })(), () => {
      M = !0, W.abort();
    };
  }, [e, n]), Ie(() => {
    if (!t.length) return;
    t.some((W) => W.id === d) || m(t[0].id);
  }, [t, d, m]);
  const j = d != null || !o;
  return /* @__PURE__ */ g.jsx(
    Gi.Provider,
    {
      value: { orgs: t, activeOrgId: d, setActiveOrgId: m, loading: o, error: l, isSuper: n, orgResolved: j },
      children: s
    }
  );
}, is = () => Pn(Gi), It = "America/Los_Angeles", su = /^(?:GMT|UTC)?\s*([+-])\s*(\d{1,2})(?::?(\d{2}))?$/i, iu = -14, au = 12, Ir = /* @__PURE__ */ new Map();
function ou(e) {
  if (Ir.has(e)) return Ir.get(e);
  let s = !0;
  try {
    new Intl.DateTimeFormat("en-CA", { timeZone: e });
  } catch {
    s = !1;
  }
  return Ir.set(e, s), s;
}
function as(e) {
  if (typeof e != "string") return It;
  const s = e.trim();
  if (!s) return It;
  if (/^(?:GMT|UTC)$/i.test(s)) return "Etc/GMT";
  const r = su.exec(s);
  if (r) {
    const [, i, n, t] = r;
    if (t && Number(t) !== 0) return It;
    const a = Number(n) * (i === "-" ? -1 : 1);
    return a < iu || a > au ? It : a === 0 ? "Etc/GMT" : `Etc/GMT${a < 0 ? "+" : "-"}${Math.abs(a)}`;
  }
  return ou(s) ? s : It;
}
function Hi(e) {
  if (e instanceof Date) return Number.isNaN(e.getTime()) ? null : e;
  if (e == null) return null;
  const s = new Date(e);
  return Number.isNaN(s.getTime()) ? null : s;
}
function Zd(e, { timeZone: s = It, seconds: r = !1, hour12: i = !0 } = {}) {
  const n = Hi(e);
  return n ? n.toLocaleTimeString("en-US", {
    ...i ? { hour: "numeric", hour12: !0 } : { hour: "2-digit", hourCycle: "h23" },
    minute: "2-digit",
    ...r ? { second: "2-digit" } : {},
    timeZone: as(s)
  }) : "";
}
function Yd(e, s = /* @__PURE__ */ new Date()) {
  var n;
  const r = as(e);
  return ((n = new Intl.DateTimeFormat("en-US", {
    timeZone: r,
    timeZoneName: "short"
  }).formatToParts(s).find((t) => t.type === "timeZoneName")) == null ? void 0 : n.value) ?? r;
}
function uu(e, s = It) {
  const r = Hi(e);
  return r ? new Intl.DateTimeFormat("en-CA", {
    timeZone: as(s),
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).format(r) : null;
}
const Vr = "common-fe.activeShowId", lu = Symbol("active-show-never-loaded"), zi = An({
  shows: [],
  allShows: [],
  activeShowId: null,
  activeShow: null,
  setActiveShowId: () => {
  },
  patchShow: () => {
  },
  loading: !1,
  error: null,
  filterActive: !1,
  showAllShows: !1,
  setShowAllShows: () => {
  }
}), Ls = 3, Ds = 24 * 60 * 60 * 1e3, _r = (e) => {
  if (typeof e != "string" || !e) return null;
  const s = /* @__PURE__ */ new Date(`${e}T00:00:00.000Z`);
  return Number.isNaN(s.getTime()) ? null : s;
}, cu = (e, { todayKey: s = uu(/* @__PURE__ */ new Date(), It) } = {}) => {
  const r = _r(e == null ? void 0 : e.startDate), i = _r(e == null ? void 0 : e.endDate);
  if (!r || !i) return !0;
  const n = _r(s);
  if (!n) return !0;
  const t = r.getTime() - Ls * Ds, a = i.getTime() + Ls * Ds;
  return n.getTime() >= t && n.getTime() <= a;
}, du = () => {
  try {
    return window.localStorage.getItem(Vr) || null;
  } catch {
    return null;
  }
}, hu = (e) => {
  try {
    e ? window.localStorage.setItem(Vr, e) : window.localStorage.removeItem(Vr);
  } catch {
  }
}, fu = (e) => [...e].sort((s, r) => {
  const i = s != null && s.startDate ? new Date(s.startDate).getTime() : NaN, n = r != null && r.startDate ? new Date(r.startDate).getTime() : NaN, t = Number.isFinite(i), a = Number.isFinite(n);
  return t && a ? n - i : t ? -1 : a ? 1 : 0;
}), Kd = ({
  listShows: e,
  orgId: s,
  filterActive: r = !1,
  children: i
}) => {
  const [n, t] = q([]), [a, o] = q(!0), [u, l] = q(null), [c, d] = q(() => du()), h = rt(lu), m = ut((ee) => {
    d(ee), hu(ee);
  }, []), j = ut((ee, ue) => {
    t(
      (de) => de.map((Z) => Z.id === ee ? { ...Z, ...ue } : Z)
    );
  }, []);
  Ie(() => {
    if (!e) {
      o(!1);
      return;
    }
    let ee = !1;
    const ue = new AbortController();
    return (async () => {
      try {
        o(!0);
        const de = await e(ue.signal);
        if (ee) return;
        h.current = s, l(null), t(Array.isArray(de) ? fu(de) : []);
      } catch (de) {
        if (ee) return;
        console.error("Failed to load shows for switcher:", de), h.current !== s && (l(de), t([]));
      } finally {
        ee || o(!1);
      }
    })(), () => {
      ee = !0, ue.abort();
    };
  }, [e, s]);
  const [E, M] = q(!1), W = $t(() => !r || E ? n : n.filter((ee) => cu(ee)), [n, r, E]);
  Ie(() => {
    if (!n.length || n.some((de) => de.id === c)) return;
    const ue = W[0] || n[0];
    m(ue.id);
  }, [n, W, c, m]);
  const B = $t(
    () => n.find((ee) => ee.id === c) || null,
    [n, c]
  ), be = $t(
    () => ({
      shows: W,
      allShows: n,
      activeShowId: c,
      activeShow: B,
      setActiveShowId: m,
      patchShow: j,
      loading: a,
      error: u,
      filterActive: r,
      showAllShows: E,
      setShowAllShows: M
    }),
    [
      W,
      n,
      c,
      B,
      m,
      j,
      a,
      u,
      r,
      E
    ]
  );
  return /* @__PURE__ */ g.jsx(zi.Provider, { value: be, children: i });
}, pu = () => Pn(zi);
function $i(e, { max: s = 28, tail: r = 12 } = {}) {
  if (!e || e.length <= s) return e;
  const i = Math.max(0, s - r - 1);
  return `${e.slice(0, i)}…${e.slice(-r)}`;
}
const vu = { max: 44, tail: 16 }, gu = { max: 28, tail: 12 }, Tr = (e) => (typeof (e == null ? void 0 : e.friendlyName) == "string" ? e.friendlyName.trim() : "") || null, Qd = ({ onShowChange: e, toggleInDropdown: s = !1 }) => {
  const {
    shows: r,
    allShows: i,
    activeShowId: n,
    activeShow: t,
    setActiveShowId: a,
    loading: o,
    filterActive: u,
    showAllShows: l,
    setShowAllShows: c
  } = pu(), d = uo(), h = bo(d.breakpoints.up("lg"), {
    defaultMatches: !0
  });
  if (o && !i.length)
    return /* @__PURE__ */ g.jsx(
      sr,
      {
        "data-testid": "show-switcher-loading",
        variant: "rounded",
        width: 140,
        height: 24,
        sx: { bgcolor: "rgba(255,255,255,0.18)" }
      }
    );
  if (!i || i.length === 0) return null;
  const m = (j) => {
    const E = j.target.value;
    a(E), e && e(E);
  };
  return /* @__PURE__ */ g.jsxs(
    Te,
    {
      "data-testid": "show-switcher",
      sx: { display: "flex", alignItems: "center", gap: 0.75, color: "inherit" },
      children: [
        /* @__PURE__ */ g.jsx(mo, { fontSize: "small", sx: { color: "inherit", opacity: 0.9 } }),
        /* @__PURE__ */ g.jsxs(
          Ei,
          {
            value: n || "",
            onChange: m,
            variant: "standard",
            disableUnderline: !0,
            inputProps: { "aria-label": "Show switcher" },
            renderValue: () => {
              const j = t ? t.name || t.id : "", E = Tr(t);
              return /* @__PURE__ */ g.jsx(
                "span",
                {
                  title: j,
                  style: {
                    display: "block",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                  },
                  children: E || $i(
                    j,
                    h ? vu : gu
                  )
                }
              );
            },
            sx: {
              color: "inherit",
              fontSize: "0.9rem",
              // { xs: 240, lg: 420 } (was 240): a 33-character full name plus the caret did not fit
              // in 240 at 0.9rem, so the CSS end-ellipsis stacked a second
              // ellipsis on top of truncateMiddle's (bug #200). Sized for the
              // 44-character FULL_NAME_TRUNCATION budget above. Only from lg up: at
              // narrow widths the bar also carries OrgSwitcher + email, and a
              // wider wrapper cannot shrink below its content, so xs keeps 240
              // (paired with NARROW_NAME_TRUNCATION).
              maxWidth: { xs: 240, lg: 420 },
              "& .MuiSelect-select": { py: 0.25 },
              "& .MuiSelect-icon": { color: "inherit" }
            },
            children: [
              t && !r.some((j) => j.id === t.id) && /* @__PURE__ */ g.jsx(
                yn,
                {
                  value: t.id,
                  style: { display: "none" },
                  children: t.name || t.id
                },
                t.id
              ),
              r.map((j) => /* @__PURE__ */ g.jsx(yn, { value: j.id, children: Tr(j) ? /* @__PURE__ */ g.jsxs(Te, { sx: { display: "flex", flexDirection: "column" }, children: [
                /* @__PURE__ */ g.jsx("span", { children: Tr(j) }),
                /* @__PURE__ */ g.jsx(Te, { component: "span", sx: { fontSize: "0.75rem", color: "text.secondary" }, children: j.name || j.id })
              ] }) : j.name || j.id }, j.id)),
              u && s && /* @__PURE__ */ g.jsxs(Te, { component: "li", children: [
                /* @__PURE__ */ g.jsx(bi, { sx: { my: 0.5 } }),
                /* @__PURE__ */ g.jsx(
                  Te,
                  {
                    onClick: (j) => j.stopPropagation(),
                    onKeyDown: (j) => {
                      j.key !== "Escape" && j.stopPropagation();
                    },
                    sx: { px: 2, py: 0.5 },
                    children: /* @__PURE__ */ g.jsx(
                      Os,
                      {
                        "data-testid": "show-all-shows-toggle",
                        control: /* @__PURE__ */ g.jsx(
                          Es,
                          {
                            size: "small",
                            checked: l,
                            onChange: (j) => c(j.target.checked),
                            inputProps: { "aria-label": "Show all past shows" }
                          }
                        ),
                        label: "Show all past shows",
                        sx: { mr: 0, "& .MuiFormControlLabel-label": { fontSize: "0.8rem" } }
                      }
                    )
                  }
                )
              ] }, "show-all-shows-toggle-row")
            ]
          }
        ),
        u && !s && /* @__PURE__ */ g.jsx(
          Os,
          {
            "data-testid": "show-all-shows-toggle",
            control: /* @__PURE__ */ g.jsx(
              Es,
              {
                size: "small",
                checked: l,
                onChange: (j) => c(j.target.checked),
                inputProps: { "aria-label": "Show all past shows" },
                sx: {
                  "& .MuiSwitch-switchBase": { color: "rgba(255,255,255,0.75)" },
                  "& .MuiSwitch-switchBase.Mui-checked": { color: "#fff" },
                  "& .MuiSwitch-track": {
                    backgroundColor: "rgba(255,255,255,0.5)"
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "rgba(255,255,255,0.9)"
                  }
                }
              }
            ),
            label: "Show all past shows",
            sx: {
              color: "inherit",
              ml: 0.5,
              mr: 0,
              "& .MuiFormControlLabel-label": { fontSize: "0.75rem" }
            }
          }
        )
      ]
    }
  );
}, Bi = An({
  appNamespace: null,
  isSuper: !1,
  permissions: /* @__PURE__ */ new Set()
}), mu = (e, s) => typeof s == "string" && s.includes(":") ? s : `${e}:${s}`, bu = (e) => {
  if (!e) return { isSuper: !1, permissions: /* @__PURE__ */ new Set() };
  try {
    const s = Vi(e), r = s["custom:super"] ?? s.super, i = r === "true" || r === !0, n = new Set(
      Array.isArray(s.permissions) ? s.permissions : []
    );
    return { isSuper: i, permissions: n };
  } catch {
    return { isSuper: !1, permissions: /* @__PURE__ */ new Set() };
  }
}, Xd = ({ appNamespace: e, children: s }) => {
  var t;
  const i = (t = Et().user) == null ? void 0 : t.access_token, n = $t(() => {
    const { isSuper: a, permissions: o } = bu(i);
    return { appNamespace: e, isSuper: a, permissions: o };
  }, [e, i]);
  return /* @__PURE__ */ g.jsx(Bi.Provider, { value: n, children: s });
}, eh = (e) => {
  const { appNamespace: s, isSuper: r, permissions: i } = Pn(Bi);
  return r ? !0 : i.has(mu(s, e));
}, In = (e) => typeof e == "string" ? e.trim() : "", qi = (e) => In(e == null ? void 0 : e.firstName) || In(e == null ? void 0 : e.given_name), Su = (e) => In(e == null ? void 0 : e.lastName) || In(e == null ? void 0 : e.family_name), Wi = (e) => In(e == null ? void 0 : e.email);
function wu(e) {
  return e ? [qi(e), Su(e)].filter(Boolean).join(" ") || Wi(e) : "";
}
function th(e) {
  return e ? qi(e) || Wi(e) : "";
}
const yu = (e, s) => e.length > s ? `${e.slice(0, Math.max(0, s - 1))}…` : e;
function Ru({ maxEmailChars: e = 28 }) {
  var o;
  const r = ((o = Et().user) == null ? void 0 : o.profile) || {}, i = (r.given_name || "").trim(), n = wu(r), t = (r.email || "").trim(), a = i || (t ? yu(t, e) : "");
  return a ? /* @__PURE__ */ g.jsx(er, { title: n || t, children: /* @__PURE__ */ g.jsx(
    xn,
    {
      variant: "body2",
      noWrap: !0,
      "data-testid": "nav-user-name",
      sx: { color: "inherit", maxWidth: 220 },
      children: a
    }
  ) }) : null;
}
const xu = ({ accountOrgsUrl: e } = {}) => {
  const { orgs: s, activeOrgId: r, setActiveOrgId: i, isSuper: n } = is(), { t } = wo("common");
  return n && (!s || s.length === 0) ? /* @__PURE__ */ g.jsx(
    Te,
    {
      "data-testid": "org-switcher-empty",
      sx: { display: "flex", alignItems: "center", gap: 0.75, color: "inherit" },
      children: /* @__PURE__ */ g.jsx(
        Lr,
        {
          ...e ? { component: "a", href: e, clickable: !0 } : {},
          size: "small",
          icon: /* @__PURE__ */ g.jsx(
            ks,
            {
              fontSize: "small",
              sx: { color: "inherit !important" }
            }
          ),
          label: e ? t(
            "orgSwitcher.noOrgsEnabledLink",
            "No orgs enabled for switching — manage in Account"
          ) : t("orgSwitcher.noOrgsEnabled", "No orgs enabled for switching"),
          sx: {
            color: "inherit",
            bgcolor: "rgba(255, 255, 255, 0.18)",
            fontWeight: 600,
            ...e && {
              textDecoration: "underline",
              "&:hover": { bgcolor: "rgba(255, 255, 255, 0.28)" }
            }
          }
        }
      )
    }
  ) : !s || s.length <= 1 ? null : /* @__PURE__ */ g.jsxs(
    Te,
    {
      "data-testid": "org-switcher",
      sx: { display: "flex", alignItems: "center", gap: 0.75, color: "inherit" },
      children: [
        n && /* @__PURE__ */ g.jsx(
          Lr,
          {
            size: "small",
            "data-testid": "super-badge",
            icon: /* @__PURE__ */ g.jsx(
              ks,
              {
                fontSize: "small",
                sx: { color: "inherit !important" }
              }
            ),
            label: "All orgs",
            sx: {
              color: "inherit",
              bgcolor: "rgba(255, 255, 255, 0.18)",
              fontWeight: 600
            }
          }
        ),
        /* @__PURE__ */ g.jsx(So, { fontSize: "small", sx: { color: "inherit", opacity: 0.9 } }),
        /* @__PURE__ */ g.jsx(
          Ei,
          {
            value: r || "",
            onChange: (a) => i(a.target.value),
            variant: "standard",
            disableUnderline: !0,
            inputProps: { "aria-label": "Organization switcher" },
            renderValue: (a) => {
              const o = s.find((l) => l.id === a), u = o ? o.name : "";
              return /* @__PURE__ */ g.jsx(
                "span",
                {
                  title: u,
                  style: {
                    display: "block",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                  },
                  children: $i(u)
                }
              );
            },
            sx: {
              color: "inherit",
              fontSize: "0.9rem",
              maxWidth: 220,
              "& .MuiSelect-select": { py: 0.25 },
              "& .MuiSelect-icon": { color: "inherit" }
            },
            children: s.map((a) => /* @__PURE__ */ g.jsx(yn, { value: a.id, children: a.name }, a.id))
          }
        )
      ]
    }
  );
};
function nh({ onLogout: e, brandLogo: s = null, accountOrgsUrl: r }) {
  var l;
  const { mode: i, setMode: n } = Ii(), { orgs: t, activeOrgId: a } = is(), o = ((l = t.find((c) => c.id === a)) == null ? void 0 : l.name) || null, u = [
    {
      icon: i === "dark" ? /* @__PURE__ */ g.jsx(ki, {}) : /* @__PURE__ */ g.jsx(Oi, {}),
      text: i === "dark" ? "Light mode" : "Dark mode",
      onClick: () => n(i === "dark" ? "light" : "dark")
    },
    {
      icon: /* @__PURE__ */ g.jsx(Ai, {}),
      text: "Sign out",
      onClick: e
    }
  ];
  return /* @__PURE__ */ g.jsx(
    Eo,
    {
      sx: { backgroundColor: _t.darkGrey, color: "#fff" },
      brandLogo: s,
      rightContent: /* @__PURE__ */ g.jsxs(
        Te,
        {
          "data-testid": "gate-header",
          sx: { display: "flex", alignItems: "center", gap: 1.5 },
          children: [
            /* @__PURE__ */ g.jsx(xu, { accountOrgsUrl: r }),
            o && /* @__PURE__ */ g.jsx(
              xn,
              {
                "data-testid": "gate-active-org-name",
                variant: "body2",
                sx: { color: "inherit", opacity: 0.9, whiteSpace: "nowrap" },
                children: o
              }
            ),
            /* @__PURE__ */ g.jsx(Ru, {}),
            /* @__PURE__ */ g.jsx(To, { menuItems: u })
          ]
        }
      )
    }
  );
}
const Ji = "common-fe.mockAuth", Zi = An(null), Iu = {
  email: "jaybill@foxvillage.com",
  displayName: "Jaybill"
};
function _u() {
  try {
    const e = localStorage.getItem(Ji);
    return e ? JSON.parse(e) : { signedIn: !1, user: null };
  } catch {
    return { signedIn: !1, user: null };
  }
}
function Tu(e) {
  try {
    localStorage.setItem(Ji, JSON.stringify(e));
  } catch {
  }
}
function rh({ children: e, defaultUser: s = Iu }) {
  const [r, i] = q(_u);
  Ie(() => {
    Tu(r);
  }, [r]);
  const n = ut(
    (o) => {
      i({ signedIn: !0, user: o ?? s });
    },
    [s]
  ), t = ut(() => {
    i({ signedIn: !1, user: null });
  }, []), a = $t(
    () => ({
      isAuthenticated: r.signedIn,
      user: r.user,
      signIn: n,
      signOut: t
    }),
    [r, n, t]
  );
  return /* @__PURE__ */ g.jsx(Zi.Provider, { value: a, children: e });
}
function Yi() {
  const e = Pn(Zi);
  if (!e)
    throw new Error("useMockAuth must be used within a MockAuthProvider");
  return e;
}
function sh({ children: e, loginPath: s = "/login" }) {
  const { isAuthenticated: r } = Yi(), i = go();
  return r ? e : /* @__PURE__ */ g.jsx(Ci, { to: s, replace: !0, state: { from: i.pathname } });
}
const Cu = "jaybill@foxvillage.com", Eu = "demo-password", Ou = {
  heading: "Sign in",
  subheading: "Sign in to your account.",
  emailLabel: "Email address",
  passwordLabel: "Password",
  showPassword: "Show password",
  forgotPassword: "Forgot your password?",
  submit: "Sign in",
  newUserPrompt: "New user?",
  createAccount: "Create an account"
};
function ih({
  onSignIn: e,
  brandLogo: s,
  labels: r = {}
}) {
  const { signIn: i } = Yi(), [n, t] = q(Cu), [a, o] = q(Eu), [u, l] = q(!1), c = { ...Ou, ...r }, d = (m) => {
    m.preventDefault();
    const j = { email: n, displayName: n.split("@")[0] };
    e ? e(j) : i(j);
  }, h = s ?? xi;
  return /* @__PURE__ */ g.jsx(
    ae,
    {
      sx: {
        minHeight: "100vh",
        width: "100%",
        bgcolor: (m) => m.palette.mode === "dark" ? "#2a2a2a" : "grey.100",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2
      },
      children: /* @__PURE__ */ g.jsxs(
        tr,
        {
          elevation: 6,
          sx: {
            width: "100%",
            maxWidth: 480,
            p: { xs: 3, sm: 5 },
            bgcolor: (m) => m.palette.mode === "dark" ? "#000" : "background.paper",
            color: (m) => m.palette.mode === "dark" ? "#fff" : "text.primary",
            borderRadius: 3
          },
          children: [
            /* @__PURE__ */ g.jsx(
              ae,
              {
                sx: {
                  display: "flex",
                  justifyContent: "center",
                  mb: 4,
                  color: "inherit"
                },
                children: /* @__PURE__ */ g.jsx(h, { style: { width: 240, height: "auto" } })
              }
            ),
            /* @__PURE__ */ g.jsx(ze, { variant: "h4", component: "h1", fontWeight: 700, gutterBottom: !0, children: c.heading }),
            /* @__PURE__ */ g.jsx(
              ze,
              {
                variant: "body1",
                sx: { opacity: 0.7, mb: 4 },
                children: c.subheading
              }
            ),
            /* @__PURE__ */ g.jsx(ae, { component: "form", onSubmit: d, children: /* @__PURE__ */ g.jsxs(qt, { spacing: 3, children: [
              /* @__PURE__ */ g.jsx(
                Wt,
                {
                  label: c.emailLabel,
                  type: "email",
                  fullWidth: !0,
                  value: n,
                  onChange: (m) => t(m.target.value),
                  InputLabelProps: {
                    sx: { fontWeight: 600 }
                  }
                }
              ),
              /* @__PURE__ */ g.jsxs(ae, { children: [
                /* @__PURE__ */ g.jsx(
                  Wt,
                  {
                    label: c.passwordLabel,
                    type: u ? "text" : "password",
                    fullWidth: !0,
                    value: a,
                    onChange: (m) => o(m.target.value),
                    InputLabelProps: {
                      sx: { fontWeight: 600 }
                    }
                  }
                ),
                /* @__PURE__ */ g.jsxs(
                  qt,
                  {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    sx: { mt: 1 },
                    children: [
                      /* @__PURE__ */ g.jsx(
                        yi,
                        {
                          control: /* @__PURE__ */ g.jsx(
                            Ri,
                            {
                              size: "small",
                              checked: u,
                              onChange: (m) => l(m.target.checked),
                              sx: { color: "inherit" }
                            }
                          ),
                          label: c.showPassword
                        }
                      ),
                      /* @__PURE__ */ g.jsx(
                        Ts,
                        {
                          component: "button",
                          type: "button",
                          underline: "hover",
                          onClick: () => {
                          },
                          sx: { color: "primary.light" },
                          children: c.forgotPassword
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ g.jsx(
                $e,
                {
                  type: "submit",
                  variant: "contained",
                  fullWidth: !0,
                  size: "large",
                  sx: { py: 1.5, fontWeight: 600 },
                  children: c.submit
                }
              ),
              /* @__PURE__ */ g.jsxs(
                ze,
                {
                  variant: "body2",
                  align: "center",
                  sx: { opacity: 0.8 },
                  children: [
                    c.newUserPrompt,
                    " ",
                    /* @__PURE__ */ g.jsx(
                      Ts,
                      {
                        component: "button",
                        type: "button",
                        underline: "hover",
                        onClick: () => {
                        },
                        sx: { color: "primary.light" },
                        children: c.createAccount
                      }
                    )
                  ]
                }
              )
            ] }) })
          ]
        }
      )
    }
  );
}
var Gr = { d: (e, s) => {
  for (var r in s) Gr.o(s, r) && !Gr.o(e, r) && Object.defineProperty(e, r, { enumerable: !0, get: s[r] });
}, o: (e, s) => Object.prototype.hasOwnProperty.call(e, s) };
const le = (Fs = { default: () => Pi.default }, Cr = {}, Gr.d(Cr, Fs), Cr);
var Fs, Cr;
function Ki(e, s) {
  if (!(e instanceof s)) throw new TypeError("Cannot call a class as a function");
}
function Hr(e, s, r) {
  return Hr = os() ? Reflect.construct : function(i, n, t) {
    var a = [null];
    a.push.apply(a, n);
    var o = new (Function.bind.apply(i, a))();
    return t && Tn(o, t.prototype), o;
  }, Hr.apply(null, arguments);
}
function Qn(e, s, r) {
  return s in e ? Object.defineProperty(e, s, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[s] = r, e;
}
function _n(e) {
  return _n = Object.setPrototypeOf ? Object.getPrototypeOf : function(s) {
    return s.__proto__ || Object.getPrototypeOf(s);
  }, _n(e);
}
function Tn(e, s) {
  return Tn = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Tn(e, s);
}
function zr(e) {
  var s = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return zr = function(r) {
    if (r === null || (i = r, Function.toString.call(i).indexOf("[native code]") === -1)) return r;
    var i;
    if (typeof r != "function") throw new TypeError("Super expression must either be null or a function");
    if (s !== void 0) {
      if (s.has(r)) return s.get(r);
      s.set(r, n);
    }
    function n() {
      return Hr(r, arguments, _n(this).constructor);
    }
    return n.prototype = Object.create(r.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), Tn(n, r);
  }, zr(e);
}
function os() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (os = function() {
    return !!e;
  })();
}
var ce = "http://localhost".replace(/\/+$/, ""), Xt = function e(s) {
  var r, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ce, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : le.default;
  Ki(this, e), Qn(this, "basePath", void 0), Qn(this, "axios", void 0), Qn(this, "configuration", void 0), this.basePath = i, this.axios = n, s && (this.configuration = s, this.basePath = (r = s.basePath) !== null && r !== void 0 ? r : i);
}, ku = function() {
  function e(s, r) {
    var i;
    return Ki(this, e), Qn(i = function(n, t, a) {
      return t = _n(t), o = n, !(u = os() ? Reflect.construct(t, a || [], _n(n).constructor) : t.apply(n, a)) || ((l = u) && typeof Symbol < "u" && l.constructor === Symbol ? "symbol" : typeof l) != "object" && typeof u != "function" ? function(c) {
        if (c === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return c;
      }(o) : u;
      var o, u, l;
    }(this, e, [r]), "field", void 0), i.field = s, i.name = "RequiredError", i;
  }
  return function(s, r) {
    if (typeof r != "function" && r !== null) throw new TypeError("Super expression must either be null or a function");
    s.prototype = Object.create(r && r.prototype, { constructor: { value: s, writable: !0, configurable: !0 } }), r && Tn(s, r);
  }(e, zr(Error)), e;
}(), fe = {};
function Ms(e, s, r, i, n, t, a) {
  try {
    var o = e[t](a), u = o.value;
  } catch (l) {
    return void r(l);
  }
  o.done ? s(u) : Promise.resolve(u).then(i, n);
}
function Au(e, s, r) {
  return s in e ? Object.defineProperty(e, s, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[s] = r, e;
}
var pe = "https://example.com", ie = function(e, s, r) {
  if (r == null) throw new ku(s, "Required parameter ".concat(s, " was null or undefined when calling ").concat(e, "."));
}, xe = function(e, s) {
  return (r = function() {
    var i, n;
    return function(t, a) {
      var o, u, l, c = { label: 0, sent: function() {
        if (1 & l[0]) throw l[1];
        return l[1];
      }, trys: [], ops: [] }, d = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
      return d.next = h(0), d.throw = h(1), d.return = h(2), typeof Symbol == "function" && (d[Symbol.iterator] = function() {
        return this;
      }), d;
      function h(m) {
        return function(j) {
          return function(E) {
            if (o) throw new TypeError("Generator is already executing.");
            for (; d && (d = 0, E[0] && (c = 0)), c; ) try {
              if (o = 1, u && (l = 2 & E[0] ? u.return : E[0] ? u.throw || ((l = u.return) && l.call(u), 0) : u.next) && !(l = l.call(u, E[1])).done) return l;
              switch (u = 0, l && (E = [2 & E[0], l.value]), E[0]) {
                case 0:
                case 1:
                  l = E;
                  break;
                case 4:
                  return c.label++, { value: E[1], done: !1 };
                case 5:
                  c.label++, u = E[1], E = [0];
                  continue;
                case 7:
                  E = c.ops.pop(), c.trys.pop();
                  continue;
                default:
                  if (!((l = (l = c.trys).length > 0 && l[l.length - 1]) || E[0] !== 6 && E[0] !== 2)) {
                    c = 0;
                    continue;
                  }
                  if (E[0] === 3 && (!l || E[1] > l[0] && E[1] < l[3])) {
                    c.label = E[1];
                    break;
                  }
                  if (E[0] === 6 && c.label < l[1]) {
                    c.label = l[1], l = E;
                    break;
                  }
                  if (l && c.label < l[2]) {
                    c.label = l[2], c.ops.push(E);
                    break;
                  }
                  l[2] && c.ops.pop(), c.trys.pop();
                  continue;
              }
              E = a.call(t, c);
            } catch (M) {
              E = [6, M], u = 0;
            } finally {
              o = l = 0;
            }
            if (5 & E[0]) throw E[1];
            return { value: E[0] ? E[1] : void 0, done: !0 };
          }([m, j]);
        };
      }
    }(this, function(t) {
      switch (t.label) {
        case 0:
          return s && s.accessToken ? typeof s.accessToken != "function" ? [3, 2] : [4, s.accessToken()] : [3, 5];
        case 1:
          return n = t.sent(), [3, 4];
        case 2:
          return [4, s.accessToken];
        case 3:
          n = t.sent(), t.label = 4;
        case 4:
          i = n, e.Authorization = "Bearer " + i, t.label = 5;
        case 5:
          return [2];
      }
    });
  }, function() {
    var i = this, n = arguments;
    return new Promise(function(t, a) {
      var o = r.apply(i, n);
      function u(c) {
        Ms(o, t, a, u, l, "next", c);
      }
      function l(c) {
        Ms(o, t, a, u, l, "throw", c);
      }
      u(void 0);
    });
  })();
  var r;
};
function $r(e, s) {
  var r, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  s != null && ((s === void 0 ? "undefined" : (r = s) && typeof Symbol < "u" && r.constructor === Symbol ? "symbol" : typeof r) == "object" ? Array.isArray(s) ? s.forEach(function(n) {
    return $r(e, n, i);
  }) : Object.keys(s).forEach(function(n) {
    return $r(e, s[n], "".concat(i).concat(i !== "" ? "." : "").concat(n));
  }) : e.has(i) ? e.append(i, s) : e.set(i, s));
}
var ve = function(e) {
  for (var s = arguments.length, r = new Array(s > 1 ? s - 1 : 0), i = 1; i < s; i++) r[i - 1] = arguments[i];
  var n = new URLSearchParams(e.search);
  $r(n, r), e.search = n.toString();
}, at = function(e, s, r) {
  var i = typeof e != "string";
  return (i && r && r.isJsonMime ? r.isJsonMime(s.headers["Content-Type"]) : i) ? JSON.stringify(e !== void 0 ? e : {}) : e || "";
}, ge = function(e) {
  return e.pathname + e.search + e.hash;
}, me = function(e, s, r, i) {
  return function() {
    var n, t, a, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : s, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : r, l = (t = function(c) {
      for (var d = 1; d < arguments.length; d++) {
        var h = arguments[d] != null ? arguments[d] : {}, m = Object.keys(h);
        typeof Object.getOwnPropertySymbols == "function" && (m = m.concat(Object.getOwnPropertySymbols(h).filter(function(j) {
          return Object.getOwnPropertyDescriptor(h, j).enumerable;
        }))), m.forEach(function(j) {
          Au(c, j, h[j]);
        });
      }
      return c;
    }({}, e.options), a = (a = { url: (o.defaults.baseURL ? "" : (n = i == null ? void 0 : i.basePath) !== null && n !== void 0 ? n : u) + e.url }) != null ? a : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : function(c) {
      var d = Object.keys(c);
      if (Object.getOwnPropertySymbols) {
        var h = Object.getOwnPropertySymbols(c);
        d.push.apply(d, h);
      }
      return d;
    }(Object(a)).forEach(function(c) {
      Object.defineProperty(t, c, Object.getOwnPropertyDescriptor(a, c));
    }), t);
    return o.request(l);
  };
};
function Vs(e, s, r, i, n, t, a) {
  try {
    var o = e[t](a), u = o.value;
  } catch (l) {
    return void r(l);
  }
  o.done ? s(u) : Promise.resolve(u).then(i, n);
}
function z(e) {
  return function() {
    var s = this, r = arguments;
    return new Promise(function(i, n) {
      var t = e.apply(s, r);
      function a(u) {
        Vs(t, i, n, a, o, "next", u);
      }
      function o(u) {
        Vs(t, i, n, a, o, "throw", u);
      }
      a(void 0);
    });
  };
}
function en(e, s, r) {
  return s = ar(s), i = e, !(n = Qi() ? Reflect.construct(s, r || [], ar(e).constructor) : s.apply(e, r)) || ((t = n) && typeof Symbol < "u" && t.constructor === Symbol ? "symbol" : typeof t) != "object" && typeof n != "function" ? function(a) {
    if (a === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return a;
  }(i) : n;
  var i, n, t;
}
function tn(e, s) {
  if (!(e instanceof s)) throw new TypeError("Cannot call a class as a function");
}
function Pu(e, s) {
  for (var r = 0; r < s.length; r++) {
    var i = s[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function nn(e, s, r) {
  return s && Pu(e.prototype, s), e;
}
function ju(e, s, r) {
  return s in e ? Object.defineProperty(e, s, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[s] = r, e;
}
function ar(e) {
  return ar = Object.setPrototypeOf ? Object.getPrototypeOf : function(s) {
    return s.__proto__ || Object.getPrototypeOf(s);
  }, ar(e);
}
function rn(e, s) {
  if (typeof s != "function" && s !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(s && s.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), s && Br(e, s);
}
function G(e) {
  for (var s = 1; s < arguments.length; s++) {
    var r = arguments[s] != null ? arguments[s] : {}, i = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (i = i.concat(Object.getOwnPropertySymbols(r).filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    }))), i.forEach(function(n) {
      ju(e, n, r[n]);
    });
  }
  return e;
}
function Br(e, s) {
  return Br = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Br(e, s);
}
function Qi() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Qi = function() {
    return !!e;
  })();
}
function $(e, s) {
  var r, i, n, t = { label: 0, sent: function() {
    if (1 & n[0]) throw n[1];
    return n[1];
  }, trys: [], ops: [] }, a = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return a.next = o(0), a.throw = o(1), a.return = o(2), typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function o(u) {
    return function(l) {
      return function(c) {
        if (r) throw new TypeError("Generator is already executing.");
        for (; a && (a = 0, c[0] && (t = 0)), t; ) try {
          if (r = 1, i && (n = 2 & c[0] ? i.return : c[0] ? i.throw || ((n = i.return) && n.call(i), 0) : i.next) && !(n = n.call(i, c[1])).done) return n;
          switch (i = 0, n && (c = [2 & c[0], n.value]), c[0]) {
            case 0:
            case 1:
              n = c;
              break;
            case 4:
              return t.label++, { value: c[1], done: !1 };
            case 5:
              t.label++, i = c[1], c = [0];
              continue;
            case 7:
              c = t.ops.pop(), t.trys.pop();
              continue;
            default:
              if (!((n = (n = t.trys).length > 0 && n[n.length - 1]) || c[0] !== 6 && c[0] !== 2)) {
                t = 0;
                continue;
              }
              if (c[0] === 3 && (!n || c[1] > n[0] && c[1] < n[3])) {
                t.label = c[1];
                break;
              }
              if (c[0] === 6 && t.label < n[1]) {
                t.label = n[1], n = c;
                break;
              }
              if (n && t.label < n[2]) {
                t.label = n[2], t.ops.push(c);
                break;
              }
              n[2] && t.ops.pop(), t.trys.pop();
              continue;
          }
          c = s.call(e, t);
        } catch (d) {
          c = [6, d], i = 0;
        } finally {
          r = n = 0;
        }
        if (5 & c[0]) throw c[1];
        return { value: c[0] ? c[1] : void 0, done: !0 };
      }([u, l]);
    };
  }
}
var Uu = function(e) {
  return { publicScoreSheetsConfigGet: function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return z(function() {
      var r, i, n, t, a;
      return $(this, function(o) {
        return r = new URL("/public/score-sheets/config", pe), e && (i = e.baseOptions), n = G({ method: "GET" }, i, s), t = {}, ve(r, {}), a = i && i.headers ? i.headers : {}, n.headers = G({}, t, a, s.headers), [2, { url: ge(r), options: n }];
      });
    })();
  }, publicScoreSheetsRequestPost: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, n, t, a, o, u;
      return $(this, function(l) {
        return ie("publicScoreSheetsRequestPost", "publicScoreSheetsRequestPostRequest", s), i = new URL("/public/score-sheets/request", pe), e && (n = e.baseOptions), t = G({ method: "POST" }, n, r), o = {}, (a = {})["Content-Type"] = "application/json", ve(i, o), u = n && n.headers ? n.headers : {}, t.headers = G({}, a, u, r.headers), t.data = at(s, t, e), [2, { url: ge(i), options: t }];
      });
    })();
  }, publicScoreSheetsTokenGet: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, n, t, a, o, u;
      return $(this, function(l) {
        return ie("publicScoreSheetsTokenGet", "token", s), i = "/public/score-sheets/{token}".replace("{token}", encodeURIComponent(String(s))), n = new URL(i, pe), e && (t = e.baseOptions), a = G({ method: "GET" }, t, r), o = {}, ve(n, {}), u = t && t.headers ? t.headers : {}, a.headers = G({}, o, u, r.headers), [2, { url: ge(n), options: a }];
      });
    })();
  }, publicSheetsRequestIdRideIdVariantUrlGet: function(s, r, i) {
    var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return z(function() {
      var t, a, o, u, l, c;
      return $(this, function(d) {
        return ie("publicSheetsRequestIdRideIdVariantUrlGet", "requestId", s), ie("publicSheetsRequestIdRideIdVariantUrlGet", "rideId", r), ie("publicSheetsRequestIdRideIdVariantUrlGet", "variant", i), t = "/public/sheets/{requestId}/{rideId}/{variant}/url".replace("{requestId}", encodeURIComponent(String(s))).replace("{rideId}", encodeURIComponent(String(r))).replace("{variant}", encodeURIComponent(String(i))), a = new URL(t, pe), e && (o = e.baseOptions), u = G({ method: "GET" }, o, n), l = {}, ve(a, {}), c = o && o.headers ? o.headers : {}, u.headers = G({}, l, c, n.headers), [2, { url: ge(a), options: u }];
      });
    })();
  } };
}, Hn = function(e) {
  var s = Uu(e);
  return { publicScoreSheetsConfigGet: function(r) {
    return z(function() {
      var i, n, t, a, o, u;
      return $(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, s.publicScoreSheetsConfigGet(r)];
          case 1:
            return t = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (n = fe["DefaultApi.publicScoreSheetsConfigGet"]) === null || n === void 0 || (i = n[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return me(t, le.default, ce, e)(c, u || d);
            }];
        }
      });
    })();
  }, publicScoreSheetsRequestPost: function(r, i) {
    return z(function() {
      var n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.publicScoreSheetsRequestPost(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = fe["DefaultApi.publicScoreSheetsRequestPost"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, publicScoreSheetsTokenGet: function(r, i) {
    return z(function() {
      var n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.publicScoreSheetsTokenGet(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = fe["DefaultApi.publicScoreSheetsTokenGet"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, publicSheetsRequestIdRideIdVariantUrlGet: function(r, i, n, t) {
    return z(function() {
      var a, o, u, l, c, d;
      return $(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, s.publicSheetsRequestIdRideIdVariantUrlGet(r, i, n, t)];
          case 1:
            return u = h.sent(), c = (l = e == null ? void 0 : e.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = fe["DefaultApi.publicSheetsRequestIdRideIdVariantUrlGet"]) === null || o === void 0 || (a = o[c]) === null || a === void 0 ? void 0 : a.url, [2, function(m, j) {
              return me(u, le.default, ce, e)(m, d || j);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return tn(this, s), en(this, s, arguments);
  }
  return rn(s, e), nn(s, [{ key: "publicScoreSheetsConfigGet", value: function(r) {
    var i = this;
    return Hn(this.configuration).publicScoreSheetsConfigGet(r).then(function(n) {
      return n(i.axios, i.basePath);
    });
  } }, { key: "publicScoreSheetsRequestPost", value: function(r, i) {
    var n = this;
    return Hn(this.configuration).publicScoreSheetsRequestPost(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "publicScoreSheetsTokenGet", value: function(r, i) {
    var n = this;
    return Hn(this.configuration).publicScoreSheetsTokenGet(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "publicSheetsRequestIdRideIdVariantUrlGet", value: function(r, i, n, t) {
    var a = this;
    return Hn(this.configuration).publicSheetsRequestIdRideIdVariantUrlGet(r, i, n, t).then(function(o) {
      return o(a.axios, a.basePath);
    });
  } }]), s;
})(Xt);
var Nu = function(e) {
  return { correctUsefClass: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var n, t, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return ie("correctUsefClass", "classId", s), ie("correctUsefClass", "uploadUsefClassRequest", r), n = "/federation/usef/classes/{classId}/correct".replace("{classId}", encodeURIComponent(String(s))), t = new URL(n, pe), e && (a = e.baseOptions), o = G({ method: "POST" }, a, i), l = {}, [4, xe(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ve(t, l), c = a && a.headers ? a.headers : {}, o.headers = G({}, u, c, i.headers), o.data = at(r, o, e), [2, { url: ge(t), options: o }];
        }
      });
    })();
  }, deleteUsefClass: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var n, t, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return ie("deleteUsefClass", "classId", s), ie("deleteUsefClass", "deleteUsefClassRequest", r), n = "/federation/usef/classes/{classId}/delete".replace("{classId}", encodeURIComponent(String(s))), t = new URL(n, pe), e && (a = e.baseOptions), o = G({ method: "POST" }, a, i), l = {}, [4, xe(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ve(t, l), c = a && a.headers ? a.headers : {}, o.headers = G({}, u, c, i.headers), o.data = at(r, o, e), [2, { url: ge(t), options: o }];
        }
      });
    })();
  }, finalizeUsefClass: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var n, t, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return ie("finalizeUsefClass", "classId", s), ie("finalizeUsefClass", "deleteUsefClassRequest", r), n = "/federation/usef/classes/{classId}/finalize".replace("{classId}", encodeURIComponent(String(s))), t = new URL(n, pe), e && (a = e.baseOptions), o = G({ method: "POST" }, a, i), l = {}, [4, xe(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ve(t, l), c = a && a.headers ? a.headers : {}, o.headers = G({}, u, c, i.headers), o.data = at(r, o, e), [2, { url: ge(t), options: o }];
        }
      });
    })();
  }, getFederationClassAudit: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return ie("getFederationClassAudit", "classId", s), i = "/federation/classes/{classId}/audit".replace("{classId}", encodeURIComponent(String(s))), n = new URL(i, pe), e && (t = e.baseOptions), a = G({ method: "GET" }, t, r), u = {}, [4, xe(o = {}, e)];
          case 1:
            return c.sent(), ve(n, u), l = t && t.headers ? t.headers : {}, a.headers = G({}, o, l, r.headers), [2, { url: ge(n), options: a }];
        }
      });
    })();
  }, getFederationShowAudit: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return ie("getFederationShowAudit", "showId", s), i = "/federation/shows/{showId}/audit".replace("{showId}", encodeURIComponent(String(s))), n = new URL(i, pe), e && (t = e.baseOptions), a = G({ method: "GET" }, t, r), u = {}, [4, xe(o = {}, e)];
          case 1:
            return c.sent(), ve(n, u), l = t && t.headers ? t.headers : {}, a.headers = G({}, o, l, r.headers), [2, { url: ge(n), options: a }];
        }
      });
    })();
  }, getFederationShowState: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return ie("getFederationShowState", "showId", s), i = "/federation/shows/{showId}/state".replace("{showId}", encodeURIComponent(String(s))), n = new URL(i, pe), e && (t = e.baseOptions), a = G({ method: "GET" }, t, r), u = {}, [4, xe(o = {}, e)];
          case 1:
            return c.sent(), ve(n, u), l = t && t.headers ? t.headers : {}, a.headers = G({}, o, l, r.headers), [2, { url: ge(n), options: a }];
        }
      });
    })();
  }, getUsefDeadlineStatus: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return ie("getUsefDeadlineStatus", "competitionEndDate", s), n = new URL("/federation/usef/deadline", pe), e && (t = e.baseOptions), a = G({ method: "GET" }, t, i), u = {}, [4, xe(o = {}, e)];
          case 1:
            return c.sent(), s !== void 0 && (u.competitionEndDate = s), r !== void 0 && (u.showId = r), ve(n, u), l = t && t.headers ? t.headers : {}, a.headers = G({}, o, l, i.headers), [2, { url: ge(n), options: a }];
        }
      });
    })();
  }, listUsefDressageSections: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, n, t, a, o, u;
      return $(this, function(l) {
        switch (l.label) {
          case 0:
            return ie("listUsefDressageSections", "compYear", s), i = new URL("/federation/usef/sections", pe), e && (n = e.baseOptions), t = G({ method: "GET" }, n, r), o = {}, [4, xe(a = {}, e)];
          case 1:
            return l.sent(), s !== void 0 && (o.compYear = s), ve(i, o), u = n && n.headers ? n.headers : {}, t.headers = G({}, a, u, r.headers), [2, { url: ge(i), options: t }];
        }
      });
    })();
  }, listUsefDressageTests: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, n, t, a, o, u;
      return $(this, function(l) {
        switch (l.label) {
          case 0:
            return ie("listUsefDressageTests", "testYear", s), i = new URL("/federation/usef/tests", pe), e && (n = e.baseOptions), t = G({ method: "GET" }, n, r), o = {}, [4, xe(a = {}, e)];
          case 1:
            return l.sent(), s !== void 0 && (o.testYear = s), ve(i, o), u = n && n.headers ? n.headers : {}, t.headers = G({}, a, u, r.headers), [2, { url: ge(i), options: t }];
        }
      });
    })();
  }, markClassForRepublish: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var n, t, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return ie("markClassForRepublish", "classId", s), ie("markClassForRepublish", "markClassForRepublishRequest", r), n = "/federation/usef/classes/{classId}/mark-for-republish".replace("{classId}", encodeURIComponent(String(s))), t = new URL(n, pe), e && (a = e.baseOptions), o = G({ method: "POST" }, a, i), l = {}, [4, xe(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ve(t, l), c = a && a.headers ? a.headers : {}, o.headers = G({}, u, c, i.headers), o.data = at(r, o, e), [2, { url: ge(t), options: o }];
        }
      });
    })();
  }, previewClassResult: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return ie("previewClassResult", "classId", s), i = "/federation/classes/{classId}/preview".replace("{classId}", encodeURIComponent(String(s))), n = new URL(i, pe), e && (t = e.baseOptions), a = G({ method: "GET" }, t, r), u = {}, [4, xe(o = {}, e)];
          case 1:
            return c.sent(), ve(n, u), l = t && t.headers ? t.headers : {}, a.headers = G({}, o, l, r.headers), [2, { url: ge(n), options: a }];
        }
      });
    })();
  }, previewShowResults: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return ie("previewShowResults", "showId", s), i = "/federation/shows/{showId}/preview".replace("{showId}", encodeURIComponent(String(s))), n = new URL(i, pe), e && (t = e.baseOptions), a = G({ method: "GET" }, t, r), u = {}, [4, xe(o = {}, e)];
          case 1:
            return c.sent(), ve(n, u), l = t && t.headers ? t.headers : {}, a.headers = G({}, o, l, r.headers), [2, { url: ge(n), options: a }];
        }
      });
    })();
  }, publishUsdfShow: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var n, t, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return ie("publishUsdfShow", "showId", s), n = "/federation/usdf/shows/{showId}/publish".replace("{showId}", encodeURIComponent(String(s))), t = new URL(n, pe), e && (a = e.baseOptions), o = G({ method: "POST" }, a, i), l = {}, [4, xe(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ve(t, l), c = a && a.headers ? a.headers : {}, o.headers = G({}, u, c, i.headers), o.data = at(r, o, e), [2, { url: ge(t), options: o }];
        }
      });
    })();
  }, publishUsefShow: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var n, t, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return ie("publishUsefShow", "showId", s), ie("publishUsefShow", "publishUsefShowRequest", r), n = "/federation/usef/shows/{showId}/publish".replace("{showId}", encodeURIComponent(String(s))), t = new URL(n, pe), e && (a = e.baseOptions), o = G({ method: "POST" }, a, i), l = {}, [4, xe(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ve(t, l), c = a && a.headers ? a.headers : {}, o.headers = G({}, u, c, i.headers), o.data = at(r, o, e), [2, { url: ge(t), options: o }];
        }
      });
    })();
  }, submitUsefShow: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var n, t, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return ie("submitUsefShow", "showId", s), ie("submitUsefShow", "submitUsefShowRequest", r), n = "/federation/usef/shows/{showId}/submit".replace("{showId}", encodeURIComponent(String(s))), t = new URL(n, pe), e && (a = e.baseOptions), o = G({ method: "POST" }, a, i), l = {}, [4, xe(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ve(t, l), c = a && a.headers ? a.headers : {}, o.headers = G({}, u, c, i.headers), o.data = at(r, o, e), [2, { url: ge(t), options: o }];
        }
      });
    })();
  }, uploadUsefClass: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var n, t, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return ie("uploadUsefClass", "classId", s), ie("uploadUsefClass", "uploadUsefClassRequest", r), n = "/federation/usef/classes/{classId}/upload".replace("{classId}", encodeURIComponent(String(s))), t = new URL(n, pe), e && (a = e.baseOptions), o = G({ method: "POST" }, a, i), l = {}, [4, xe(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ve(t, l), c = a && a.headers ? a.headers : {}, o.headers = G({}, u, c, i.headers), o.data = at(r, o, e), [2, { url: ge(t), options: o }];
        }
      });
    })();
  } };
}, Be = function(e) {
  var s = Nu(e);
  return { correctUsefClass: function(r, i, n) {
    return z(function() {
      var t, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.correctUsefClass(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["FederationApi.correctUsefClass"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  }, deleteUsefClass: function(r, i, n) {
    return z(function() {
      var t, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.deleteUsefClass(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["FederationApi.deleteUsefClass"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  }, finalizeUsefClass: function(r, i, n) {
    return z(function() {
      var t, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.finalizeUsefClass(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["FederationApi.finalizeUsefClass"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  }, getFederationClassAudit: function(r, i) {
    return z(function() {
      var n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getFederationClassAudit(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = fe["FederationApi.getFederationClassAudit"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, getFederationShowAudit: function(r, i) {
    return z(function() {
      var n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getFederationShowAudit(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = fe["FederationApi.getFederationShowAudit"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, getFederationShowState: function(r, i) {
    return z(function() {
      var n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getFederationShowState(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = fe["FederationApi.getFederationShowState"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, getUsefDeadlineStatus: function(r, i, n) {
    return z(function() {
      var t, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.getUsefDeadlineStatus(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["FederationApi.getUsefDeadlineStatus"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  }, listUsefDressageSections: function(r, i) {
    return z(function() {
      var n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.listUsefDressageSections(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = fe["FederationApi.listUsefDressageSections"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, listUsefDressageTests: function(r, i) {
    return z(function() {
      var n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.listUsefDressageTests(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = fe["FederationApi.listUsefDressageTests"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, markClassForRepublish: function(r, i, n) {
    return z(function() {
      var t, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.markClassForRepublish(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["FederationApi.markClassForRepublish"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  }, previewClassResult: function(r, i) {
    return z(function() {
      var n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.previewClassResult(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = fe["FederationApi.previewClassResult"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, previewShowResults: function(r, i) {
    return z(function() {
      var n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.previewShowResults(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = fe["FederationApi.previewShowResults"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, publishUsdfShow: function(r, i, n) {
    return z(function() {
      var t, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.publishUsdfShow(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["FederationApi.publishUsdfShow"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  }, publishUsefShow: function(r, i, n) {
    return z(function() {
      var t, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.publishUsefShow(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["FederationApi.publishUsefShow"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  }, submitUsefShow: function(r, i, n) {
    return z(function() {
      var t, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.submitUsefShow(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["FederationApi.submitUsefShow"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  }, uploadUsefClass: function(r, i, n) {
    return z(function() {
      var t, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.uploadUsefClass(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["FederationApi.uploadUsefClass"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return tn(this, s), en(this, s, arguments);
  }
  return rn(s, e), nn(s, [{ key: "correctUsefClass", value: function(r, i, n) {
    var t = this;
    return Be(this.configuration).correctUsefClass(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "deleteUsefClass", value: function(r, i, n) {
    var t = this;
    return Be(this.configuration).deleteUsefClass(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "finalizeUsefClass", value: function(r, i, n) {
    var t = this;
    return Be(this.configuration).finalizeUsefClass(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "getFederationClassAudit", value: function(r, i) {
    var n = this;
    return Be(this.configuration).getFederationClassAudit(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "getFederationShowAudit", value: function(r, i) {
    var n = this;
    return Be(this.configuration).getFederationShowAudit(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "getFederationShowState", value: function(r, i) {
    var n = this;
    return Be(this.configuration).getFederationShowState(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "getUsefDeadlineStatus", value: function(r, i, n) {
    var t = this;
    return Be(this.configuration).getUsefDeadlineStatus(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "listUsefDressageSections", value: function(r, i) {
    var n = this;
    return Be(this.configuration).listUsefDressageSections(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "listUsefDressageTests", value: function(r, i) {
    var n = this;
    return Be(this.configuration).listUsefDressageTests(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "markClassForRepublish", value: function(r, i, n) {
    var t = this;
    return Be(this.configuration).markClassForRepublish(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "previewClassResult", value: function(r, i) {
    var n = this;
    return Be(this.configuration).previewClassResult(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "previewShowResults", value: function(r, i) {
    var n = this;
    return Be(this.configuration).previewShowResults(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "publishUsdfShow", value: function(r, i, n) {
    var t = this;
    return Be(this.configuration).publishUsdfShow(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "publishUsefShow", value: function(r, i, n) {
    var t = this;
    return Be(this.configuration).publishUsefShow(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "submitUsefShow", value: function(r, i, n) {
    var t = this;
    return Be(this.configuration).submitUsefShow(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "uploadUsefClass", value: function(r, i, n) {
    var t = this;
    return Be(this.configuration).uploadUsefClass(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }]), s;
})(Xt);
var Lu = function(e) {
  return { getHealth: function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return z(function() {
      var r, i, n, t, a;
      return $(this, function(o) {
        return r = new URL("/health", pe), e && (i = e.baseOptions), n = G({ method: "GET" }, i, s), t = {}, ve(r, {}), a = i && i.headers ? i.headers : {}, n.headers = G({}, t, a, s.headers), [2, { url: ge(r), options: n }];
      });
    })();
  } };
}, Du = function(e) {
  var s = Lu(e);
  return { getHealth: function(r) {
    return z(function() {
      var i, n, t, a, o, u;
      return $(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, s.getHealth(r)];
          case 1:
            return t = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (n = fe["HealthApi.getHealth"]) === null || n === void 0 || (i = n[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return me(t, le.default, ce, e)(c, u || d);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return tn(this, s), en(this, s, arguments);
  }
  return rn(s, e), nn(s, [{ key: "getHealth", value: function(r) {
    var i = this;
    return Du(this.configuration).getHealth(r).then(function(n) {
      return n(i.axios, i.basePath);
    });
  } }]), s;
})(Xt);
var Fu = function(e) {
  return { createReportRun: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var n, t, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return ie("createReportRun", "id", s), n = "/reports/{id}/runs".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, pe), e && (a = e.baseOptions), o = G({ method: "POST" }, a, i), l = {}, [4, xe(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ve(t, l), c = a && a.headers ? a.headers : {}, o.headers = G({}, u, c, i.headers), o.data = at(r, o, e), [2, { url: ge(t), options: o }];
        }
      });
    })();
  }, listReports: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, n, t, a, o, u;
      return $(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/reports", pe), e && (n = e.baseOptions), t = G({ method: "GET" }, n, r), o = {}, [4, xe(a = {}, e)];
          case 1:
            return l.sent(), s !== void 0 && (o.domain = s), ve(i, o), u = n && n.headers ? n.headers : {}, t.headers = G({}, a, u, r.headers), [2, { url: ge(i), options: t }];
        }
      });
    })();
  } };
}, Gs = function(e) {
  var s = Fu(e);
  return { createReportRun: function(r, i, n) {
    return z(function() {
      var t, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.createReportRun(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["ReportsApi.createReportRun"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  }, listReports: function(r, i) {
    return z(function() {
      var n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.listReports(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = fe["ReportsApi.listReports"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  } };
}, Mu = function(e) {
  function s() {
    return tn(this, s), en(this, s, arguments);
  }
  return rn(s, e), nn(s, [{ key: "createReportRun", value: function(r, i, n) {
    var t = this;
    return Gs(this.configuration).createReportRun(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "listReports", value: function(r, i) {
    var n = this;
    return Gs(this.configuration).listReports(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }]), s;
}(Xt), Vu = function(e) {
  return { getScorePageLink: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return ie("getScorePageLink", "rideId", s), i = "/score-sheets/rides/{rideId}/link".replace("{rideId}", encodeURIComponent(String(s))), n = new URL(i, pe), e && (t = e.baseOptions), a = G({ method: "GET" }, t, r), u = {}, [4, xe(o = {}, e)];
          case 1:
            return c.sent(), ve(n, u), l = t && t.headers ? t.headers : {}, a.headers = G({}, o, l, r.headers), [2, { url: ge(n), options: a }];
        }
      });
    })();
  }, getScoreSheetStatus: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return ie("getScoreSheetStatus", "rideId", s), i = "/score-sheets/rides/{rideId}/status".replace("{rideId}", encodeURIComponent(String(s))), n = new URL(i, pe), e && (t = e.baseOptions), a = G({ method: "GET" }, t, r), u = {}, [4, xe(o = {}, e)];
          case 1:
            return c.sent(), ve(n, u), l = t && t.headers ? t.headers : {}, a.headers = G({}, o, l, r.headers), [2, { url: ge(n), options: a }];
        }
      });
    })();
  }, resendScoreSheet: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var n, t, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return ie("resendScoreSheet", "rideId", s), n = "/score-sheets/rides/{rideId}/resend".replace("{rideId}", encodeURIComponent(String(s))), t = new URL(n, pe), e && (a = e.baseOptions), o = G({ method: "POST" }, a, i), l = {}, [4, xe(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ve(t, l), c = a && a.headers ? a.headers : {}, o.headers = G({}, u, c, i.headers), o.data = at(r, o, e), [2, { url: ge(t), options: o }];
        }
      });
    })();
  } };
}, Er = function(e) {
  var s = Vu(e);
  return { getScorePageLink: function(r, i) {
    return z(function() {
      var n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getScorePageLink(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = fe["RiderSheetsApi.getScorePageLink"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, getScoreSheetStatus: function(r, i) {
    return z(function() {
      var n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getScoreSheetStatus(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = fe["RiderSheetsApi.getScoreSheetStatus"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, resendScoreSheet: function(r, i, n) {
    return z(function() {
      var t, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.resendScoreSheet(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["RiderSheetsApi.resendScoreSheet"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return tn(this, s), en(this, s, arguments);
  }
  return rn(s, e), nn(s, [{ key: "getScorePageLink", value: function(r, i) {
    var n = this;
    return Er(this.configuration).getScorePageLink(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "getScoreSheetStatus", value: function(r, i) {
    var n = this;
    return Er(this.configuration).getScoreSheetStatus(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "resendScoreSheet", value: function(r, i, n) {
    var t = this;
    return Er(this.configuration).resendScoreSheet(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }]), s;
})(Xt);
var Gu = function(e) {
  return { clearRuns: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, n, t, a, o, u;
      return $(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/runs", pe), e && (n = e.baseOptions), t = G({ method: "DELETE" }, n, r), o = {}, [4, xe(a = {}, e)];
          case 1:
            return l.sent(), s !== void 0 && (o.reportId = s), ve(i, o), u = n && n.headers ? n.headers : {}, t.headers = G({}, a, u, r.headers), [2, { url: ge(i), options: t }];
        }
      });
    })();
  }, deleteRun: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return ie("deleteRun", "id", s), i = "/runs/{id}".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, pe), e && (t = e.baseOptions), a = G({ method: "DELETE" }, t, r), u = {}, [4, xe(o = {}, e)];
          case 1:
            return c.sent(), ve(n, u), l = t && t.headers ? t.headers : {}, a.headers = G({}, o, l, r.headers), [2, { url: ge(n), options: a }];
        }
      });
    })();
  }, getRun: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return ie("getRun", "id", s), i = "/runs/{id}".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, pe), e && (t = e.baseOptions), a = G({ method: "GET" }, t, r), u = {}, [4, xe(o = {}, e)];
          case 1:
            return c.sent(), ve(n, u), l = t && t.headers ? t.headers : {}, a.headers = G({}, o, l, r.headers), [2, { url: ge(n), options: a }];
        }
      });
    })();
  }, listRuns: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, n, t, a, o, u;
      return $(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/runs", pe), e && (n = e.baseOptions), t = G({ method: "GET" }, n, r), o = {}, [4, xe(a = {}, e)];
          case 1:
            return l.sent(), s !== void 0 && (o.reportId = s), ve(i, o), u = n && n.headers ? n.headers : {}, t.headers = G({}, a, u, r.headers), [2, { url: ge(i), options: t }];
        }
      });
    })();
  } };
}, zn = function(e) {
  var s = Gu(e);
  return { clearRuns: function(r, i) {
    return z(function() {
      var n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.clearRuns(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = fe["RunsApi.clearRuns"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, deleteRun: function(r, i) {
    return z(function() {
      var n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.deleteRun(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = fe["RunsApi.deleteRun"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, getRun: function(r, i) {
    return z(function() {
      var n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getRun(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = fe["RunsApi.getRun"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, listRuns: function(r, i) {
    return z(function() {
      var n, t, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.listRuns(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = fe["RunsApi.listRuns"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  } };
}, Hu = function(e) {
  function s() {
    return tn(this, s), en(this, s, arguments);
  }
  return rn(s, e), nn(s, [{ key: "clearRuns", value: function(r, i) {
    var n = this;
    return zn(this.configuration).clearRuns(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "deleteRun", value: function(r, i) {
    var n = this;
    return zn(this.configuration).deleteRun(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "getRun", value: function(r, i) {
    var n = this;
    return zn(this.configuration).getRun(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "listRuns", value: function(r, i) {
    var n = this;
    return zn(this.configuration).listRuns(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }]), s;
}(Xt);
function zu(e, s) {
  for (var r = 0; r < s.length; r++) {
    var i = s[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function mt(e, s, r) {
  return s in e ? Object.defineProperty(e, s, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[s] = r, e;
}
function Hs(e) {
  for (var s = 1; s < arguments.length; s++) {
    var r = arguments[s] != null ? arguments[s] : {}, i = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (i = i.concat(Object.getOwnPropertySymbols(r).filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    }))), i.forEach(function(n) {
      mt(e, n, r[n]);
    });
  }
  return e;
}
var $u = function() {
  function e() {
    var i, n, t, a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (function(o, u) {
      if (!(o instanceof u)) throw new TypeError("Cannot call a class as a function");
    })(this, e), mt(this, "apiKey", void 0), mt(this, "username", void 0), mt(this, "password", void 0), mt(this, "accessToken", void 0), mt(this, "basePath", void 0), mt(this, "serverIndex", void 0), mt(this, "baseOptions", void 0), mt(this, "formDataCtor", void 0), this.apiKey = a.apiKey, this.username = a.username, this.password = a.password, this.accessToken = a.accessToken, this.basePath = a.basePath, this.serverIndex = a.serverIndex, this.baseOptions = (n = Hs({}, a.baseOptions), t = (t = { headers: Hs({}, (i = a.baseOptions) === null || i === void 0 ? void 0 : i.headers) }) != null ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : function(o) {
      var u = Object.keys(o);
      if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(o);
        u.push.apply(u, l);
      }
      return u;
    }(Object(t)).forEach(function(o) {
      Object.defineProperty(n, o, Object.getOwnPropertyDescriptor(t, o));
    }), n), this.formDataCtor = a.formDataCtor;
  }
  var s, r;
  return s = e, (r = [{ key: "isJsonMime", value: function(i) {
    var n = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return i !== null && (n.test(i) || i.toLowerCase() === "application/json-patch+json");
  } }]) && zu(s.prototype, r), e;
}();
function Bu() {
  var i;
  const e = Et(), { activeOrgId: s } = is(), r = (i = e.user) == null ? void 0 : i.access_token;
  return ut(
    (n) => ({
      basePath: n,
      accessToken: r,
      baseOptions: s ? { headers: { "X-Org-Id": s } } : void 0
    }),
    [r, s]
  );
}
function qu(e) {
  const s = Bu();
  return $t(() => {
    const r = new $u(s(e));
    return {
      reports: new Mu(r),
      runs: new Hu(r)
    };
  }, [s, e]);
}
function Bt(e) {
  var r;
  const s = e == null ? void 0 : e.data;
  if (!s || s.status !== "success") {
    const i = ((r = s == null ? void 0 : s.data) == null ? void 0 : r.message) || (s == null ? void 0 : s.code) || "Request failed";
    throw new Error(i);
  }
  return s.data;
}
const Wu = {
  empty: "No reports available.",
  error: "Failed to load reports"
}, Ju = (e) => (e == null ? void 0 : e.name) ?? "";
function Zu({
  api: e,
  domain: s,
  onSelect: r,
  selectedId: i,
  // #579 — when set, auto-select this def once (deep-link from another page).
  autoSelectId: n,
  labels: t = {},
  resolveReportName: a = Ju
}) {
  const o = { ...Wu, ...t }, [u, l] = q([]), [c, d] = q(!0), [h, m] = q(null), j = rt(!1);
  return Ie(() => {
    if (j.current || !n || u.length === 0) return;
    const E = u.find((M) => M.id === n);
    E && (j.current = !0, r == null || r(E));
  }, [u, n, r]), Ie(() => {
    let E = !1;
    return d(!0), m(null), e.reports.listReports(s).then((M) => {
      E || l(Bt(M) || []);
    }).catch((M) => {
      E || m(M.message || o.error);
    }).finally(() => {
      E || d(!1);
    }), () => {
      E = !0;
    };
  }, [e, s, o.error]), c ? /* @__PURE__ */ g.jsx(ae, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ g.jsx(jn, { "data-testid": "report-list-loading" }) }) : h ? /* @__PURE__ */ g.jsx(Rn, { severity: "error", children: h }) : u.length === 0 ? /* @__PURE__ */ g.jsx(ze, { color: "text.secondary", sx: { p: 2 }, children: o.empty }) : /* @__PURE__ */ g.jsx(Ba, { "data-testid": "report-list", children: u.map((E) => /* @__PURE__ */ g.jsx(
    qa,
    {
      selected: E.id === i,
      onClick: () => r == null ? void 0 : r(E),
      children: /* @__PURE__ */ g.jsx(
        Wa,
        {
          primary: a(E),
          primaryTypographyProps: { color: "text.primary" }
        }
      )
    },
    E.id
  )) });
}
function Yu(e) {
  return e.default !== void 0 ? e.default : e.type === "boolean" ? !1 : "";
}
const cn = (e) => e !== "" && e !== void 0 && e !== null, Ku = {
  submit: "Run report",
  required: "Required"
}, Qu = (e, s, r) => (r == null ? void 0 : r.title) || s;
function Xu({
  def: e,
  onSubmit: s,
  submitting: r = !1,
  labels: i = {},
  // #551 — `context` supplies values for fields the surface knows (e.g. showId
  // from the active show); those fields are auto-filled + hidden, not typed.
  // `fieldRenderers` overrides how a specific field renders (e.g. day/ring as
  // dropdowns, classId/rideId as a lookup) — keyed by the param name; each gets
  // { value, onChange, label, required, error, disabled }.
  context: n = {},
  fieldRenderers: t = {},
  resolveParamLabel: a = Qu,
  // #1995 — when true AND every required param is already supplied by
  // `context` (a full deep-link, e.g. RideEditor's "Score Sheet Report"
  // button), submit automatically the first time that becomes true instead
  // of making the admin click "Run report" on a form with nothing left to
  // fill in. Guarded to fire at most once per mounted `def`.
  autoSubmit: o = !1
}) {
  var ue, de;
  const u = { ...Ku, ...i }, l = ((ue = e == null ? void 0 : e.paramsSchema) == null ? void 0 : ue.properties) || {}, c = ((de = e == null ? void 0 : e.paramsSchema) == null ? void 0 : de.required) || [], d = Object.entries(l).filter(([Z]) => !cn(n[Z])), [h, m] = q(() => {
    const Z = {};
    for (const [ye, Ve] of Object.entries(l))
      cn(n[ye]) || (Z[ye] = Yu(Ve));
    return Z;
  }), [j, E] = q(!1), M = (Z, ye) => m((Ve) => ({ ...Ve, [Z]: ye })), W = c.filter((Z) => cn(n[Z]) ? !1 : !cn(h[Z])), B = () => {
    const Z = {};
    for (const [ye, Ve] of Object.entries(l)) {
      if (cn(n[ye])) {
        Z[ye] = n[ye];
        continue;
      }
      const et = h[ye];
      et === "" && !c.includes(ye) || (Z[ye] = Ve.type === "number" || Ve.type === "integer" ? Number(et) : et);
    }
    return Z;
  }, be = (Z) => {
    Z.preventDefault(), E(!0), !(W.length > 0) && s(B());
  }, ee = rt(!1);
  return Ie(() => {
    ee.current = !1;
  }, [e == null ? void 0 : e.id]), Ie(() => {
    !o || ee.current || W.length > 0 || (ee.current = !0, s(B()));
  }, [o, W.length]), /* @__PURE__ */ g.jsx(ae, { component: "form", onSubmit: be, noValidate: !0, children: /* @__PURE__ */ g.jsxs(qt, { spacing: 2, children: [
    d.map(([Z, ye]) => {
      const Ve = a(e, Z, ye), et = c.includes(Z), ct = j && et && W.includes(Z), dt = t[Z];
      if (dt)
        return /* @__PURE__ */ g.jsx(Da, { children: dt({
          value: h[Z],
          onChange: (_e) => M(Z, _e),
          label: Ve,
          required: et,
          error: ct,
          disabled: r
        }) }, Z);
      if (ye.type === "boolean")
        return /* @__PURE__ */ g.jsx(
          yi,
          {
            control: /* @__PURE__ */ g.jsx(
              Ri,
              {
                color: "default",
                checked: !!h[Z],
                onChange: (_e) => M(Z, _e.target.checked)
              }
            ),
            label: Ve
          },
          Z
        );
      if (Array.isArray(ye.enum))
        return /* @__PURE__ */ g.jsx(
          Wt,
          {
            select: !0,
            label: Ve,
            required: et,
            error: ct,
            helperText: ct ? u.required : ye.description,
            value: h[Z] ?? "",
            onChange: (_e) => M(Z, _e.target.value),
            fullWidth: !0,
            children: ye.enum.map((_e) => /* @__PURE__ */ g.jsx(Ja, { value: _e, children: String(_e) }, String(_e)))
          },
          Z
        );
      const We = ye.type === "number" || ye.type === "integer";
      return /* @__PURE__ */ g.jsx(
        Wt,
        {
          label: Ve,
          type: We ? "number" : "text",
          required: et,
          error: ct,
          helperText: ct ? u.required : ye.description,
          value: h[Z] ?? "",
          onChange: (_e) => M(Z, _e.target.value),
          fullWidth: !0
        },
        Z
      );
    }),
    /* @__PURE__ */ g.jsx(ae, { children: /* @__PURE__ */ g.jsx($e, { type: "submit", variant: "contained", loading: r, children: u.submit }) })
  ] }) });
}
const el = /* @__PURE__ */ new Set(["PENDING", "RUNNING"]), tl = {
  COMPLETE: "success",
  FAILED: "error",
  RUNNING: "info",
  PENDING: "warning"
};
function nl(e) {
  if (!e) return "";
  const s = new Date(e);
  return isNaN(s.getTime()) ? e : s.toLocaleString();
}
const rl = {
  empty: "No runs yet.",
  error: "Failed to load runs",
  colReport: "Report",
  colRequested: "Requested",
  colStatus: "Status",
  colActions: "Actions",
  view: "View",
  delete: "Delete"
}, sl = (e) => e;
function il({
  api: e,
  onView: s,
  onDelete: r,
  refreshKey: i = 0,
  labels: n = {},
  resolveReportName: t = sl
}) {
  const a = { ...rl, ...n }, [o, u] = q([]), [l, c] = q(!0), [d, h] = q(null), m = rt(null), j = ut(async () => {
    try {
      const E = await e.runs.listRuns();
      u(Bt(E) || []), h(null);
    } catch (E) {
      h(E.message || a.error);
    } finally {
      c(!1);
    }
  }, [e, a.error]);
  return Ie(() => {
    j();
  }, [j, i]), Ie(() => {
    if (!o.some((M) => el.has(M.status))) {
      m.current && clearInterval(m.current), m.current = null;
      return;
    }
    return m.current || (m.current = setInterval(j, 4e3)), () => {
      m.current && (clearInterval(m.current), m.current = null);
    };
  }, [o, j]), l ? /* @__PURE__ */ g.jsx(ae, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ g.jsx(jn, { "data-testid": "run-history-loading" }) }) : d ? /* @__PURE__ */ g.jsx(Rn, { severity: "error", children: d }) : o.length === 0 ? /* @__PURE__ */ g.jsx(ze, { color: "text.secondary", sx: { p: 2 }, children: a.empty }) : /* @__PURE__ */ g.jsxs(Za, { size: "small", "data-testid": "run-history", children: [
    /* @__PURE__ */ g.jsx(Ya, { children: /* @__PURE__ */ g.jsxs(Cs, { children: [
      /* @__PURE__ */ g.jsx(yt, { children: a.colReport }),
      /* @__PURE__ */ g.jsx(yt, { children: a.colRequested }),
      /* @__PURE__ */ g.jsx(yt, { children: a.colStatus }),
      /* @__PURE__ */ g.jsx(yt, { align: "right", children: a.colActions })
    ] }) }),
    /* @__PURE__ */ g.jsx(Ka, { children: o.map((E) => /* @__PURE__ */ g.jsxs(Cs, { "data-testid": `run-row-${E.id}`, children: [
      /* @__PURE__ */ g.jsx(yt, { sx: { color: "text.primary" }, children: t(E.reportId) }),
      /* @__PURE__ */ g.jsx(yt, { sx: { color: "text.primary" }, children: nl(E.createdAt) }),
      /* @__PURE__ */ g.jsx(yt, { children: /* @__PURE__ */ g.jsx(
        wi,
        {
          size: "small",
          label: E.status,
          color: tl[E.status] || "default"
        }
      ) }),
      /* @__PURE__ */ g.jsxs(yt, { align: "right", children: [
        /* @__PURE__ */ g.jsx(
          $e,
          {
            size: "small",
            variant: "outlined",
            color: "inherit",
            disabled: E.status !== "COMPLETE",
            onClick: () => s == null ? void 0 : s(E),
            children: a.view
          }
        ),
        r && /* @__PURE__ */ g.jsx(
          rr,
          {
            size: "small",
            color: "inherit",
            "aria-label": a.delete,
            title: a.delete,
            sx: { ml: 1 },
            onClick: () => r(E),
            children: /* @__PURE__ */ g.jsx(Ro, { fontSize: "small" })
          }
        )
      ] })
    ] }, E.id)) })
  ] });
}
const al = {
  failed: "This run failed to render.",
  notReady: "Report is not ready yet.",
  error: "Failed to load report",
  openPdf: "Open PDF",
  openHtml: "Open HTML in new tab",
  preview: "Report preview"
};
function ol({ api: e, runId: s, height: r = 600, labels: i = {} }) {
  const n = { ...al, ...i }, [t, a] = q(null), [o, u] = q(!0), [l, c] = q(null);
  return Ie(() => {
    if (!s) return;
    let d = !1;
    return u(!0), c(null), e.runs.getRun(s).then((h) => {
      if (d) return;
      const m = Bt(h);
      if (m.status !== "COMPLETE" || !m.artifactUrls) {
        c(m.status === "FAILED" ? n.failed : n.notReady);
        return;
      }
      a(m.artifactUrls);
    }).catch((h) => {
      d || c(h.message || n.error);
    }).finally(() => {
      d || u(!1);
    }), () => {
      d = !0;
    };
  }, [e, s, n.error, n.failed, n.notReady]), s ? o ? /* @__PURE__ */ g.jsx(ae, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ g.jsx(jn, { "data-testid": "report-viewer-loading" }) }) : l ? /* @__PURE__ */ g.jsx(Rn, { severity: "error", children: l }) : t ? /* @__PURE__ */ g.jsxs(qt, { spacing: 1, "data-testid": "report-viewer", children: [
    /* @__PURE__ */ g.jsxs(qt, { direction: "row", spacing: 1, children: [
      t.pdf && /* @__PURE__ */ g.jsx($e, { variant: "outlined", href: t.pdf, target: "_blank", rel: "noopener", children: n.openPdf }),
      t.html && /* @__PURE__ */ g.jsx($e, { variant: "text", href: t.html, target: "_blank", rel: "noopener", children: n.openHtml })
    ] }),
    t.html && /* @__PURE__ */ g.jsx(
      ae,
      {
        component: "iframe",
        "data-testid": "report-viewer-frame",
        title: n.preview,
        src: t.html,
        sx: { width: "100%", height: r, border: 1, borderColor: "divider", borderRadius: 1, bgcolor: "#fff" }
      }
    )
  ] }) : null : null;
}
const ul = {
  title: "Reports",
  availableReports: "Available reports",
  runHistory: "Run history",
  reportDialogTitle: "Report",
  reportStarted: "Report started — open Run history to view it when ready.",
  failedToStart: "Failed to start report",
  // #609 — run-progress modal
  runningTitle: "Running report…",
  runningMessage: "Your report is being generated. It will download automatically when it's ready — or close this and find it in Run history.",
  runningDoneTitle: "Report ready",
  runningDoneMessage: "Your report has downloaded. It's also in Run history.",
  runningFailedTitle: "Report failed",
  download: "Download",
  close: "Close",
  // #606 — clear old runs
  clearHistory: "Clear history",
  clearConfirm: "Delete all report runs for this organization? This removes the generated files too and can't be undone.",
  delete: "Delete",
  // ReportList
  noReports: "No reports available.",
  failedToLoadReports: "Failed to load reports",
  // ReportParamsForm
  runReport: "Run report",
  required: "Required",
  // RunHistory
  noRuns: "No runs yet.",
  failedToLoadRuns: "Failed to load runs",
  colReport: "Report",
  colRequested: "Requested",
  colStatus: "Status",
  colActions: "Actions",
  view: "View",
  // ReportViewer
  runFailed: "This run failed to render.",
  runNotReady: "Report is not ready yet.",
  failedToLoadReport: "Failed to load report",
  openPdf: "Open PDF",
  openHtml: "Open HTML in new tab",
  reportPreview: "Report preview"
}, ll = (e) => (e == null ? void 0 : e.name) ?? (e == null ? void 0 : e.id) ?? "", cl = (e, s, r) => (r == null ? void 0 : r.title) || s;
function zs(e) {
  const s = document.createElement("a");
  s.href = e, s.target = "_blank", s.rel = "noopener", s.download = "", document.body.appendChild(s), s.click(), s.remove();
}
function ah({
  basePath: e,
  domain: s,
  // Back-compat: an explicit `title` still wins; otherwise labels.title is used.
  title: r,
  // #602 — translated chrome strings from the mounting app (see DEFAULT_LABELS).
  labels: i = {},
  // #551 — a surface can supply context values (e.g. showId from the active
  // show) and custom field renderers (day/ring dropdowns, class/ride lookups)
  // forwarded to the params form. `paramsFieldRenderers` may be a plain map or
  // a function of the selected def (so renderers can depend on the def).
  paramsContext: n = {},
  paramsFieldRenderers: t = {},
  // #579 — a surface can deep-link to a specific report (e.g. from a ride page);
  // the matching def is auto-selected once the list loads.
  initialSelectedId: a,
  // #1995 — when true, a deep-linked def whose required params are already
  // fully supplied by `paramsContext` runs immediately (skipping the manual
  // "Run report" click) instead of just being pre-filled. See
  // ReportParamsForm's `autoSubmit` for the fire-once guard.
  autoRun: o = !1,
  // #649 — see defaultResolveReportName/defaultResolveParamLabel above.
  resolveReportName: u = ll,
  resolveParamLabel: l = cl
}) {
  var Fn, Mn;
  const c = { ...ul, ...i }, d = qu(e), [h, m] = q(null), [j, E] = q(!1), [M, W] = q(null), [B, be] = q(0), [ee, ue] = q(""), [de, Z] = q(null), [ye, Ve] = q({});
  Ie(() => {
    let je = !1;
    return d.reports.listReports(s).then((Ge) => {
      if (je) return;
      const tt = {};
      for (const ht of Bt(Ge) || []) tt[ht.id] = ht;
      Ve(tt);
    }).catch(() => {
    }), () => {
      je = !0;
    };
  }, [d, s]);
  const et = (je) => {
    var Ge;
    return u({ id: je, name: (Ge = ye[je]) == null ? void 0 : Ge.name });
  }, [ct, dt] = q(!1), [We, _e] = q(null), [Re, Ut] = q(null), Nt = rt(!1), sn = rt(!1), Un = async (je) => {
    if (h) {
      sn.current = !0, E(!0), W(null);
      try {
        const Ge = Bt(await d.reports.createReportRun(h.id, { params: je }));
        be((tt) => tt + 1), m(null), Nt.current = !1, Ut(Ge), _e(Ge.id);
      } catch (Ge) {
        W(Ge.message || c.failedToStart);
      } finally {
        E(!1);
      }
    }
  };
  Ie(() => {
    if (!We) return;
    let je = !1, Ge;
    const tt = async () => {
      var ht, Ot;
      try {
        const ft = Bt(await d.runs.getRun(We));
        if (je) return;
        if (Ut(ft), ft.status === "COMPLETE") {
          be((vr) => vr + 1);
          const kt = ((ht = ft.artifactUrls) == null ? void 0 : ht.pdf) || ((Ot = ft.artifactUrls) == null ? void 0 : Ot.html);
          kt && !Nt.current && (Nt.current = !0, zs(kt));
          return;
        }
        if (ft.status === "FAILED") {
          be((kt) => kt + 1);
          return;
        }
        Ge = setTimeout(tt, 3e3);
      } catch {
        je || Ut((ft) => ({ ...ft || {}, status: "FAILED" }));
      }
    };
    return Ge = setTimeout(tt, 1200), () => {
      je = !0, clearTimeout(Ge);
    };
  }, [We, d]);
  const [Nn, an] = q(!1), Ln = async () => {
    if (!(typeof window < "u" && !window.confirm(c.clearConfirm))) {
      an(!0);
      try {
        await d.runs.clearRuns(), be((je) => je + 1);
      } finally {
        an(!1);
      }
    }
  }, Dn = async (je) => {
    await d.runs.deleteRun(je.id), be((Ge) => Ge + 1);
  };
  return /* @__PURE__ */ g.jsxs(ae, { children: [
    /* @__PURE__ */ g.jsx(ze, { variant: "h5", sx: { mb: 2, color: "text.primary" }, children: r ?? c.title }),
    /* @__PURE__ */ g.jsxs(ae, { sx: { display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 2, alignItems: "flex-start" }, children: [
      /* @__PURE__ */ g.jsx(ae, { sx: { width: { xs: "100%", md: 340 }, flexShrink: 0 }, children: /* @__PURE__ */ g.jsx(tr, { variant: "outlined", children: /* @__PURE__ */ g.jsxs(nr, { children: [
        /* @__PURE__ */ g.jsx(ze, { variant: "subtitle1", sx: { color: "text.primary" }, children: c.availableReports }),
        /* @__PURE__ */ g.jsx(
          Zu,
          {
            api: d,
            domain: s,
            selectedId: h == null ? void 0 : h.id,
            autoSelectId: a,
            onSelect: m,
            labels: { empty: c.noReports, error: c.failedToLoadReports },
            resolveReportName: u
          }
        ),
        /* @__PURE__ */ g.jsx(
          $e,
          {
            fullWidth: !0,
            variant: "text",
            color: "inherit",
            sx: { mt: 1, justifyContent: "flex-start" },
            onClick: () => dt(!0),
            children: c.runHistory
          }
        )
      ] }) }) }),
      /* @__PURE__ */ g.jsx(ae, { sx: { flex: 1, minWidth: 0, width: "100%" }, children: h && /* @__PURE__ */ g.jsx(tr, { variant: "outlined", sx: { mb: 2 }, children: /* @__PURE__ */ g.jsxs(nr, { children: [
        /* @__PURE__ */ g.jsx(ze, { variant: "subtitle1", sx: { color: "text.primary" }, children: u(h) }),
        /* @__PURE__ */ g.jsx(Qa, { sx: { my: 1 } }),
        M && /* @__PURE__ */ g.jsx(Rn, { severity: "error", sx: { mb: 2 }, children: M }),
        /* @__PURE__ */ g.jsx(
          Xu,
          {
            def: h,
            onSubmit: Un,
            submitting: j,
            autoSubmit: o && !sn.current && (h == null ? void 0 : h.id) === a,
            labels: { submit: c.runReport, required: c.required },
            context: n,
            fieldRenderers: typeof t == "function" ? t(h) : t,
            resolveParamLabel: l
          }
        )
      ] }) }) })
    ] }),
    /* @__PURE__ */ g.jsxs(Yn, { open: ct, onClose: () => dt(!1), maxWidth: "md", fullWidth: !0, children: [
      /* @__PURE__ */ g.jsx(Rr, { children: c.runHistory }),
      /* @__PURE__ */ g.jsx(Kn, { children: /* @__PURE__ */ g.jsx(
        il,
        {
          api: d,
          refreshKey: B,
          onView: (je) => Z(je.id),
          onDelete: Dn,
          labels: {
            empty: c.noRuns,
            error: c.failedToLoadRuns,
            colReport: c.colReport,
            colRequested: c.colRequested,
            colStatus: c.colStatus,
            colActions: c.colActions,
            view: c.view,
            delete: c.delete
          },
          resolveReportName: et
        }
      ) }),
      /* @__PURE__ */ g.jsxs(Nr, { children: [
        /* @__PURE__ */ g.jsx($e, { color: "error", onClick: Ln, disabled: Nn, children: c.clearHistory }),
        /* @__PURE__ */ g.jsx($e, { color: "inherit", onClick: () => dt(!1), children: c.close })
      ] })
    ] }),
    /* @__PURE__ */ g.jsxs(Yn, { open: !!de, onClose: () => Z(null), maxWidth: "lg", fullWidth: !0, children: [
      /* @__PURE__ */ g.jsx(Rr, { children: c.reportDialogTitle }),
      /* @__PURE__ */ g.jsx(Kn, { children: /* @__PURE__ */ g.jsx(
        ol,
        {
          api: d,
          runId: de,
          labels: {
            failed: c.runFailed,
            notReady: c.runNotReady,
            error: c.failedToLoadReport,
            openPdf: c.openPdf,
            openHtml: c.openHtml,
            preview: c.reportPreview
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ g.jsxs(Yn, { open: !!We, onClose: () => _e(null), maxWidth: "xs", fullWidth: !0, children: [
      /* @__PURE__ */ g.jsx(Rr, { children: (Re == null ? void 0 : Re.status) === "COMPLETE" ? c.runningDoneTitle : (Re == null ? void 0 : Re.status) === "FAILED" ? c.runningFailedTitle : c.runningTitle }),
      /* @__PURE__ */ g.jsx(Kn, { children: (Re == null ? void 0 : Re.status) === "FAILED" ? /* @__PURE__ */ g.jsx(Rn, { severity: "error", children: c.runFailed }) : (Re == null ? void 0 : Re.status) === "COMPLETE" ? /* @__PURE__ */ g.jsx(ze, { sx: { color: "text.primary" }, children: c.runningDoneMessage }) : /* @__PURE__ */ g.jsxs(ae, { sx: { display: "flex", alignItems: "center", gap: 2, py: 1 }, children: [
        /* @__PURE__ */ g.jsx(jn, { size: 26, color: "inherit" }),
        /* @__PURE__ */ g.jsx(ze, { sx: { color: "text.primary" }, children: c.runningMessage })
      ] }) }),
      /* @__PURE__ */ g.jsxs(Nr, { children: [
        (Re == null ? void 0 : Re.status) === "COMPLETE" && (((Fn = Re.artifactUrls) == null ? void 0 : Fn.pdf) || ((Mn = Re.artifactUrls) == null ? void 0 : Mn.html)) && // #609 — brand primary is darkGrey (invisible as a text button on
        // dark); a contained button + inherit-colored Close stay legible
        // in both light and dark.
        /* @__PURE__ */ g.jsx(
          $e,
          {
            variant: "contained",
            onClick: () => zs(Re.artifactUrls.pdf || Re.artifactUrls.html),
            children: c.download
          }
        ),
        /* @__PURE__ */ g.jsx($e, { color: "inherit", onClick: () => _e(null), children: c.close })
      ] })
    ] }),
    /* @__PURE__ */ g.jsx(
      Xa,
      {
        open: !!ee,
        autoHideDuration: 5e3,
        onClose: () => ue(""),
        message: ee
      }
    )
  ] });
}
var bn = {};
function Rt(e, s, r) {
  return s in e ? Object.defineProperty(e, s, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[s] = r, e;
}
bn.d = (e, s) => {
  for (var r in s) bn.o(s, r) && !bn.o(e, r) && Object.defineProperty(e, r, { enumerable: !0, get: s[r] });
}, bn.o = (e, s) => Object.prototype.hasOwnProperty.call(e, s);
var Xi = ["E", "H", "C", "M", "B"], dn = { PENDING: "PENDING", ENTERING_RING: "ENTERING_RING", IN_PROGRESS: "IN_PROGRESS", COMPLETED: "COMPLETED", SCRATCHED: "SCRATCHED" }, dl = { SCRATCHED: "Scratched", EXCUSED: "Excused", ELIMINATED: "Eliminated", NO_SHOW: "No Show" }, us = { BLOOD: "BLOOD", LAMENESS: "LAMENESS", MEETING_REQUESTED: "MEETING_REQUESTED" }, Sn = { POINTS: "POINTS", PERCENT_SENIOR: "PERCENT_SENIOR", PERCENT_YOUTH: "PERCENT_YOUTH" }, hl = 0, Jt = 10, pr = 0.5, Ft = { RIDE_INTRO_DETAILED: "ride-intro-detailed", POST_RIDE_SCORE: "post-ride-score", END_OF_CLASS_RESULT: "end-of-class-result", MID_RIDE_SIMPLE: "mid-ride-simple", CLASS_SUMMARY: "class-summary", MID_CLASS_RESULT: "mid-class-result" }, $s = { DETAILED: "detailed", SIMPLE: "simple" }, Or, Pt;
Rt(Pt = {}, Ft.RIDE_INTRO_DETAILED, ["classNumberName", "testName", "entryIdentity", "riderLocation", "horseBio", "ownerInfo"]), Rt(Pt, Ft.POST_RIDE_SCORE, ["classNumberName", "testName", "entryIdentity", "scoreHero", "termReason", "currentRank", "divisionRank", "perJudgeBreakout", "qr"]), Rt(Pt, Ft.END_OF_CLASS_RESULT, ["classNumberName", "judgesPositions", "rankedList", "resultLayout", "resultDwellSeconds", "sponsor", "qr"]), Rt(Pt, Ft.MID_CLASS_RESULT, ["classNumberName", "judgesPositions", "rankedList", "resultLayout", "resultDwellSeconds", "sponsor", "qr"]), Rt(Pt, Ft.MID_RIDE_SIMPLE, ["classNumberName", "testName", "entryIdentity", "qr"]), Rt(Pt, Ft.CLASS_SUMMARY, (Rt(Or = {}, $s.DETAILED, ["judgesPositions", "classNumberName", "startList", "resultLayout", "resultDwellSeconds", "sponsor", "qr"]), Rt(Or, $s.SIMPLE, ["classNumberName", "testName", "judgesPositions", "classStart", "estimatedFinish", "totalRides", "ring", "sponsor", "qr"]), Or));
var fl = "Withdrawn / retired", Bs = { RULE: "rule", MANUAL: "manual" }, pl = { CLASS_RIDE_MISMATCH: "CLASS_RIDE_MISMATCH", DSHB_NAME_MISMATCH: "DSHB_NAME_MISMATCH" }, A = Object.freeze({ ALREADY_AUTHORITATIVE: "already_authoritative", ALREADY_EXCUSED: "already_excused", ALREADY_MAPPED: "already_mapped", ALREADY_NO_SHOW: "already_no_show", AMBIGUOUS_USEF_COMP_ID: "ambiguous_usef_comp_id", BATCH_TOO_LARGE: "batch_too_large", CLASS_NOT_FOUND: "class_not_found", COMPOSITE_JUDGE_NOT_FOUND: "composite_judge_not_found", CONCURRENT_MODIFICATION: "concurrent_modification", DEFAULT_VIEW_REQUIRED: "default_view_required", DEFAULT_VIEW_UNDELETABLE: "default_view_undeletable", DUPLICATE_JUDGE: "duplicate_judge", DUPLICATE_SCORE_SHEET: "duplicate_score_sheet", DUPLICATE_SLUG: "duplicate_slug", ELIMINATION_CHANGE_NEEDS_SHEET_EDIT: "elimination_change_needs_sheet_edit", ENV_NOT_ALLOWED: "env_not_allowed", FORBIDDEN: "forbidden", INSUFFICIENT_CONTRAST: "insufficient_contrast", INVALID_ACTION: "invalid_action", INVALID_ASPECT_RATIO: "invalid_aspect_ratio", INVALID_BODY: "invalid_body", INVALID_DEFAULT_MODE: "invalid_default_mode", INVALID_EVENT_MODE_MAP: "invalid_event_mode_map", INVALID_FIELD_SET: "invalid_field_set", INVALID_IMAGE_TYPE: "invalid_image_type", INVALID_JUDGE: "invalid_judge", INVALID_MIRROR_TARGET: "invalid_mirror_target", INVALID_MODE_GROUP: "invalid_mode_group", INVALID_MODE_TYPE: "invalid_mode_type", INVALID_MOVEMENT_NUMBER: "invalid_movement_number", INVALID_MOVEMENT_OVERRIDE: "invalid_movement_override", INVALID_PATH: "invalid_path", INVALID_PIN: "invalid_pin", INVALID_PLACING_VIEW: "invalid_placing_view", INVALID_RIDE: "invalid_ride", INVALID_SHAPE: "invalid_shape", INVALID_SIGNATURE: "invalid_signature", INVALID_SLUG: "invalid_slug", INVALID_SPONSOR: "invalid_sponsor", INVALID_STATUS: "invalid_status", INVALID_STATUS_ENTRY: "invalid_status_entry", INVALID_TERM_REASON: "invalid_term_reason", INVALID_TIMEZONE: "invalid_timezone", INVALID_TYPE: "invalid_type", INVALID_VISIBLE_ON_REMOTE: "invalid_visible_on_remote", INVALID_WATERMARK_MODE: "invalid_watermark_mode", JUDGE_NOT_FOUND: "judge_not_found", JUDGE_NOT_ON_PANEL: "judge_not_on_panel", LIVE_GUARD: "live_guard", LOGO_TOO_LARGE: "logo_too_large", LOGO_TOO_SMALL: "logo_too_small", MARKS_CONFIRMED_FROZEN: "marks_confirmed_frozen", MARKS_NOT_CONFIRMED: "marks_not_confirmed", MIRROR_CYCLE: "mirror_cycle", MISSING_ACTION: "missing_action", MISSING_PARAMS: "missing_params", MISSING_QUERY_PARAM: "missing_query_param", MISSING_SHOW_ID: "missing_show_id", MISSING_SIGNATURE: "missing_signature", MISSING_TARGET: "missing_target", NO_CONFLICT: "no_conflict", NO_CONTENDER: "no_contender", NO_DRAFT: "no_draft", NO_SCRIBE_IDENTITY: "no_scribe_identity", NOT_ASSIGNED: "not_assigned", NOT_CHAMPIONSHIP_CLASS: "not_championship_class", NOT_ENTITLED: "not_entitled", NOT_EXCUSED: "not_excused", NOT_FINAL: "not_final", NOT_FOUND: "not_found", NOT_MANUAL: "not_manual", NOT_NO_SHOW: "not_no_show", NOT_PANEL_SHEET: "not_panel_sheet", NOT_PRESIDING_JUDGE: "not_presiding_judge", NOT_RELEASABLE: "not_releasable", NOT_UNFILLED_SLOT: "not_unfilled_slot", PANEL_NOT_FULLY_SIGNED: "panel_not_fully_signed", PLACED_CLASS_LOCKED: "placed_class_locked", PRIMARY_JUDGE_NOT_FOUND: "primary_judge_not_found", PROD_REFUSED: "prod_refused", REASON_REQUIRED: "reason_required", RIDE_SCRATCHED: "ride_scratched", RIDE_TERMINATED: "ride_terminated", ROUTE_NOT_FOUND: "route_not_found", RUNNING_REQUIRES_CLASS: "running_requires_class", SAME_CLASS: "same_class", SAME_RIDE: "same_ride", SECONDARY_JUDGE_NOT_FOUND: "secondary_judge_not_found", SELF_MAPPING: "self_mapping", SHEET_COMPLETED: "sheet_completed", SHEET_EDITING: "sheet_editing", SHEET_INCOMPLETE: "sheet_incomplete", SHEET_NOT_EDITING: "sheet_not_editing", SHEET_NOT_FROZEN: "sheet_not_frozen", SHOW_NOT_FOUND: "show_not_found", SOURCE_IS_PLACEHOLDER: "source_is_placeholder", SOURCE_NOT_FOUND: "source_not_found", SOURCE_NOT_PLACED: "source_not_placed", STALE_WRITE: "stale_write", TARGET_ALREADY_SCORED: "target_already_scored", TARGET_IS_MANUAL: "target_is_manual", TARGET_NOT_FOUND: "target_not_found", TERM_REASON_CONFLICT: "term_reason_conflict", TEST_MISMATCH: "test_mismatch", TEXT_REQUIRED: "text_required", UNEXPECTED_ERROR: "unexpected_error", UNKNOWN_MODE: "unknown_mode", UNSUPPORTED_SUBJECT_TYPE: "unsupported_subject_type", VALIDATION_ERROR: "validation_error", VALIDATION_FAILED: "validation_failed", VENUE_HAS_SCREENS: "venue_has_screens", VENUE_HAS_SHOWS: "venue_has_shows", VIEW_NOT_FOUND: "view_not_found", WRONG_ORG: "wrong_org", YEAR_MISMATCH: "year_mismatch" });
new Set(Object.values(A));
function P(e, s, r) {
  return s in e ? Object.defineProperty(e, s, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[s] = r, e;
}
function hn(e) {
  return e == null || e === "" ? "another status" : String(e).toLowerCase().split(/[_\s]+/).filter(Boolean).map(function(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
  }).join(" ");
}
function $n(e) {
  var s, r = [], i = !0, n = !1, t = void 0;
  try {
    for (var a, o = (Array.isArray(e) ? e : [])[Symbol.iterator](); !(i = (a = o.next()).done); i = !0) {
      var u = a.value, l = String(u).replace(/^\//, "").split(/[/.[\]]/)[0].replace(/([a-z0-9])([A-Z])/g, "$1 $2").replace(/[_-]+/g, " ").toLowerCase().replace(/\s+ids?$/, "").trim();
      l && !r.includes(l) && r.push(l);
    }
  } catch (c) {
    n = !0, t = c;
  } finally {
    try {
      i || o.return == null || o.return();
    } finally {
      if (n) throw t;
    }
  }
  return r.length <= 1 ? (s = r[0]) !== null && s !== void 0 ? s : "" : "".concat(r.slice(0, -1).join(", "), " and ").concat(r[r.length - 1]);
}
var k, Mt = "Reload the page and try again.";
Object.freeze((P(k = {}, A.ALREADY_AUTHORITATIVE, { default: "This sheet is already the authoritative one for this seat. There is nothing to switch." }), P(k, A.ALREADY_EXCUSED, { default: "This ride is already marked Excused. There is nothing more to do here." }), P(k, A.ALREADY_MAPPED, { default: "This combined judge already has its two judges set. Edit the existing pairing instead of adding a new one." }), P(k, A.ALREADY_NO_SHOW, { default: "This ride is already marked No Show. There is nothing more to do here." }), P(k, A.AMBIGUOUS_USEF_COMP_ID, { default: "More than one show uses this USEF competition number. Add the show year to the scoreboard link to pick the right one." }), P(k, A.BATCH_TOO_LARGE, { default: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).max;
  return "That is more than ".concat(e, " placings to save at once. Save them in smaller groups.");
} }), P(k, A.CLASS_NOT_FOUND, { default: "That class could not be found for this show. Check the link, or choose the class again from the class list." }), P(k, A.COMPOSITE_JUDGE_NOT_FOUND, { default: "The combined judge you picked is not on this show's judge list. Reload the judge list and pick again." }), P(k, A.CONCURRENT_MODIFICATION, { default: "Someone else changed this scoresheet after you opened it. Reload the sheet to see their changes, then make yours again.", commit: "Someone else changed this scoresheet after you opened it. Reload the sheet to see their changes, then save your edit again.", restore: "Someone else changed this scoresheet after you opened it. Reload the audit trail to see their changes, then try the restore again.", stationReconcile: "This station was reconciled again after you last looked. Reload the review and try again." }), P(k, A.DEFAULT_VIEW_REQUIRED, { default: "Every show needs a default scoreboard view, and this is the only one. Make another view the default first, then change this one." }), P(k, A.DEFAULT_VIEW_UNDELETABLE, { default: "This is the show's default scoreboard view, so it cannot be deleted while other views exist. Make another view the default first, then delete this one." }), P(k, A.DUPLICATE_JUDGE, { default: "The two judges in a combined judge must be different people. Pick a different second judge." }), P(k, A.DUPLICATE_SCORE_SHEET, { default: "This judge already has a scoresheet for this ride. Open that sheet instead of starting a new one." }), P(k, A.DUPLICATE_SLUG, { default: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).slug;
  return 'Another scoreboard view on this show already uses the web address "'.concat(e, '". Choose a different one.');
} }), P(k, A.ELIMINATION_CHANGE_NEEDS_SHEET_EDIT, { default: "Applying this value would add or remove an elimination on the sheet, which can't be done from the review queue. Keep the current value here, then make the change on the sheet itself." }), P(k, A.ENV_NOT_ALLOWED, { default: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).allowed;
  return "Resetting the demo data only works on these servers: ".concat(e, ". This server is not one of them.");
} }), P(k, A.FORBIDDEN, { default: "You do not have permission to do that. Ask the show office if you need it.", superAdmin: "Only a Fox Village administrator can change this. Ask Fox Village support if it needs changing.", instance: "Your account cannot change this scoring station's setup. Ask Fox Village support if it needs changing.", showOfficeOnly: "Only the show office can make that status change. Ask the show office to make it for you.", otherOrg: "This show belongs to a different organization. Switch to that organization, or check that you picked the right show.", alertOwner: "Only the person who raised this alert, or the show office, can clear it. Ask one of them to clear it." }), P(k, A.INSUFFICIENT_CONTRAST, { default: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).parts;
  return "The text color is too hard to read against the ".concat(e, ". Pick a darker or lighter text color, or change that color.");
} }), P(k, A.INVALID_ACTION, { default: "That choice is not available for this review item. Reload the review list and pick one of the options shown." }), P(k, A.INVALID_ASPECT_RATIO, { default: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = e.width, r = e.height;
  return "That picture is ".concat(s, " by ").concat(r, " pixels, which is the wrong shape. Crop it to the shape you picked and upload it again.");
}, square: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = e.width, r = e.height;
  return "That picture is ".concat(s, " by ").concat(r, " pixels, but a square image has to be as wide as it is tall. Crop it to a square and upload it again.");
}, wide: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = e.width, r = e.height;
  return "That picture is ".concat(s, " by ").concat(r, " pixels, but a wide image has to be about five times as wide as it is tall. Crop it to that shape and upload it again.");
} }), P(k, A.INVALID_BODY, { default: "Some of what was sent was missing or in the wrong form. ".concat(Mt), listMissing: "The list of rides or classes to work on was missing or empty. ".concat(Mt), tooMany: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).max;
  return "That is more than ".concat(e, " items to load at once. Load fewer at a time.");
}, placingsMissing: "There were no placings to save. Set at least one placing, then save again." }), P(k, A.INVALID_DEFAULT_MODE, { default: "A screen's default can only be a message, an image, a blank screen, or a group made only of those, all from that same view, because the default shows when nothing is selected and must never read ride or ring data. Pick one of those, or clear the default." }), P(k, A.INVALID_EVENT_MODE_MAP, { default: "The automatic switching list can only use ride start, ride scored or class complete, and each one must point at a screen from this same view. Fix the list and save again." }), P(k, A.INVALID_FIELD_SET, { default: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).fieldSet;
  return '"'.concat(e, '" is not a class summary layout we know. Pick Detailed or Simple.');
} }), P(k, A.INVALID_MODE_GROUP, { default: "A group needs a list of screens from this same view, each with a whole-number dwell time from 3 to 120 seconds. A group cannot contain itself or another group. Fix the group's list and save again." }), P(k, A.INVALID_IMAGE_TYPE, { default: "That file is not a picture we can use. Upload a PNG, GIF, or JPEG image.", pngOrJpegOnly: "This picture has to be a PNG or JPEG. Save it in one of those formats and upload it again.", damaged: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).kind;
  return "That ".concat(e, " picture looks damaged and could not be read. Save it again and upload the new copy.");
} }), P(k, A.INVALID_JUDGE, { default: "One of the judges you picked is not on this show's judge list. Reload the page and pick the judges again." }), P(k, A.INVALID_MIRROR_TARGET, { default: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).view;
  return 'The view to copy from ("'.concat(e, `") is not one of this show's scoreboard views. Pick a view from this show's list.`);
} }), P(k, A.INVALID_MODE_TYPE, { default: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).modeType;
  return '"'.concat(e, '" is not a kind of scoreboard screen we know. Pick a screen type from the list.');
} }), P(k, A.INVALID_MOVEMENT_NUMBER, { default: "The movement number has to be a whole number. Enter it again without letters or decimals." }), P(k, A.INVALID_MOVEMENT_OVERRIDE, { default: "That movement change would leave the test sheet in a form that cannot be scored, for example two movements with the same number. Check the section and movement number, then save again." }), P(k, A.INVALID_PATH, { default: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = e.fileLabel, r = e.path;
  return "The ".concat(s, ' path "').concat(r, '" is not valid. Fix the path and save again.');
}, wrongEnding: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = e.fileLabel, r = e.path, i = e.ending;
  return "The ".concat(s, ' path "').concat(r, '" has to end in "').concat(i, '". Fix the path and save again.');
}, parentFolder: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = e.fileLabel, r = e.path;
  return "The ".concat(s, ' path "').concat(r, '" cannot step up a folder with "..". Enter the full path to the file and save again.');
}, hiddenCharacter: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = e.fileLabel, r = e.path;
  return "The ".concat(s, ' path "').concat(r, '" contains a hidden character that is not allowed. Retype the path and save again.');
} }), P(k, A.INVALID_PIN, { default: "The scribe unlock PIN has to be 4 to 8 digits, numbers only. Enter a new PIN, or clear it to turn the PIN off." }), P(k, A.INVALID_PLACING_VIEW, { default: "That default placing view is not one of the available choices. Pick one from the list, or clear it to use the standard view." }), P(k, A.INVALID_RIDE, { default: "One of the rides in these placings is not in this class. Reload the class and set the placings again." }), P(k, A.INVALID_SHAPE, { default: "The logo shape has to be square or wide. Pick one and upload again." }), P(k, A.INVALID_SIGNATURE, { default: "The signature did not come through as a picture. Clear the signature box, have the judge sign again, and save." }), P(k, A.INVALID_SLUG, { default: "The web address for this view can only use lowercase letters, numbers, and hyphens. Change it and save again." }), P(k, A.INVALID_SPONSOR, { default: "The sponsor you picked is not in this show's sponsor list. Reload the page and pick the sponsor again." }), P(k, A.INVALID_STATUS, { default: "That is not a ride status the scoring system knows. ".concat(Mt) }), P(k, A.INVALID_STATUS_ENTRY, { default: "Every ride in this update needs a ride and a known status. Reload the page and set the statuses again." }), P(k, A.INVALID_TERM_REASON, { default: "That is not a reason the scoring system knows for ending a ride. Reload the page and pick the reason again from the list." }), P(k, A.INVALID_TIMEZONE, { default: "The venue time zone was not recognized. Enter a whole-hour offset such as GMT-4, a zone name such as America/Chicago, or clear it." }), P(k, A.INVALID_TYPE, { default: "That is not a kind of alert the scoring system knows. Reload the page and pick the alert again." }), P(k, A.INVALID_VISIBLE_ON_REMOTE, { default: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).visibleOnRemote;
  return '"'.concat(e, '" is not a yes or no. Choose whether this mode shows a button on the remote.');
} }), P(k, A.INVALID_WATERMARK_MODE, { default: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).watermarkMode;
  return '"'.concat(e, `" is not a watermark setting we know. Pick Inherit, Show or Hide for the screen's watermark.`);
} }), P(k, A.JUDGE_NOT_FOUND, { default: "That judge is not on this show's judge list any more. Reload the judge list and try again." }), P(k, A.JUDGE_NOT_ON_PANEL, { default: "That judge is not on this class's panel. Pick a judge from this class's panel." }), P(k, A.LIVE_GUARD, { default: "Resetting the demo data is switched off on a live scoring server. Use the demo server instead." }), P(k, A.LOGO_TOO_LARGE, { default: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = e.sizeMb, r = e.maxMb;
  return "That picture is ".concat(s, " MB, and the limit is ").concat(r, " MB. Make it smaller and upload it again.");
} }), P(k, A.LOGO_TOO_SMALL, { default: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = e.width, r = e.height, i = e.minPx;
  return "That picture is only ".concat(s, " by ").concat(r, " pixels, and its longest side needs to be at least ").concat(i, " pixels. Upload a bigger version.");
} }), P(k, A.MARKS_CONFIRMED_FROZEN, { default: "The marks on this sheet are confirmed and locked, so only the remarks can still be changed. To change a mark, ask the show office to unlock the sheet." }), P(k, A.MARKS_NOT_CONFIRMED, { default: "The class's marks have not been confirmed yet. Confirm the marks first, then the panel can sign." }), P(k, A.MIRROR_CYCLE, { default: "A scoreboard view cannot copy itself. Pick a different view to copy from.", loop: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = e.view, r = e.maxDepth;
  return 'Copying "'.concat(s, '" would make views copy each other in a loop, or chain more than ').concat(r, " views together. Pick a view that shows its own content.");
} }), P(k, A.MISSING_ACTION, { default: "No choice was picked for this review item. Pick an option and try again." }), P(k, A.MISSING_PARAMS, { default: "The page did not say which show to use. Reload the page, or pick the show again.", showAndRing: "The page did not say which show and ring to use. Pick the show and ring again." }), P(k, A.MISSING_QUERY_PARAM, { default: "The page did not say which show to use. Reload the page, or pick the show again.", showAndRing: "The page did not say which show and ring to use. Pick the show and ring again.", rideFilter: "Looking up rides needs a class, show, rider, horse, or review filter. Pick one and search again.", rideOrJudge: "Looking up scoresheets needs a ride or a judge. Pick one and try again." }), P(k, A.MISSING_SHOW_ID, { default: "The page did not say which show to use. Reload the page, or pick the show again." }), P(k, A.MISSING_SIGNATURE, { default: "The judge needs to sign this sheet before it can be completed. Have the judge sign, then complete the sheet again.", notOnFile: "That judge has no signature on file for this show. Ask the show office to add the judge's signature, then try again.", namedJudgeNotOnFile: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).judgeName;
  return "".concat(e, " has no signature on file for this show. Ask the show office to add it, then try again.");
}, combinedJudgeUnresolved: "One of the two judges behind this combined judge could not be found. Ask the show office to check the combined judge setup, then try again." }), P(k, A.MISSING_TARGET, { default: "No ride was picked to move this sheet to. Pick the ride, then try again." }), P(k, A.NO_CONFLICT, { default: "This sheet has no stale-write conflict waiting to be resolved. Reload the review queue and try again." }), P(k, A.NO_CONTENDER, { default: "This seat has no other sheet to compare against. Reload the ride and try again." }), P(k, A.NO_DRAFT, { default: "There are no unsaved edits on this sheet to work with. Reload the sheet to see what was saved." }), P(k, A.NO_SCRIBE_IDENTITY, { default: "This tablet is not signed in as a scribe. Sign in again, then try again." }), P(k, A.NOT_ASSIGNED, { default: "You aren't assigned to scribe this class. Ask the show office to assign you to this judge, then try again.", ride: "You aren't assigned to scribe this ride. Ask the show office to assign you, then try again." }), P(k, A.NOT_CHAMPIONSHIP_CLASS, { default: "This class is not a championship class, so its spots cannot be filled from other classes. Pick a championship class.", target: "The class you are filling is not a championship class. Pick a ride in a championship class." }), P(k, A.NOT_EXCUSED, { default: "This ride is not marked Excused, so there is nothing to undo. Reload the ride to see its current status." }), P(k, A.NOT_FINAL, { default: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).status;
  return "This ride cannot be placed yet because it is still ".concat(hn(e).toLowerCase(), ". Every judge's sheet for the ride has to be signed first.");
} }), P(k, A.NOT_FOUND, { default: "That record could not be found. ".concat(Mt), ride: "This ride could not be found. It may have been removed, so reload the class list and open it again.", scoreSheet: "This scoresheet is no longer on the server. Go back to the class list and open the ride again.", class: "This class could not be found. It may have been removed, so reload the class list and pick it again.", classNoRides: "This class has no rides yet, so there is nothing to place. Check the class's rides, then try again.", test: "The dressage test for this ride could not be found. Ask the show office to check which test the class uses.", catalogTest: "That test is not in the test catalog. Check the test name, or ask Fox Village support to add it.", person: "This person could not be found. They may have been removed, so reload the list and try again.", horse: "This horse could not be found. It may have been removed, so reload the list and try again.", show: "This show could not be found. Check that you are in the right organization, then pick the show again.", view: "This scoreboard view could not be found. It may have been deleted, so reload the list of views.", sponsor: "This sponsor could not be found. It may have been deleted, so reload the list of sponsors.", theme: "This theme could not be found. It may have been deleted, so reload the list of themes.", screen: "This screen could not be found. It may have been deleted, so reload the list of screens.", venue: "This venue could not be found. It may have been deleted, so reload the list of venues.", asset: "This picture could not be found. It may have been deleted, so reload the page and upload it again.", alert: "This alert could not be found. It may already have been cleared, so reload the ride to check.", reviewItem: "This review item could not be found. It may already have been handled, so reload the review list.", version: "That version is no longer in this sheet's audit trail. Reload the audit trail and pick a version from the current list.", judgePairing: "This combined judge pairing could not be found. It may have been removed, so reload the judge list.", movement: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).movementNumber;
  return "Movement ".concat(e, " is not on this ride's test sheet. Reload the sheet and pick a movement that is listed.");
} }), P(k, A.NOT_MANUAL, { default: "Only a ride that was added by hand can be matched to a real ride this way. Pick a ride that was added by hand." }), P(k, A.NOT_NO_SHOW, { default: "This ride is not marked No Show, so there is nothing to undo. Reload the ride to see its current status." }), P(k, A.NOT_PANEL_SHEET, { default: "This sheet is not scored by a judging panel, so it does not use panel signing. Use Complete & Sign instead." }), P(k, A.NOT_PRESIDING_JUDGE, { default: "Only the judge at C can do that. Ask the judge at C to do it.", markNoShow: "Only the judge at C can mark this ride No Show. Ask the judge at C to do it.", undoNoShow: "Only the judge at C can undo this ride's No Show. Ask the judge at C to do it.", markExcused: "Only the judge at C can mark this ride Excused. Ask the judge at C to do it.", undoExcused: "Only the judge at C can undo this ride's Excused mark. Ask the judge at C to do it." }), P(k, A.NOT_RELEASABLE, { default: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = e.blocking, r = e.total;
  return "".concat(s, " of ").concat(r, " rides in this class are not finished, because not every judge's sheet is signed yet. Finish judging those rides, then save the placings.");
} }), P(k, A.NOT_UNFILLED_SLOT, { default: "That ride is not an empty championship spot. Pick an empty spot to fill." }), P(k, A.PANEL_NOT_FULLY_SIGNED, { default: "Not every judge on the panel has signed yet. Have the remaining judges sign, then complete the sheet." }), P(k, A.PLACED_CLASS_LOCKED, { default: "This class's placings are already set and locked. Ask someone with permission to override placed classes to change them." }), P(k, A.PRIMARY_JUDGE_NOT_FOUND, { default: "The first judge you picked is not on this show's judge list. Reload the judge list and pick again." }), P(k, A.PROD_REFUSED, { default: "Resetting the demo data is never allowed on the live production server. Use the demo server instead." }), P(k, A.REASON_REQUIRED, { default: "Enter a reason before saving. The reason is kept in the sheet's history.", unlock: "Enter a reason for unlocking this sheet. The reason is kept in the sheet's history.", commit: "Enter a reason for this edit before saving it. The reason is kept in the sheet's history.", restore: "Enter a reason for restoring this version. The reason is kept in the sheet's history." }), P(k, A.RIDE_SCRATCHED, { default: "This ride has been scratched, so it can't be scored. Pick another ride from the class list." }), P(k, A.RIDE_TERMINATED, { default: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).termReason;
  return "This ride ended as ".concat(hn(e), ", so it cannot be placed. Leave it out of the placings.");
}, batch: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).count;
  return "".concat(e, " of the rides in these placings ended early and cannot be placed. Leave them out and save again.");
} }), P(k, A.ROUTE_NOT_FOUND, { default: "This app asked the scoring server for something it doesn't have. Reload the app, and if it keeps happening tell the show office." }), P(k, A.RUNNING_REQUIRES_CLASS, { default: "To mark the ring as running, pick the class that is in the ring. Choose a class, then try again." }), P(k, A.SAME_CLASS, { default: "The ride to fill from has to come from a different class that qualifies for this championship. Pick a ride from a qualifying class." }), P(k, A.SAME_RIDE, { default: "The ride you picked is the same ride this sheet is already on. Pick a different ride." }), P(k, A.SECONDARY_JUDGE_NOT_FOUND, { default: "The second judge you picked is not on this show's judge list. Reload the judge list and pick again." }), P(k, A.SELF_MAPPING, { default: "A combined judge cannot be paired with itself. Pick two other judges." }), P(k, A.SHEET_COMPLETED, { default: "This sheet has already been signed and is locked, so changes can't be saved to it. Ask the show office to unlock it if something needs fixing." }), P(k, A.SHEET_EDITING, { default: "This sheet has an edit in progress. Commit or discard that edit first, then restore the version." }), P(k, A.SHEET_INCOMPLETE, { default: "This sheet still has a blank movement or collective mark. Fill in every mark, then try again.", confirm: "This sheet cannot be confirmed yet because a movement or collective mark is blank. Fill in every mark, then confirm again.", complete: "This sheet cannot be completed yet because a movement or collective mark is blank. Fill in every mark, then complete it again.", commit: "This edit cannot be saved because a movement or collective mark is blank. Fill in every mark, then save again." }), P(k, A.SHEET_NOT_EDITING, { default: "This sheet is not unlocked for editing. Unlock it first, then make the change." }), P(k, A.SHEET_NOT_FROZEN, { default: "This sheet is not locked, so there is nothing to unlock. Make your changes directly." }), P(k, A.SHOW_NOT_FOUND, { default: "This show could not be found. Check the show link, or pick the show again from the list." }), P(k, A.SOURCE_IS_PLACEHOLDER, { default: "The ride you are filling from is itself an empty championship spot. Pick a real ride from a qualifying class." }), P(k, A.SOURCE_NOT_FOUND, { default: "The ride you are filling from could not be found. Reload the class and pick it again." }), P(k, A.SOURCE_NOT_PLACED, { default: "The ride you are filling from has not been placed in its class yet. Place that class first, then fill the championship." }), P(k, A.STALE_WRITE, { default: "Someone else saved a change to this scoresheet after you loaded it. Reload the sheet to see their change, then make yours again." }), P(k, A.TARGET_ALREADY_SCORED, { default: "The ride you picked already has a sheet from the same judge. Pick a different ride, or ask the show office to sort out the extra sheet." }), P(k, A.TARGET_IS_MANUAL, { default: "The ride you picked was also added by hand. Pick a ride that came from the show's entries." }), P(k, A.TARGET_NOT_FOUND, { default: "The ride you picked could not be found. Reload the class and pick it again." }), P(k, A.TERM_REASON_CONFLICT, { default: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = e.existing, r = e.incoming;
  return r ? "This ride is already marked ".concat(hn(s), ", so it can't also be marked ").concat(hn(r), ". Ask the show office to clear the earlier status first.") : "This ride is already marked ".concat(hn(s), ". Ask the show office to clear that status first.");
} }), P(k, A.TEST_MISMATCH, { default: "This sheet was scored on a different test than the ride you picked. Pick a ride in a class that uses the same test.", attach: "This sheet was scored on a different test than the ride you picked, so it cannot be attached. Pick a ride in a class that uses the same test.", move: "This sheet was scored on a different test than the ride you picked, so it cannot be moved there. Pick a ride in a class that uses the same test." }), P(k, A.TEXT_REQUIRED, { default: "The note is empty. Type the note, then save." }), P(k, A.UNEXPECTED_ERROR, { default: "The scoring server couldn't accept that request. Try again, and if it keeps happening tell the show office.", server: "The scoring server hit a problem. Try again in a moment, and if it keeps happening tell the show office." }), P(k, A.UNKNOWN_MODE, { default: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).mode;
  return 'That screen ("'.concat(e, `") is not one of this view's screens. Reload the view and pick one of its screens.`);
} }), P(k, A.UNSUPPORTED_SUBJECT_TYPE, { default: "This kind of review item is not handled from the review list. Open the ride itself and resolve it there." }), P(k, A.VALIDATION_ERROR, { default: "Some of what was entered is missing or not in the right form. Check what you entered and try again.", fields: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).fields;
  return $n(e) ? "Some of what was sent wasn't in a form the server accepts. Check the ".concat($n(e), " and try again.") : "Some of what was sent wasn't in a form the server accepts. ".concat(Mt);
}, sheetFields: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).fields;
  return $n(e) ? "Some of what was entered on this sheet wasn't in a form the server accepts. Check the ".concat($n(e), " and try again.") : "Some of what was entered on this sheet wasn't in a form the server accepts. ".concat(Mt);
}, catalogTest: "The updated test does not fit the rules every test sheet has to follow. Check the listed problems, then save again.", judgePairing: "A combined judge needs the combined judge and both of its judges. Pick all three, then save.", seat: "The page did not say which show and scribe seat to use. Reload the page and try again.", held: "The failed change was missing details it needs to be held for review. Reload the page and try again.", placing: "A placing has to be a whole number of 0 or more, or left blank. Fix the placing and save again.", ringStatus: "The ring update was missing the show, the ring, or the ring status. Pick all three and try again.", viewFields: "A scoreboard view needs a show, a name, and a web address. Fill them in, then save.", sponsorFields: "A sponsor needs a name, a display name, or a logo. Add at least one, then save.", themeName: "A theme needs a name. Enter one, then save.", venueName: "A venue needs a name. Enter one, then save.", screenLabel: "A screen needs a label. Enter one, then save.", screenAspectRatio: "The screen shape has to be 2 to 1, 16 to 9, or 4 to 3. Pick one of those, then save.", screenTokenLocked: "A screen's public link cannot be changed. To get a new link, delete the screen and add a new one.", showVenueId: "That venue could not be found. Pick a venue from the list, then save.", viewScreenNoVenue: "This show has no venue yet, so it has no screens to put a view on. Set the show's venue first, then pick a screen.", viewScreen: "That screen is not at this show's venue. Pick a screen from the list for this venue, then save.", image: "No picture was attached. Choose a picture, then upload again." }), P(k, A.VALIDATION_FAILED, { default: "Pick at least one scribe account to assign in the demo data. Then run the reset again." }), P(k, A.VENUE_HAS_SCREENS, { default: "This venue still has screens. Delete its screens first, then delete the venue." }), P(k, A.VENUE_HAS_SHOWS, { default: "This venue is still linked to one or more shows. Unlink those shows from it first, then delete the venue." }), P(k, A.VIEW_NOT_FOUND, { default: "This scoreboard view could not be found. Check the scoreboard link, or ask the show office for the right one." }), P(k, A.WRONG_ORG, { default: "Resetting the demo data only works while you are in the demo organization. Switch to it, then try again." }), P(k, A.YEAR_MISMATCH, { default: "That show is not from the year given in the scoreboard link. Check the year in the link." }), P(k, A.NOT_ENTITLED, { default: "Your organization does not have the scoring app turned on. Ask Fox Village support to turn it on." }), k));
function kr(e, s, r) {
  return s in e ? Object.defineProperty(e, s, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[s] = r, e;
}
function ea(e) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : pr;
  if (typeof e != "number" || !Number.isFinite(e)) return null;
  var r = Math.round(e / s) * s, i = Math.round(1e3 * r) / 1e3;
  return i < 0 ? 0 : i > Jt ? Jt : i;
}
function ta(e) {
  var s = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).suppressShorthand, r = s !== void 0 && s;
  if (e == null) return null;
  var i = String(e).trim();
  if (i === "") return null;
  var n = Number(i);
  return Number.isFinite(n) ? /\./.test(i) || n >= 0 && n <= Jt ? n : !r && n > Jt && n <= 100 ? n / 10 : n : null;
}
function vl(e) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : pr, r = ta(e);
  return r === null ? null : ea(r, s);
}
var Bn;
kr(Bn = {}, Sn.POINTS, [{ points: 2 }, { points: 4 }, { eliminate: !0 }]), kr(Bn, Sn.PERCENT_SENIOR, [{ percent: 2 }, { eliminate: !0 }]), kr(Bn, Sn.PERCENT_YOUTH, [{ percent: 0.5 }, { percent: 1 }, { eliminate: !0 }]);
function Ze(e, s, r) {
  return s in e ? Object.defineProperty(e, s, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[s] = r, e;
}
var qe, Ye = { PERCENTAGE: "PERCENTAGE", COLLECTIVE_MARKS: "COLLECTIVE_MARKS", YOUNG_HORSE_AVERAGE: "YOUNG_HORSE_AVERAGE", YOUNG_HORSE_SUBMISSION: "YOUNG_HORSE_SUBMISSION", FEI_CHILDREN_TECHNICAL: "FEI_CHILDREN_TECHNICAL", FEI_CHILDREN_MEDIAN: "FEI_CHILDREN_MEDIAN", FREESTYLE_ARTISTIC: "FREESTYLE_ARTISTIC", FREESTYLE_HARMONY: "FREESTYLE_HARMONY", FREESTYLE_CHOREOGRAPHY: "FREESTYLE_CHOREOGRAPHY", MOVEMENT_TOTALS: "MOVEMENT_TOTALS", UNRESOLVED: "UNRESOLVED", JUDGE_ENTERED: "JUDGE_ENTERED", RIDE_OFF_REQUIRED: "RIDE_OFF_REQUIRED", DSHB_JUDGE_ENTERED: "DSHB_JUDGE_ENTERED", DSHB_UNRESOLVED: "DSHB_UNRESOLVED" };
Ze(qe = {}, Ye.PERCENTAGE, "DR123.3"), Ze(qe, Ye.COLLECTIVE_MARKS, "DR123.3"), Ze(qe, Ye.YOUNG_HORSE_AVERAGE, "DR123.3 (Young Horse exception)"), Ze(qe, Ye.YOUNG_HORSE_SUBMISSION, "DR123.3 (Young Horse exception)"), Ze(qe, Ye.FEI_CHILDREN_TECHNICAL, "DR123.3 (FEI Children exception)"), Ze(qe, Ye.FEI_CHILDREN_MEDIAN, "DR123.3 (FEI Children exception)"), Ze(qe, Ye.FREESTYLE_ARTISTIC, "DR129.5"), Ze(qe, Ye.FREESTYLE_HARMONY, "DR129.5"), Ze(qe, Ye.FREESTYLE_CHOREOGRAPHY, "DR129.5"), Ze(qe, Ye.MOVEMENT_TOTALS, "DR211.4"), Ze(qe, Ye.UNRESOLVED, "DR123.3"), Ze(qe, Ye.JUDGE_ENTERED, "DR133.1.k / DR133.2.g.4"), Ze(qe, Ye.RIDE_OFF_REQUIRED, "DR133.2.g.5"), Ze(qe, Ye.DSHB_JUDGE_ENTERED, "DR210.5 / DR204.2.c"), Ze(qe, Ye.DSHB_UNRESOLVED, "DR211.4");
var pt = { PENDING: dn.PENDING, ENTERING_RING: dn.ENTERING_RING, IN_PROGRESS: dn.IN_PROGRESS, CONFIRMED: "CONFIRMED", COMPLETED: dn.COMPLETED, FINAL: "FINAL", SCRATCHED: dn.SCRATCHED, IN_REVIEW: "IN_REVIEW", NEEDS_SIGNING: "NEEDS_SIGNING" }, gl = [fl, "Withdrawal", "Withdrawn", "Withdraw"];
new Set(gl.map(ml));
function ml(e) {
  return typeof e == "string" ? e.trim().toLowerCase().replace(/[^a-z0-9]/g, "") : "";
}
var oe, qs;
(function(e) {
  e.assertEqual = (s) => {
  }, e.assertIs = function(s) {
  }, e.assertNever = function(s) {
    throw new Error();
  }, e.arrayToEnum = (s) => {
    const r = {};
    for (const i of s) r[i] = i;
    return r;
  }, e.getValidEnumValues = (s) => {
    const r = e.objectKeys(s).filter((n) => typeof s[s[n]] != "number"), i = {};
    for (const n of r) i[n] = s[n];
    return e.objectValues(i);
  }, e.objectValues = (s) => e.objectKeys(s).map(function(r) {
    return s[r];
  }), e.objectKeys = typeof Object.keys == "function" ? (s) => Object.keys(s) : (s) => {
    const r = [];
    for (const i in s) Object.prototype.hasOwnProperty.call(s, i) && r.push(i);
    return r;
  }, e.find = (s, r) => {
    for (const i of s) if (r(i)) return i;
  }, e.isInteger = typeof Number.isInteger == "function" ? (s) => Number.isInteger(s) : (s) => typeof s == "number" && Number.isFinite(s) && Math.floor(s) === s, e.joinValues = function(s, r = " | ") {
    return s.map((i) => typeof i == "string" ? `'${i}'` : i).join(r);
  }, e.jsonStringifyReplacer = (s, r) => typeof r == "bigint" ? r.toString() : r;
})(oe || (oe = {})), function(e) {
  e.mergeShapes = (s, r) => ({ ...s, ...r });
}(qs || (qs = {}));
const V = oe.arrayToEnum(["string", "nan", "number", "integer", "float", "boolean", "date", "bigint", "symbol", "function", "undefined", "null", "array", "object", "unknown", "promise", "void", "never", "map", "set"]), xt = (e) => {
  switch (typeof e) {
    case "undefined":
      return V.undefined;
    case "string":
      return V.string;
    case "number":
      return Number.isNaN(e) ? V.nan : V.number;
    case "boolean":
      return V.boolean;
    case "function":
      return V.function;
    case "bigint":
      return V.bigint;
    case "symbol":
      return V.symbol;
    case "object":
      return Array.isArray(e) ? V.array : e === null ? V.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? V.promise : typeof Map < "u" && e instanceof Map ? V.map : typeof Set < "u" && e instanceof Set ? V.set : typeof Date < "u" && e instanceof Date ? V.date : V.object;
    default:
      return V.unknown;
  }
}, N = oe.arrayToEnum(["invalid_type", "invalid_literal", "custom", "invalid_union", "invalid_union_discriminator", "invalid_enum_value", "unrecognized_keys", "invalid_arguments", "invalid_return_type", "invalid_date", "invalid_string", "too_small", "too_big", "invalid_intersection_types", "not_multiple_of", "not_finite"]);
class wt extends Error {
  get errors() {
    return this.issues;
  }
  constructor(s) {
    super(), this.issues = [], this.addIssue = (i) => {
      this.issues = [...this.issues, i];
    }, this.addIssues = (i = []) => {
      this.issues = [...this.issues, ...i];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = s;
  }
  format(s) {
    const r = s || function(t) {
      return t.message;
    }, i = { _errors: [] }, n = (t) => {
      for (const a of t.issues) if (a.code === "invalid_union") a.unionErrors.map(n);
      else if (a.code === "invalid_return_type") n(a.returnTypeError);
      else if (a.code === "invalid_arguments") n(a.argumentsError);
      else if (a.path.length === 0) i._errors.push(r(a));
      else {
        let o = i, u = 0;
        for (; u < a.path.length; ) {
          const l = a.path[u];
          u === a.path.length - 1 ? (o[l] = o[l] || { _errors: [] }, o[l]._errors.push(r(a))) : o[l] = o[l] || { _errors: [] }, o = o[l], u++;
        }
      }
    };
    return n(this), i;
  }
  static assert(s) {
    if (!(s instanceof wt)) throw new Error(`Not a ZodError: ${s}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, oe.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(s = (r) => r.message) {
    const r = {}, i = [];
    for (const n of this.issues) if (n.path.length > 0) {
      const t = n.path[0];
      r[t] = r[t] || [], r[t].push(s(n));
    } else i.push(s(n));
    return { formErrors: i, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
wt.create = (e) => new wt(e);
const qr = (e, s) => {
  let r;
  switch (e.code) {
    case N.invalid_type:
      r = e.received === V.undefined ? "Required" : `Expected ${e.expected}, received ${e.received}`;
      break;
    case N.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, oe.jsonStringifyReplacer)}`;
      break;
    case N.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${oe.joinValues(e.keys, ", ")}`;
      break;
    case N.invalid_union:
      r = "Invalid input";
      break;
    case N.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${oe.joinValues(e.options)}`;
      break;
    case N.invalid_enum_value:
      r = `Invalid enum value. Expected ${oe.joinValues(e.options)}, received '${e.received}'`;
      break;
    case N.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case N.invalid_return_type:
      r = "Invalid function return type";
      break;
    case N.invalid_date:
      r = "Invalid date";
      break;
    case N.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : oe.assertNever(e.validation) : r = e.validation !== "regex" ? `Invalid ${e.validation}` : "Invalid";
      break;
    case N.too_small:
      r = e.type === "array" ? `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" || e.type === "bigint" ? `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : "Invalid input";
      break;
    case N.too_big:
      r = e.type === "array" ? `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : "Invalid input";
      break;
    case N.custom:
      r = "Invalid input";
      break;
    case N.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case N.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case N.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = s.defaultError, oe.assertNever(e);
  }
  return { message: r };
};
let bl = qr;
var H;
(function(e) {
  e.errToObj = (s) => typeof s == "string" ? { message: s } : s || {}, e.toString = (s) => typeof s == "string" ? s : s == null ? void 0 : s.message;
})(H || (H = {}));
function D(e, s) {
  const r = bl, i = ((n) => {
    const { data: t, path: a, errorMaps: o, issueData: u } = n, l = [...a, ...u.path || []], c = { ...u, path: l };
    if (u.message !== void 0) return { ...u, path: l, message: u.message };
    let d = "";
    const h = o.filter((m) => !!m).slice().reverse();
    for (const m of h) d = m(c, { data: t, defaultError: d }).message;
    return { ...u, path: l, message: d };
  })({ issueData: s, data: e.data, path: e.path, errorMaps: [e.common.contextualErrorMap, e.schemaErrorMap, r, r === qr ? void 0 : qr].filter((n) => !!n) });
  e.common.issues.push(i);
}
class Ke {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(s, r) {
    const i = [];
    for (const n of r) {
      if (n.status === "aborted") return Q;
      n.status === "dirty" && s.dirty(), i.push(n.value);
    }
    return { status: s.value, value: i };
  }
  static async mergeObjectAsync(s, r) {
    const i = [];
    for (const n of r) {
      const t = await n.key, a = await n.value;
      i.push({ key: t, value: a });
    }
    return Ke.mergeObjectSync(s, i);
  }
  static mergeObjectSync(s, r) {
    const i = {};
    for (const n of r) {
      const { key: t, value: a } = n;
      if (t.status === "aborted" || a.status === "aborted") return Q;
      t.status === "dirty" && s.dirty(), a.status === "dirty" && s.dirty(), t.value === "__proto__" || a.value === void 0 && !n.alwaysSet || (i[t.value] = a.value);
    }
    return { status: s.value, value: i };
  }
}
const Q = Object.freeze({ status: "aborted" }), Wr = (e) => ({ status: "dirty", value: e }), st = (e) => ({ status: "valid", value: e }), Ws = (e) => e.status === "aborted", Js = (e) => e.status === "dirty", Zt = (e) => e.status === "valid", or = (e) => typeof Promise < "u" && e instanceof Promise;
class lt {
  constructor(s, r, i, n) {
    this._cachedPath = [], this.parent = s, this.data = r, this._path = i, this._key = n;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Zs = (e, s) => {
  if (Zt(s)) return { success: !0, data: s.value };
  if (!e.common.issues.length) throw new Error("Validation failed but no issues detected.");
  return { success: !1, get error() {
    if (this._error) return this._error;
    const r = new wt(e.common.issues);
    return this._error = r, this._error;
  } };
};
function X(e) {
  if (!e) return {};
  const { errorMap: s, invalid_type_error: r, required_error: i, description: n } = e;
  if (s && (r || i)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return s ? { errorMap: s, description: n } : { errorMap: (t, a) => {
    const { message: o } = e;
    return t.code === "invalid_enum_value" ? { message: o ?? a.defaultError } : a.data === void 0 ? { message: o ?? i ?? a.defaultError } : t.code !== "invalid_type" ? { message: a.defaultError } : { message: o ?? r ?? a.defaultError };
  }, description: n };
}
class re {
  get description() {
    return this._def.description;
  }
  _getType(s) {
    return xt(s.data);
  }
  _getOrReturnCtx(s, r) {
    return r || { common: s.parent.common, data: s.data, parsedType: xt(s.data), schemaErrorMap: this._def.errorMap, path: s.path, parent: s.parent };
  }
  _processInputParams(s) {
    return { status: new Ke(), ctx: { common: s.parent.common, data: s.data, parsedType: xt(s.data), schemaErrorMap: this._def.errorMap, path: s.path, parent: s.parent } };
  }
  _parseSync(s) {
    const r = this._parse(s);
    if (or(r)) throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(s) {
    const r = this._parse(s);
    return Promise.resolve(r);
  }
  parse(s, r) {
    const i = this.safeParse(s, r);
    if (i.success) return i.data;
    throw i.error;
  }
  safeParse(s, r) {
    const i = { common: { issues: [], async: (r == null ? void 0 : r.async) ?? !1, contextualErrorMap: r == null ? void 0 : r.errorMap }, path: (r == null ? void 0 : r.path) || [], schemaErrorMap: this._def.errorMap, parent: null, data: s, parsedType: xt(s) }, n = this._parseSync({ data: s, path: i.path, parent: i });
    return Zs(i, n);
  }
  "~validate"(s) {
    var i, n;
    const r = { common: { issues: [], async: !!this["~standard"].async }, path: [], schemaErrorMap: this._def.errorMap, parent: null, data: s, parsedType: xt(s) };
    if (!this["~standard"].async) try {
      const t = this._parseSync({ data: s, path: [], parent: r });
      return Zt(t) ? { value: t.value } : { issues: r.common.issues };
    } catch (t) {
      (n = (i = t == null ? void 0 : t.message) == null ? void 0 : i.toLowerCase()) != null && n.includes("encountered") && (this["~standard"].async = !0), r.common = { issues: [], async: !0 };
    }
    return this._parseAsync({ data: s, path: [], parent: r }).then((t) => Zt(t) ? { value: t.value } : { issues: r.common.issues });
  }
  async parseAsync(s, r) {
    const i = await this.safeParseAsync(s, r);
    if (i.success) return i.data;
    throw i.error;
  }
  async safeParseAsync(s, r) {
    const i = { common: { issues: [], contextualErrorMap: r == null ? void 0 : r.errorMap, async: !0 }, path: (r == null ? void 0 : r.path) || [], schemaErrorMap: this._def.errorMap, parent: null, data: s, parsedType: xt(s) }, n = this._parse({ data: s, path: i.path, parent: i }), t = await (or(n) ? n : Promise.resolve(n));
    return Zs(i, t);
  }
  refine(s, r) {
    const i = (n) => typeof r == "string" || r === void 0 ? { message: r } : typeof r == "function" ? r(n) : r;
    return this._refinement((n, t) => {
      const a = s(n), o = () => t.addIssue({ code: N.custom, ...i(n) });
      return typeof Promise < "u" && a instanceof Promise ? a.then((u) => !!u || (o(), !1)) : !!a || (o(), !1);
    });
  }
  refinement(s, r) {
    return this._refinement((i, n) => !!s(i) || (n.addIssue(typeof r == "function" ? r(i, n) : r), !1));
  }
  _refinement(s) {
    return new Ht({ schema: this, typeName: K.ZodEffects, effect: { type: "refinement", refinement: s } });
  }
  superRefine(s) {
    return this._refinement(s);
  }
  constructor(s) {
    this.spa = this.safeParseAsync, this._def = s, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = { version: 1, vendor: "zod", validate: (r) => this["~validate"](r) };
  }
  optional() {
    return Ct.create(this, this._def);
  }
  nullable() {
    return Qt.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ot.create(this);
  }
  promise() {
    return dr.create(this, this._def);
  }
  or(s) {
    return lr.create([this, s], this._def);
  }
  and(s) {
    return cr.create(this, s, this._def);
  }
  transform(s) {
    return new Ht({ ...X(this._def), schema: this, typeName: K.ZodEffects, effect: { type: "transform", transform: s } });
  }
  default(s) {
    const r = typeof s == "function" ? s : () => s;
    return new Kr({ ...X(this._def), innerType: this, defaultValue: r, typeName: K.ZodDefault });
  }
  brand() {
    return new Fl({ typeName: K.ZodBranded, type: this, ...X(this._def) });
  }
  catch(s) {
    const r = typeof s == "function" ? s : () => s;
    return new Qr({ ...X(this._def), innerType: this, catchValue: r, typeName: K.ZodCatch });
  }
  describe(s) {
    return new this.constructor({ ...this._def, description: s });
  }
  pipe(s) {
    return cs.create(this, s);
  }
  readonly() {
    return Xr.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Sl = /^c[^\s-]{8,}$/i, wl = /^[0-9a-z]+$/, yl = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Rl = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, xl = /^[a-z0-9_-]{21}$/i, Il = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, _l = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Tl = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
let Ar;
const Cl = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, El = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Ol = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, kl = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Al = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Pl = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, na = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", jl = new RegExp(`^${na}$`);
function ra(e) {
  let s = "[0-5]\\d";
  return e.precision ? s = `${s}\\.\\d{${e.precision}}` : e.precision == null && (s = `${s}(\\.\\d+)?`), `([01]\\d|2[0-3]):[0-5]\\d(:${s})${e.precision ? "+" : "?"}`;
}
function Ul(e) {
  let s = `${na}T${ra(e)}`;
  const r = [];
  return r.push(e.local ? "Z?" : "Z"), e.offset && r.push("([+-]\\d{2}:?\\d{2})"), s = `${s}(${r.join("|")})`, new RegExp(`^${s}$`);
}
function Nl(e, s) {
  if (!Il.test(e)) return !1;
  try {
    const [r] = e.split(".");
    if (!r) return !1;
    const i = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), n = JSON.parse(atob(i));
    return !(typeof n != "object" || n === null || "typ" in n && (n == null ? void 0 : n.typ) !== "JWT" || !n.alg || s && n.alg !== s);
  } catch {
    return !1;
  }
}
function Ll(e, s) {
  return !(s !== "v4" && s || !El.test(e)) || !(s !== "v6" && s || !kl.test(e));
}
class St extends re {
  _parse(s) {
    if (this._def.coerce && (s.data = String(s.data)), this._getType(s) !== V.string) {
      const a = this._getOrReturnCtx(s);
      return D(a, { code: N.invalid_type, expected: V.string, received: a.parsedType }), Q;
    }
    const r = new Ke();
    let i;
    for (const a of this._def.checks) if (a.kind === "min") s.data.length < a.value && (i = this._getOrReturnCtx(s, i), D(i, { code: N.too_small, minimum: a.value, type: "string", inclusive: !0, exact: !1, message: a.message }), r.dirty());
    else if (a.kind === "max") s.data.length > a.value && (i = this._getOrReturnCtx(s, i), D(i, { code: N.too_big, maximum: a.value, type: "string", inclusive: !0, exact: !1, message: a.message }), r.dirty());
    else if (a.kind === "length") {
      const o = s.data.length > a.value, u = s.data.length < a.value;
      (o || u) && (i = this._getOrReturnCtx(s, i), o ? D(i, { code: N.too_big, maximum: a.value, type: "string", inclusive: !0, exact: !0, message: a.message }) : u && D(i, { code: N.too_small, minimum: a.value, type: "string", inclusive: !0, exact: !0, message: a.message }), r.dirty());
    } else if (a.kind === "email") Tl.test(s.data) || (i = this._getOrReturnCtx(s, i), D(i, { validation: "email", code: N.invalid_string, message: a.message }), r.dirty());
    else if (a.kind === "emoji") Ar || (Ar = new RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u")), Ar.test(s.data) || (i = this._getOrReturnCtx(s, i), D(i, { validation: "emoji", code: N.invalid_string, message: a.message }), r.dirty());
    else if (a.kind === "uuid") Rl.test(s.data) || (i = this._getOrReturnCtx(s, i), D(i, { validation: "uuid", code: N.invalid_string, message: a.message }), r.dirty());
    else if (a.kind === "nanoid") xl.test(s.data) || (i = this._getOrReturnCtx(s, i), D(i, { validation: "nanoid", code: N.invalid_string, message: a.message }), r.dirty());
    else if (a.kind === "cuid") Sl.test(s.data) || (i = this._getOrReturnCtx(s, i), D(i, { validation: "cuid", code: N.invalid_string, message: a.message }), r.dirty());
    else if (a.kind === "cuid2") wl.test(s.data) || (i = this._getOrReturnCtx(s, i), D(i, { validation: "cuid2", code: N.invalid_string, message: a.message }), r.dirty());
    else if (a.kind === "ulid") yl.test(s.data) || (i = this._getOrReturnCtx(s, i), D(i, { validation: "ulid", code: N.invalid_string, message: a.message }), r.dirty());
    else if (a.kind === "url") try {
      new URL(s.data);
    } catch {
      i = this._getOrReturnCtx(s, i), D(i, { validation: "url", code: N.invalid_string, message: a.message }), r.dirty();
    }
    else a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(s.data) || (i = this._getOrReturnCtx(s, i), D(i, { validation: "regex", code: N.invalid_string, message: a.message }), r.dirty())) : a.kind === "trim" ? s.data = s.data.trim() : a.kind === "includes" ? s.data.includes(a.value, a.position) || (i = this._getOrReturnCtx(s, i), D(i, { code: N.invalid_string, validation: { includes: a.value, position: a.position }, message: a.message }), r.dirty()) : a.kind === "toLowerCase" ? s.data = s.data.toLowerCase() : a.kind === "toUpperCase" ? s.data = s.data.toUpperCase() : a.kind === "startsWith" ? s.data.startsWith(a.value) || (i = this._getOrReturnCtx(s, i), D(i, { code: N.invalid_string, validation: { startsWith: a.value }, message: a.message }), r.dirty()) : a.kind === "endsWith" ? s.data.endsWith(a.value) || (i = this._getOrReturnCtx(s, i), D(i, { code: N.invalid_string, validation: { endsWith: a.value }, message: a.message }), r.dirty()) : a.kind === "datetime" ? Ul(a).test(s.data) || (i = this._getOrReturnCtx(s, i), D(i, { code: N.invalid_string, validation: "datetime", message: a.message }), r.dirty()) : a.kind === "date" ? jl.test(s.data) || (i = this._getOrReturnCtx(s, i), D(i, { code: N.invalid_string, validation: "date", message: a.message }), r.dirty()) : a.kind === "time" ? new RegExp(`^${ra(a)}$`).test(s.data) || (i = this._getOrReturnCtx(s, i), D(i, { code: N.invalid_string, validation: "time", message: a.message }), r.dirty()) : a.kind === "duration" ? _l.test(s.data) || (i = this._getOrReturnCtx(s, i), D(i, { validation: "duration", code: N.invalid_string, message: a.message }), r.dirty()) : a.kind === "ip" ? (n = s.data, ((t = a.version) !== "v4" && t || !Cl.test(n)) && (t !== "v6" && t || !Ol.test(n)) && (i = this._getOrReturnCtx(s, i), D(i, { validation: "ip", code: N.invalid_string, message: a.message }), r.dirty())) : a.kind === "jwt" ? Nl(s.data, a.alg) || (i = this._getOrReturnCtx(s, i), D(i, { validation: "jwt", code: N.invalid_string, message: a.message }), r.dirty()) : a.kind === "cidr" ? Ll(s.data, a.version) || (i = this._getOrReturnCtx(s, i), D(i, { validation: "cidr", code: N.invalid_string, message: a.message }), r.dirty()) : a.kind === "base64" ? Al.test(s.data) || (i = this._getOrReturnCtx(s, i), D(i, { validation: "base64", code: N.invalid_string, message: a.message }), r.dirty()) : a.kind === "base64url" ? Pl.test(s.data) || (i = this._getOrReturnCtx(s, i), D(i, { validation: "base64url", code: N.invalid_string, message: a.message }), r.dirty()) : oe.assertNever(a);
    var n, t;
    return { status: r.value, value: s.data };
  }
  _regex(s, r, i) {
    return this.refinement((n) => s.test(n), { validation: r, code: N.invalid_string, ...H.errToObj(i) });
  }
  _addCheck(s) {
    return new St({ ...this._def, checks: [...this._def.checks, s] });
  }
  email(s) {
    return this._addCheck({ kind: "email", ...H.errToObj(s) });
  }
  url(s) {
    return this._addCheck({ kind: "url", ...H.errToObj(s) });
  }
  emoji(s) {
    return this._addCheck({ kind: "emoji", ...H.errToObj(s) });
  }
  uuid(s) {
    return this._addCheck({ kind: "uuid", ...H.errToObj(s) });
  }
  nanoid(s) {
    return this._addCheck({ kind: "nanoid", ...H.errToObj(s) });
  }
  cuid(s) {
    return this._addCheck({ kind: "cuid", ...H.errToObj(s) });
  }
  cuid2(s) {
    return this._addCheck({ kind: "cuid2", ...H.errToObj(s) });
  }
  ulid(s) {
    return this._addCheck({ kind: "ulid", ...H.errToObj(s) });
  }
  base64(s) {
    return this._addCheck({ kind: "base64", ...H.errToObj(s) });
  }
  base64url(s) {
    return this._addCheck({ kind: "base64url", ...H.errToObj(s) });
  }
  jwt(s) {
    return this._addCheck({ kind: "jwt", ...H.errToObj(s) });
  }
  ip(s) {
    return this._addCheck({ kind: "ip", ...H.errToObj(s) });
  }
  cidr(s) {
    return this._addCheck({ kind: "cidr", ...H.errToObj(s) });
  }
  datetime(s) {
    return typeof s == "string" ? this._addCheck({ kind: "datetime", precision: null, offset: !1, local: !1, message: s }) : this._addCheck({ kind: "datetime", precision: (s == null ? void 0 : s.precision) === void 0 ? null : s == null ? void 0 : s.precision, offset: (s == null ? void 0 : s.offset) ?? !1, local: (s == null ? void 0 : s.local) ?? !1, ...H.errToObj(s == null ? void 0 : s.message) });
  }
  date(s) {
    return this._addCheck({ kind: "date", message: s });
  }
  time(s) {
    return typeof s == "string" ? this._addCheck({ kind: "time", precision: null, message: s }) : this._addCheck({ kind: "time", precision: (s == null ? void 0 : s.precision) === void 0 ? null : s == null ? void 0 : s.precision, ...H.errToObj(s == null ? void 0 : s.message) });
  }
  duration(s) {
    return this._addCheck({ kind: "duration", ...H.errToObj(s) });
  }
  regex(s, r) {
    return this._addCheck({ kind: "regex", regex: s, ...H.errToObj(r) });
  }
  includes(s, r) {
    return this._addCheck({ kind: "includes", value: s, position: r == null ? void 0 : r.position, ...H.errToObj(r == null ? void 0 : r.message) });
  }
  startsWith(s, r) {
    return this._addCheck({ kind: "startsWith", value: s, ...H.errToObj(r) });
  }
  endsWith(s, r) {
    return this._addCheck({ kind: "endsWith", value: s, ...H.errToObj(r) });
  }
  min(s, r) {
    return this._addCheck({ kind: "min", value: s, ...H.errToObj(r) });
  }
  max(s, r) {
    return this._addCheck({ kind: "max", value: s, ...H.errToObj(r) });
  }
  length(s, r) {
    return this._addCheck({ kind: "length", value: s, ...H.errToObj(r) });
  }
  nonempty(s) {
    return this.min(1, H.errToObj(s));
  }
  trim() {
    return new St({ ...this._def, checks: [...this._def.checks, { kind: "trim" }] });
  }
  toLowerCase() {
    return new St({ ...this._def, checks: [...this._def.checks, { kind: "toLowerCase" }] });
  }
  toUpperCase() {
    return new St({ ...this._def, checks: [...this._def.checks, { kind: "toUpperCase" }] });
  }
  get isDatetime() {
    return !!this._def.checks.find((s) => s.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((s) => s.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((s) => s.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((s) => s.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((s) => s.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((s) => s.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((s) => s.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((s) => s.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((s) => s.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((s) => s.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((s) => s.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((s) => s.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((s) => s.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((s) => s.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((s) => s.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((s) => s.kind === "base64url");
  }
  get minLength() {
    let s = null;
    for (const r of this._def.checks) r.kind === "min" && (s === null || r.value > s) && (s = r.value);
    return s;
  }
  get maxLength() {
    let s = null;
    for (const r of this._def.checks) r.kind === "max" && (s === null || r.value < s) && (s = r.value);
    return s;
  }
}
function Dl(e, s) {
  const r = (e.toString().split(".")[1] || "").length, i = (s.toString().split(".")[1] || "").length, n = r > i ? r : i;
  return Number.parseInt(e.toFixed(n).replace(".", "")) % Number.parseInt(s.toFixed(n).replace(".", "")) / 10 ** n;
}
St.create = (e) => new St({ checks: [], typeName: K.ZodString, coerce: (e == null ? void 0 : e.coerce) ?? !1, ...X(e) });
class Yt extends re {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(s) {
    if (this._def.coerce && (s.data = Number(s.data)), this._getType(s) !== V.number) {
      const n = this._getOrReturnCtx(s);
      return D(n, { code: N.invalid_type, expected: V.number, received: n.parsedType }), Q;
    }
    let r;
    const i = new Ke();
    for (const n of this._def.checks) n.kind === "int" ? oe.isInteger(s.data) || (r = this._getOrReturnCtx(s, r), D(r, { code: N.invalid_type, expected: "integer", received: "float", message: n.message }), i.dirty()) : n.kind === "min" ? (n.inclusive ? s.data < n.value : s.data <= n.value) && (r = this._getOrReturnCtx(s, r), D(r, { code: N.too_small, minimum: n.value, type: "number", inclusive: n.inclusive, exact: !1, message: n.message }), i.dirty()) : n.kind === "max" ? (n.inclusive ? s.data > n.value : s.data >= n.value) && (r = this._getOrReturnCtx(s, r), D(r, { code: N.too_big, maximum: n.value, type: "number", inclusive: n.inclusive, exact: !1, message: n.message }), i.dirty()) : n.kind === "multipleOf" ? Dl(s.data, n.value) !== 0 && (r = this._getOrReturnCtx(s, r), D(r, { code: N.not_multiple_of, multipleOf: n.value, message: n.message }), i.dirty()) : n.kind === "finite" ? Number.isFinite(s.data) || (r = this._getOrReturnCtx(s, r), D(r, { code: N.not_finite, message: n.message }), i.dirty()) : oe.assertNever(n);
    return { status: i.value, value: s.data };
  }
  gte(s, r) {
    return this.setLimit("min", s, !0, H.toString(r));
  }
  gt(s, r) {
    return this.setLimit("min", s, !1, H.toString(r));
  }
  lte(s, r) {
    return this.setLimit("max", s, !0, H.toString(r));
  }
  lt(s, r) {
    return this.setLimit("max", s, !1, H.toString(r));
  }
  setLimit(s, r, i, n) {
    return new Yt({ ...this._def, checks: [...this._def.checks, { kind: s, value: r, inclusive: i, message: H.toString(n) }] });
  }
  _addCheck(s) {
    return new Yt({ ...this._def, checks: [...this._def.checks, s] });
  }
  int(s) {
    return this._addCheck({ kind: "int", message: H.toString(s) });
  }
  positive(s) {
    return this._addCheck({ kind: "min", value: 0, inclusive: !1, message: H.toString(s) });
  }
  negative(s) {
    return this._addCheck({ kind: "max", value: 0, inclusive: !1, message: H.toString(s) });
  }
  nonpositive(s) {
    return this._addCheck({ kind: "max", value: 0, inclusive: !0, message: H.toString(s) });
  }
  nonnegative(s) {
    return this._addCheck({ kind: "min", value: 0, inclusive: !0, message: H.toString(s) });
  }
  multipleOf(s, r) {
    return this._addCheck({ kind: "multipleOf", value: s, message: H.toString(r) });
  }
  finite(s) {
    return this._addCheck({ kind: "finite", message: H.toString(s) });
  }
  safe(s) {
    return this._addCheck({ kind: "min", inclusive: !0, value: Number.MIN_SAFE_INTEGER, message: H.toString(s) })._addCheck({ kind: "max", inclusive: !0, value: Number.MAX_SAFE_INTEGER, message: H.toString(s) });
  }
  get minValue() {
    let s = null;
    for (const r of this._def.checks) r.kind === "min" && (s === null || r.value > s) && (s = r.value);
    return s;
  }
  get maxValue() {
    let s = null;
    for (const r of this._def.checks) r.kind === "max" && (s === null || r.value < s) && (s = r.value);
    return s;
  }
  get isInt() {
    return !!this._def.checks.find((s) => s.kind === "int" || s.kind === "multipleOf" && oe.isInteger(s.value));
  }
  get isFinite() {
    let s = null, r = null;
    for (const i of this._def.checks) {
      if (i.kind === "finite" || i.kind === "int" || i.kind === "multipleOf") return !0;
      i.kind === "min" ? (r === null || i.value > r) && (r = i.value) : i.kind === "max" && (s === null || i.value < s) && (s = i.value);
    }
    return Number.isFinite(r) && Number.isFinite(s);
  }
}
Yt.create = (e) => new Yt({ checks: [], typeName: K.ZodNumber, coerce: (e == null ? void 0 : e.coerce) || !1, ...X(e) });
class Cn extends re {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(s) {
    if (this._def.coerce) try {
      s.data = BigInt(s.data);
    } catch {
      return this._getInvalidInput(s);
    }
    if (this._getType(s) !== V.bigint) return this._getInvalidInput(s);
    let r;
    const i = new Ke();
    for (const n of this._def.checks) n.kind === "min" ? (n.inclusive ? s.data < n.value : s.data <= n.value) && (r = this._getOrReturnCtx(s, r), D(r, { code: N.too_small, type: "bigint", minimum: n.value, inclusive: n.inclusive, message: n.message }), i.dirty()) : n.kind === "max" ? (n.inclusive ? s.data > n.value : s.data >= n.value) && (r = this._getOrReturnCtx(s, r), D(r, { code: N.too_big, type: "bigint", maximum: n.value, inclusive: n.inclusive, message: n.message }), i.dirty()) : n.kind === "multipleOf" ? s.data % n.value !== BigInt(0) && (r = this._getOrReturnCtx(s, r), D(r, { code: N.not_multiple_of, multipleOf: n.value, message: n.message }), i.dirty()) : oe.assertNever(n);
    return { status: i.value, value: s.data };
  }
  _getInvalidInput(s) {
    const r = this._getOrReturnCtx(s);
    return D(r, { code: N.invalid_type, expected: V.bigint, received: r.parsedType }), Q;
  }
  gte(s, r) {
    return this.setLimit("min", s, !0, H.toString(r));
  }
  gt(s, r) {
    return this.setLimit("min", s, !1, H.toString(r));
  }
  lte(s, r) {
    return this.setLimit("max", s, !0, H.toString(r));
  }
  lt(s, r) {
    return this.setLimit("max", s, !1, H.toString(r));
  }
  setLimit(s, r, i, n) {
    return new Cn({ ...this._def, checks: [...this._def.checks, { kind: s, value: r, inclusive: i, message: H.toString(n) }] });
  }
  _addCheck(s) {
    return new Cn({ ...this._def, checks: [...this._def.checks, s] });
  }
  positive(s) {
    return this._addCheck({ kind: "min", value: BigInt(0), inclusive: !1, message: H.toString(s) });
  }
  negative(s) {
    return this._addCheck({ kind: "max", value: BigInt(0), inclusive: !1, message: H.toString(s) });
  }
  nonpositive(s) {
    return this._addCheck({ kind: "max", value: BigInt(0), inclusive: !0, message: H.toString(s) });
  }
  nonnegative(s) {
    return this._addCheck({ kind: "min", value: BigInt(0), inclusive: !0, message: H.toString(s) });
  }
  multipleOf(s, r) {
    return this._addCheck({ kind: "multipleOf", value: s, message: H.toString(r) });
  }
  get minValue() {
    let s = null;
    for (const r of this._def.checks) r.kind === "min" && (s === null || r.value > s) && (s = r.value);
    return s;
  }
  get maxValue() {
    let s = null;
    for (const r of this._def.checks) r.kind === "max" && (s === null || r.value < s) && (s = r.value);
    return s;
  }
}
Cn.create = (e) => new Cn({ checks: [], typeName: K.ZodBigInt, coerce: (e == null ? void 0 : e.coerce) ?? !1, ...X(e) });
class Jr extends re {
  _parse(s) {
    if (this._def.coerce && (s.data = !!s.data), this._getType(s) !== V.boolean) {
      const r = this._getOrReturnCtx(s);
      return D(r, { code: N.invalid_type, expected: V.boolean, received: r.parsedType }), Q;
    }
    return st(s.data);
  }
}
Jr.create = (e) => new Jr({ typeName: K.ZodBoolean, coerce: (e == null ? void 0 : e.coerce) || !1, ...X(e) });
class ur extends re {
  _parse(s) {
    if (this._def.coerce && (s.data = new Date(s.data)), this._getType(s) !== V.date) {
      const n = this._getOrReturnCtx(s);
      return D(n, { code: N.invalid_type, expected: V.date, received: n.parsedType }), Q;
    }
    if (Number.isNaN(s.data.getTime())) return D(this._getOrReturnCtx(s), { code: N.invalid_date }), Q;
    const r = new Ke();
    let i;
    for (const n of this._def.checks) n.kind === "min" ? s.data.getTime() < n.value && (i = this._getOrReturnCtx(s, i), D(i, { code: N.too_small, message: n.message, inclusive: !0, exact: !1, minimum: n.value, type: "date" }), r.dirty()) : n.kind === "max" ? s.data.getTime() > n.value && (i = this._getOrReturnCtx(s, i), D(i, { code: N.too_big, message: n.message, inclusive: !0, exact: !1, maximum: n.value, type: "date" }), r.dirty()) : oe.assertNever(n);
    return { status: r.value, value: new Date(s.data.getTime()) };
  }
  _addCheck(s) {
    return new ur({ ...this._def, checks: [...this._def.checks, s] });
  }
  min(s, r) {
    return this._addCheck({ kind: "min", value: s.getTime(), message: H.toString(r) });
  }
  max(s, r) {
    return this._addCheck({ kind: "max", value: s.getTime(), message: H.toString(r) });
  }
  get minDate() {
    let s = null;
    for (const r of this._def.checks) r.kind === "min" && (s === null || r.value > s) && (s = r.value);
    return s != null ? new Date(s) : null;
  }
  get maxDate() {
    let s = null;
    for (const r of this._def.checks) r.kind === "max" && (s === null || r.value < s) && (s = r.value);
    return s != null ? new Date(s) : null;
  }
}
ur.create = (e) => new ur({ checks: [], coerce: (e == null ? void 0 : e.coerce) || !1, typeName: K.ZodDate, ...X(e) });
class Ys extends re {
  _parse(s) {
    if (this._getType(s) !== V.symbol) {
      const r = this._getOrReturnCtx(s);
      return D(r, { code: N.invalid_type, expected: V.symbol, received: r.parsedType }), Q;
    }
    return st(s.data);
  }
}
Ys.create = (e) => new Ys({ typeName: K.ZodSymbol, ...X(e) });
class Ks extends re {
  _parse(s) {
    if (this._getType(s) !== V.undefined) {
      const r = this._getOrReturnCtx(s);
      return D(r, { code: N.invalid_type, expected: V.undefined, received: r.parsedType }), Q;
    }
    return st(s.data);
  }
}
Ks.create = (e) => new Ks({ typeName: K.ZodUndefined, ...X(e) });
class Qs extends re {
  _parse(s) {
    if (this._getType(s) !== V.null) {
      const r = this._getOrReturnCtx(s);
      return D(r, { code: N.invalid_type, expected: V.null, received: r.parsedType }), Q;
    }
    return st(s.data);
  }
}
Qs.create = (e) => new Qs({ typeName: K.ZodNull, ...X(e) });
class Xs extends re {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(s) {
    return st(s.data);
  }
}
Xs.create = (e) => new Xs({ typeName: K.ZodAny, ...X(e) });
class ei extends re {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(s) {
    return st(s.data);
  }
}
ei.create = (e) => new ei({ typeName: K.ZodUnknown, ...X(e) });
class Tt extends re {
  _parse(s) {
    const r = this._getOrReturnCtx(s);
    return D(r, { code: N.invalid_type, expected: V.never, received: r.parsedType }), Q;
  }
}
Tt.create = (e) => new Tt({ typeName: K.ZodNever, ...X(e) });
class ti extends re {
  _parse(s) {
    if (this._getType(s) !== V.undefined) {
      const r = this._getOrReturnCtx(s);
      return D(r, { code: N.invalid_type, expected: V.void, received: r.parsedType }), Q;
    }
    return st(s.data);
  }
}
ti.create = (e) => new ti({ typeName: K.ZodVoid, ...X(e) });
class ot extends re {
  _parse(s) {
    const { ctx: r, status: i } = this._processInputParams(s), n = this._def;
    if (r.parsedType !== V.array) return D(r, { code: N.invalid_type, expected: V.array, received: r.parsedType }), Q;
    if (n.exactLength !== null) {
      const a = r.data.length > n.exactLength.value, o = r.data.length < n.exactLength.value;
      (a || o) && (D(r, { code: a ? N.too_big : N.too_small, minimum: o ? n.exactLength.value : void 0, maximum: a ? n.exactLength.value : void 0, type: "array", inclusive: !0, exact: !0, message: n.exactLength.message }), i.dirty());
    }
    if (n.minLength !== null && r.data.length < n.minLength.value && (D(r, { code: N.too_small, minimum: n.minLength.value, type: "array", inclusive: !0, exact: !1, message: n.minLength.message }), i.dirty()), n.maxLength !== null && r.data.length > n.maxLength.value && (D(r, { code: N.too_big, maximum: n.maxLength.value, type: "array", inclusive: !0, exact: !1, message: n.maxLength.message }), i.dirty()), r.common.async) return Promise.all([...r.data].map((a, o) => n.type._parseAsync(new lt(r, a, r.path, o)))).then((a) => Ke.mergeArray(i, a));
    const t = [...r.data].map((a, o) => n.type._parseSync(new lt(r, a, r.path, o)));
    return Ke.mergeArray(i, t);
  }
  get element() {
    return this._def.type;
  }
  min(s, r) {
    return new ot({ ...this._def, minLength: { value: s, message: H.toString(r) } });
  }
  max(s, r) {
    return new ot({ ...this._def, maxLength: { value: s, message: H.toString(r) } });
  }
  length(s, r) {
    return new ot({ ...this._def, exactLength: { value: s, message: H.toString(r) } });
  }
  nonempty(s) {
    return this.min(1, s);
  }
}
function Gt(e) {
  if (e instanceof Me) {
    const s = {};
    for (const r in e.shape) {
      const i = e.shape[r];
      s[r] = Ct.create(Gt(i));
    }
    return new Me({ ...e._def, shape: () => s });
  }
  return e instanceof ot ? new ot({ ...e._def, type: Gt(e.element) }) : e instanceof Ct ? Ct.create(Gt(e.unwrap())) : e instanceof Qt ? Qt.create(Gt(e.unwrap())) : e instanceof jt ? jt.create(e.items.map((s) => Gt(s))) : e;
}
ot.create = (e, s) => new ot({ type: e, minLength: null, maxLength: null, exactLength: null, typeName: K.ZodArray, ...X(s) });
class Me extends re {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null) return this._cached;
    const s = this._def.shape(), r = oe.objectKeys(s);
    return this._cached = { shape: s, keys: r }, this._cached;
  }
  _parse(s) {
    if (this._getType(s) !== V.object) {
      const u = this._getOrReturnCtx(s);
      return D(u, { code: N.invalid_type, expected: V.object, received: u.parsedType }), Q;
    }
    const { status: r, ctx: i } = this._processInputParams(s), { shape: n, keys: t } = this._getCached(), a = [];
    if (!(this._def.catchall instanceof Tt && this._def.unknownKeys === "strip")) for (const u in i.data) t.includes(u) || a.push(u);
    const o = [];
    for (const u of t) {
      const l = n[u], c = i.data[u];
      o.push({ key: { status: "valid", value: u }, value: l._parse(new lt(i, c, i.path, u)), alwaysSet: u in i.data });
    }
    if (this._def.catchall instanceof Tt) {
      const u = this._def.unknownKeys;
      if (u === "passthrough") for (const l of a) o.push({ key: { status: "valid", value: l }, value: { status: "valid", value: i.data[l] } });
      else if (u === "strict") a.length > 0 && (D(i, { code: N.unrecognized_keys, keys: a }), r.dirty());
      else if (u !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const l of a) {
        const c = i.data[l];
        o.push({ key: { status: "valid", value: l }, value: u._parse(new lt(i, c, i.path, l)), alwaysSet: l in i.data });
      }
    }
    return i.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const l of o) {
        const c = await l.key, d = await l.value;
        u.push({ key: c, value: d, alwaysSet: l.alwaysSet });
      }
      return u;
    }).then((u) => Ke.mergeObjectSync(r, u)) : Ke.mergeObjectSync(r, o);
  }
  get shape() {
    return this._def.shape();
  }
  strict(s) {
    return H.errToObj, new Me({ ...this._def, unknownKeys: "strict", ...s !== void 0 ? { errorMap: (r, i) => {
      var t, a;
      const n = ((a = (t = this._def).errorMap) == null ? void 0 : a.call(t, r, i).message) ?? i.defaultError;
      return r.code === "unrecognized_keys" ? { message: H.errToObj(s).message ?? n } : { message: n };
    } } : {} });
  }
  strip() {
    return new Me({ ...this._def, unknownKeys: "strip" });
  }
  passthrough() {
    return new Me({ ...this._def, unknownKeys: "passthrough" });
  }
  extend(s) {
    return new Me({ ...this._def, shape: () => ({ ...this._def.shape(), ...s }) });
  }
  merge(s) {
    return new Me({ unknownKeys: s._def.unknownKeys, catchall: s._def.catchall, shape: () => ({ ...this._def.shape(), ...s._def.shape() }), typeName: K.ZodObject });
  }
  setKey(s, r) {
    return this.augment({ [s]: r });
  }
  catchall(s) {
    return new Me({ ...this._def, catchall: s });
  }
  pick(s) {
    const r = {};
    for (const i of oe.objectKeys(s)) s[i] && this.shape[i] && (r[i] = this.shape[i]);
    return new Me({ ...this._def, shape: () => r });
  }
  omit(s) {
    const r = {};
    for (const i of oe.objectKeys(this.shape)) s[i] || (r[i] = this.shape[i]);
    return new Me({ ...this._def, shape: () => r });
  }
  deepPartial() {
    return Gt(this);
  }
  partial(s) {
    const r = {};
    for (const i of oe.objectKeys(this.shape)) {
      const n = this.shape[i];
      s && !s[i] ? r[i] = n : r[i] = n.optional();
    }
    return new Me({ ...this._def, shape: () => r });
  }
  required(s) {
    const r = {};
    for (const i of oe.objectKeys(this.shape)) if (s && !s[i]) r[i] = this.shape[i];
    else {
      let n = this.shape[i];
      for (; n instanceof Ct; ) n = n._def.innerType;
      r[i] = n;
    }
    return new Me({ ...this._def, shape: () => r });
  }
  keyof() {
    return sa(oe.objectKeys(this.shape));
  }
}
Me.create = (e, s) => new Me({ shape: () => e, unknownKeys: "strip", catchall: Tt.create(), typeName: K.ZodObject, ...X(s) }), Me.strictCreate = (e, s) => new Me({ shape: () => e, unknownKeys: "strict", catchall: Tt.create(), typeName: K.ZodObject, ...X(s) }), Me.lazycreate = (e, s) => new Me({ shape: e, unknownKeys: "strip", catchall: Tt.create(), typeName: K.ZodObject, ...X(s) });
class lr extends re {
  _parse(s) {
    const { ctx: r } = this._processInputParams(s), i = this._def.options;
    if (r.common.async) return Promise.all(i.map(async (n) => {
      const t = { ...r, common: { ...r.common, issues: [] }, parent: null };
      return { result: await n._parseAsync({ data: r.data, path: r.path, parent: t }), ctx: t };
    })).then(function(n) {
      for (const a of n) if (a.result.status === "valid") return a.result;
      for (const a of n) if (a.result.status === "dirty") return r.common.issues.push(...a.ctx.common.issues), a.result;
      const t = n.map((a) => new wt(a.ctx.common.issues));
      return D(r, { code: N.invalid_union, unionErrors: t }), Q;
    });
    {
      let n;
      const t = [];
      for (const o of i) {
        const u = { ...r, common: { ...r.common, issues: [] }, parent: null }, l = o._parseSync({ data: r.data, path: r.path, parent: u });
        if (l.status === "valid") return l;
        l.status !== "dirty" || n || (n = { result: l, ctx: u }), u.common.issues.length && t.push(u.common.issues);
      }
      if (n) return r.common.issues.push(...n.ctx.common.issues), n.result;
      const a = t.map((o) => new wt(o));
      return D(r, { code: N.invalid_union, unionErrors: a }), Q;
    }
  }
  get options() {
    return this._def.options;
  }
}
function Zr(e, s) {
  const r = xt(e), i = xt(s);
  if (e === s) return { valid: !0, data: e };
  if (r === V.object && i === V.object) {
    const n = oe.objectKeys(s), t = oe.objectKeys(e).filter((o) => n.indexOf(o) !== -1), a = { ...e, ...s };
    for (const o of t) {
      const u = Zr(e[o], s[o]);
      if (!u.valid) return { valid: !1 };
      a[o] = u.data;
    }
    return { valid: !0, data: a };
  }
  if (r === V.array && i === V.array) {
    if (e.length !== s.length) return { valid: !1 };
    const n = [];
    for (let t = 0; t < e.length; t++) {
      const a = Zr(e[t], s[t]);
      if (!a.valid) return { valid: !1 };
      n.push(a.data);
    }
    return { valid: !0, data: n };
  }
  return r === V.date && i === V.date && +e == +s ? { valid: !0, data: e } : { valid: !1 };
}
lr.create = (e, s) => new lr({ options: e, typeName: K.ZodUnion, ...X(s) });
class cr extends re {
  _parse(s) {
    const { status: r, ctx: i } = this._processInputParams(s), n = (t, a) => {
      if (Ws(t) || Ws(a)) return Q;
      const o = Zr(t.value, a.value);
      return o.valid ? ((Js(t) || Js(a)) && r.dirty(), { status: r.value, value: o.data }) : (D(i, { code: N.invalid_intersection_types }), Q);
    };
    return i.common.async ? Promise.all([this._def.left._parseAsync({ data: i.data, path: i.path, parent: i }), this._def.right._parseAsync({ data: i.data, path: i.path, parent: i })]).then(([t, a]) => n(t, a)) : n(this._def.left._parseSync({ data: i.data, path: i.path, parent: i }), this._def.right._parseSync({ data: i.data, path: i.path, parent: i }));
  }
}
cr.create = (e, s, r) => new cr({ left: e, right: s, typeName: K.ZodIntersection, ...X(r) });
class jt extends re {
  _parse(s) {
    const { status: r, ctx: i } = this._processInputParams(s);
    if (i.parsedType !== V.array) return D(i, { code: N.invalid_type, expected: V.array, received: i.parsedType }), Q;
    if (i.data.length < this._def.items.length) return D(i, { code: N.too_small, minimum: this._def.items.length, inclusive: !0, exact: !1, type: "array" }), Q;
    !this._def.rest && i.data.length > this._def.items.length && (D(i, { code: N.too_big, maximum: this._def.items.length, inclusive: !0, exact: !1, type: "array" }), r.dirty());
    const n = [...i.data].map((t, a) => {
      const o = this._def.items[a] || this._def.rest;
      return o ? o._parse(new lt(i, t, i.path, a)) : null;
    }).filter((t) => !!t);
    return i.common.async ? Promise.all(n).then((t) => Ke.mergeArray(r, t)) : Ke.mergeArray(r, n);
  }
  get items() {
    return this._def.items;
  }
  rest(s) {
    return new jt({ ...this._def, rest: s });
  }
}
jt.create = (e, s) => {
  if (!Array.isArray(e)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new jt({ items: e, typeName: K.ZodTuple, rest: null, ...X(s) });
};
class ls extends re {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(s) {
    const { status: r, ctx: i } = this._processInputParams(s);
    if (i.parsedType !== V.object) return D(i, { code: N.invalid_type, expected: V.object, received: i.parsedType }), Q;
    const n = [], t = this._def.keyType, a = this._def.valueType;
    for (const o in i.data) n.push({ key: t._parse(new lt(i, o, i.path, o)), value: a._parse(new lt(i, i.data[o], i.path, o)), alwaysSet: o in i.data });
    return i.common.async ? Ke.mergeObjectAsync(r, n) : Ke.mergeObjectSync(r, n);
  }
  get element() {
    return this._def.valueType;
  }
  static create(s, r, i) {
    return new ls(r instanceof re ? { keyType: s, valueType: r, typeName: K.ZodRecord, ...X(i) } : { keyType: St.create(), valueType: s, typeName: K.ZodRecord, ...X(r) });
  }
}
class ni extends re {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(s) {
    const { status: r, ctx: i } = this._processInputParams(s);
    if (i.parsedType !== V.map) return D(i, { code: N.invalid_type, expected: V.map, received: i.parsedType }), Q;
    const n = this._def.keyType, t = this._def.valueType, a = [...i.data.entries()].map(([o, u], l) => ({ key: n._parse(new lt(i, o, i.path, [l, "key"])), value: t._parse(new lt(i, u, i.path, [l, "value"])) }));
    if (i.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of a) {
          const l = await u.key, c = await u.value;
          if (l.status === "aborted" || c.status === "aborted") return Q;
          l.status !== "dirty" && c.status !== "dirty" || r.dirty(), o.set(l.value, c.value);
        }
        return { status: r.value, value: o };
      });
    }
    {
      const o = /* @__PURE__ */ new Map();
      for (const u of a) {
        const l = u.key, c = u.value;
        if (l.status === "aborted" || c.status === "aborted") return Q;
        l.status !== "dirty" && c.status !== "dirty" || r.dirty(), o.set(l.value, c.value);
      }
      return { status: r.value, value: o };
    }
  }
}
ni.create = (e, s, r) => new ni({ valueType: s, keyType: e, typeName: K.ZodMap, ...X(r) });
class En extends re {
  _parse(s) {
    const { status: r, ctx: i } = this._processInputParams(s);
    if (i.parsedType !== V.set) return D(i, { code: N.invalid_type, expected: V.set, received: i.parsedType }), Q;
    const n = this._def;
    n.minSize !== null && i.data.size < n.minSize.value && (D(i, { code: N.too_small, minimum: n.minSize.value, type: "set", inclusive: !0, exact: !1, message: n.minSize.message }), r.dirty()), n.maxSize !== null && i.data.size > n.maxSize.value && (D(i, { code: N.too_big, maximum: n.maxSize.value, type: "set", inclusive: !0, exact: !1, message: n.maxSize.message }), r.dirty());
    const t = this._def.valueType;
    function a(u) {
      const l = /* @__PURE__ */ new Set();
      for (const c of u) {
        if (c.status === "aborted") return Q;
        c.status === "dirty" && r.dirty(), l.add(c.value);
      }
      return { status: r.value, value: l };
    }
    const o = [...i.data.values()].map((u, l) => t._parse(new lt(i, u, i.path, l)));
    return i.common.async ? Promise.all(o).then((u) => a(u)) : a(o);
  }
  min(s, r) {
    return new En({ ...this._def, minSize: { value: s, message: H.toString(r) } });
  }
  max(s, r) {
    return new En({ ...this._def, maxSize: { value: s, message: H.toString(r) } });
  }
  size(s, r) {
    return this.min(s, r).max(s, r);
  }
  nonempty(s) {
    return this.min(1, s);
  }
}
En.create = (e, s) => new En({ valueType: e, minSize: null, maxSize: null, typeName: K.ZodSet, ...X(s) });
class ri extends re {
  get schema() {
    return this._def.getter();
  }
  _parse(s) {
    const { ctx: r } = this._processInputParams(s);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
ri.create = (e, s) => new ri({ getter: e, typeName: K.ZodLazy, ...X(s) });
class Yr extends re {
  _parse(s) {
    if (s.data !== this._def.value) {
      const r = this._getOrReturnCtx(s);
      return D(r, { received: r.data, code: N.invalid_literal, expected: this._def.value }), Q;
    }
    return { status: "valid", value: s.data };
  }
  get value() {
    return this._def.value;
  }
}
function sa(e, s) {
  return new Kt({ values: e, typeName: K.ZodEnum, ...X(s) });
}
Yr.create = (e, s) => new Yr({ value: e, typeName: K.ZodLiteral, ...X(s) });
class Kt extends re {
  _parse(s) {
    if (typeof s.data != "string") {
      const r = this._getOrReturnCtx(s), i = this._def.values;
      return D(r, { expected: oe.joinValues(i), received: r.parsedType, code: N.invalid_type }), Q;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(s.data)) {
      const r = this._getOrReturnCtx(s), i = this._def.values;
      return D(r, { received: r.data, code: N.invalid_enum_value, options: i }), Q;
    }
    return st(s.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const s = {};
    for (const r of this._def.values) s[r] = r;
    return s;
  }
  get Values() {
    const s = {};
    for (const r of this._def.values) s[r] = r;
    return s;
  }
  get Enum() {
    const s = {};
    for (const r of this._def.values) s[r] = r;
    return s;
  }
  extract(s, r = this._def) {
    return Kt.create(s, { ...this._def, ...r });
  }
  exclude(s, r = this._def) {
    return Kt.create(this.options.filter((i) => !s.includes(i)), { ...this._def, ...r });
  }
}
Kt.create = sa;
class si extends re {
  _parse(s) {
    const r = oe.getValidEnumValues(this._def.values), i = this._getOrReturnCtx(s);
    if (i.parsedType !== V.string && i.parsedType !== V.number) {
      const n = oe.objectValues(r);
      return D(i, { expected: oe.joinValues(n), received: i.parsedType, code: N.invalid_type }), Q;
    }
    if (this._cache || (this._cache = new Set(oe.getValidEnumValues(this._def.values))), !this._cache.has(s.data)) {
      const n = oe.objectValues(r);
      return D(i, { received: i.data, code: N.invalid_enum_value, options: n }), Q;
    }
    return st(s.data);
  }
  get enum() {
    return this._def.values;
  }
}
si.create = (e, s) => new si({ values: e, typeName: K.ZodNativeEnum, ...X(s) });
class dr extends re {
  unwrap() {
    return this._def.type;
  }
  _parse(s) {
    const { ctx: r } = this._processInputParams(s);
    if (r.parsedType !== V.promise && r.common.async === !1) return D(r, { code: N.invalid_type, expected: V.promise, received: r.parsedType }), Q;
    const i = r.parsedType === V.promise ? r.data : Promise.resolve(r.data);
    return st(i.then((n) => this._def.type.parseAsync(n, { path: r.path, errorMap: r.common.contextualErrorMap })));
  }
}
dr.create = (e, s) => new dr({ type: e, typeName: K.ZodPromise, ...X(s) });
class Ht extends re {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === K.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(s) {
    const { status: r, ctx: i } = this._processInputParams(s), n = this._def.effect || null, t = { addIssue: (a) => {
      D(i, a), a.fatal ? r.abort() : r.dirty();
    }, get path() {
      return i.path;
    } };
    if (t.addIssue = t.addIssue.bind(t), n.type === "preprocess") {
      const a = n.transform(i.data, t);
      if (i.common.async) return Promise.resolve(a).then(async (o) => {
        if (r.value === "aborted") return Q;
        const u = await this._def.schema._parseAsync({ data: o, path: i.path, parent: i });
        return u.status === "aborted" ? Q : u.status === "dirty" || r.value === "dirty" ? Wr(u.value) : u;
      });
      {
        if (r.value === "aborted") return Q;
        const o = this._def.schema._parseSync({ data: a, path: i.path, parent: i });
        return o.status === "aborted" ? Q : o.status === "dirty" || r.value === "dirty" ? Wr(o.value) : o;
      }
    }
    if (n.type === "refinement") {
      const a = (o) => {
        const u = n.refinement(o, t);
        if (i.common.async) return Promise.resolve(u);
        if (u instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (i.common.async === !1) {
        const o = this._def.schema._parseSync({ data: i.data, path: i.path, parent: i });
        return o.status === "aborted" ? Q : (o.status === "dirty" && r.dirty(), a(o.value), { status: r.value, value: o.value });
      }
      return this._def.schema._parseAsync({ data: i.data, path: i.path, parent: i }).then((o) => o.status === "aborted" ? Q : (o.status === "dirty" && r.dirty(), a(o.value).then(() => ({ status: r.value, value: o.value }))));
    }
    if (n.type === "transform") {
      if (i.common.async === !1) {
        const a = this._def.schema._parseSync({ data: i.data, path: i.path, parent: i });
        if (!Zt(a)) return Q;
        const o = n.transform(a.value, t);
        if (o instanceof Promise) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: o };
      }
      return this._def.schema._parseAsync({ data: i.data, path: i.path, parent: i }).then((a) => Zt(a) ? Promise.resolve(n.transform(a.value, t)).then((o) => ({ status: r.value, value: o })) : Q);
    }
    oe.assertNever(n);
  }
}
Ht.create = (e, s, r) => new Ht({ schema: e, typeName: K.ZodEffects, effect: s, ...X(r) }), Ht.createWithPreprocess = (e, s, r) => new Ht({ schema: s, effect: { type: "preprocess", transform: e }, typeName: K.ZodEffects, ...X(r) });
class Ct extends re {
  _parse(s) {
    return this._getType(s) === V.undefined ? st(void 0) : this._def.innerType._parse(s);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ct.create = (e, s) => new Ct({ innerType: e, typeName: K.ZodOptional, ...X(s) });
class Qt extends re {
  _parse(s) {
    return this._getType(s) === V.null ? st(null) : this._def.innerType._parse(s);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Qt.create = (e, s) => new Qt({ innerType: e, typeName: K.ZodNullable, ...X(s) });
class Kr extends re {
  _parse(s) {
    const { ctx: r } = this._processInputParams(s);
    let i = r.data;
    return r.parsedType === V.undefined && (i = this._def.defaultValue()), this._def.innerType._parse({ data: i, path: r.path, parent: r });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Kr.create = (e, s) => new Kr({ innerType: e, typeName: K.ZodDefault, defaultValue: typeof s.default == "function" ? s.default : () => s.default, ...X(s) });
class Qr extends re {
  _parse(s) {
    const { ctx: r } = this._processInputParams(s), i = { ...r, common: { ...r.common, issues: [] } }, n = this._def.innerType._parse({ data: i.data, path: i.path, parent: { ...i } });
    return or(n) ? n.then((t) => ({ status: "valid", value: t.status === "valid" ? t.value : this._def.catchValue({ get error() {
      return new wt(i.common.issues);
    }, input: i.data }) })) : { status: "valid", value: n.status === "valid" ? n.value : this._def.catchValue({ get error() {
      return new wt(i.common.issues);
    }, input: i.data }) };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Qr.create = (e, s) => new Qr({ innerType: e, typeName: K.ZodCatch, catchValue: typeof s.catch == "function" ? s.catch : () => s.catch, ...X(s) });
class ii extends re {
  _parse(s) {
    if (this._getType(s) !== V.nan) {
      const r = this._getOrReturnCtx(s);
      return D(r, { code: N.invalid_type, expected: V.nan, received: r.parsedType }), Q;
    }
    return { status: "valid", value: s.data };
  }
}
ii.create = (e) => new ii({ typeName: K.ZodNaN, ...X(e) });
class Fl extends re {
  _parse(s) {
    const { ctx: r } = this._processInputParams(s), i = r.data;
    return this._def.type._parse({ data: i, path: r.path, parent: r });
  }
  unwrap() {
    return this._def.type;
  }
}
class cs extends re {
  _parse(s) {
    const { status: r, ctx: i } = this._processInputParams(s);
    if (i.common.async) return (async () => {
      const n = await this._def.in._parseAsync({ data: i.data, path: i.path, parent: i });
      return n.status === "aborted" ? Q : n.status === "dirty" ? (r.dirty(), Wr(n.value)) : this._def.out._parseAsync({ data: n.value, path: i.path, parent: i });
    })();
    {
      const n = this._def.in._parseSync({ data: i.data, path: i.path, parent: i });
      return n.status === "aborted" ? Q : n.status === "dirty" ? (r.dirty(), { status: "dirty", value: n.value }) : this._def.out._parseSync({ data: n.value, path: i.path, parent: i });
    }
  }
  static create(s, r) {
    return new cs({ in: s, out: r, typeName: K.ZodPipeline });
  }
}
class Xr extends re {
  _parse(s) {
    const r = this._def.innerType._parse(s), i = (n) => (Zt(n) && (n.value = Object.freeze(n.value)), n);
    return or(r) ? r.then((n) => i(n)) : i(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
var K;
Xr.create = (e, s) => new Xr({ innerType: e, typeName: K.ZodReadonly, ...X(s) }), function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
}(K || (K = {}));
const O = St.create, J = Yt.create, Xe = Jr.create, He = (Tt.create, ot.create), te = Me.create, qn = lr.create, ia = (cr.create, jt.create, ls.create), aa = Yr.create, we = Kt.create;
dr.create, Ct.create, Qt.create;
var oa = J().min(0).max(Jt).refine(function(e) {
  return Math.abs(Math.round(10 * e) - 10 * e) < 1e-6;
}, { message: "score must be a multiple of 0.1" }), ua = we(["N", "C"]);
te({ status: we(["confirmed", "inferred", "unmapped"]), confidence: we(["high", "medium", "low"]), signals: He(O()), confirmedBy: O().nullable(), confirmedAt: O().nullable(), source: we(["reviewer", "auto"]) });
var la = te({ id: O().optional(), type: ua.default("N"), movementNumber: J().int().positive(), description: O(), directive: O().optional(), location: O().optional(), coefficient: J().min(0.01).max(10), section: we(["technical", "artistic", "quality"]).optional() }), Ml = te({ id: O().optional(), type: ua.default("C"), movementNumber: J().int().positive(), name: O(), directive: O().optional(), coefficient: J().min(0.01).max(10) }), Vl = la.extend({ displayOrder: J() }), Gl = te({ added: He(Vl).default([]), removed: He(J().int().positive()).default([]) }), ca = ["standard", "small", "both"], da = te({ standard: J().int().positive().nullable().optional(), small: J().int().positive().nullable().optional() }), Hl = te({ arena: we(ca).nullable().optional(), averageRideTime: da.nullable().optional() });
te({ id: O(), fvdId: qn([J(), O()]).nullable().optional(), source: we(["catalog", "custom"]).optional(), testCode: O(), organization: O().optional(), level: O().optional(), testNumber: J().int().optional(), movements: He(la), collectives: He(Ml), arena: we(ca).nullable().optional(), averageRideTime: da.nullable().optional(), purpose: O().optional(), introduce: O().optional(), errorRule: te({ unit: we(["points", "percent"]).optional(), first: qn([J(), O()]).nullable().optional(), second: qn([J(), O()]).nullable().optional(), third: qn([J(), O()]).nullable().optional() }).nullable().optional(), collectivesLabel: O().default("Collective Marks"), commentMode: we(["perMovement", "generalOnly"]).default("perMovement"), hasRideTiming: Xe().default(!0), sheetLayout: we(["movement-grid", "class-grid"]).default("movement-grid"), observations: He(te({ key: O(), group: O(), label: O(), optional: aa(!0) })).default([]), panel: te({ minJudges: J().int().positive(), maxJudges: J().int().positive(), consensus: Xe().default(!1), judgeFloor: J().int().positive().optional(), judgeFloorRule: O().optional() }).optional(), placing: te({ source: we(["computed", "judge-entered"]).default("computed"), tieBreak: we(["standard", "none", "ride-off", "movement-totals"]).default("standard") }).optional(), publication: te({ scoreSheet: we(["public", "suppressed"]).default("public"), rule: O().optional() }).optional() });
var zl = te({ movementNumber: J().int().positive(), score: oa.optional().nullable(), remarks: O().max(500).optional(), flagged: Xe().default(!1), annotatedDirective: O().optional(), annotatedDescription: O().optional(), deductions: He(te({ id: O(), reason: O(), points: J().positive() })).optional() }), $l = te({ score: oa.optional(), remarks: O().max(500).optional(), flagged: Xe().optional(), annotatedName: O().optional(), annotatedDirective: O().optional() }), Bl = ia(O().regex(/^\d+$/), $l), ql = te({ id: O(), movementNumber: J().int().nullable().optional(), text: O().min(1).max(1e3), addedBy: O().nullable(), addedAt: O() });
te({ id: O().optional(), rideId: O(), judgeId: O(), testId: O(), movementScores: He(zl).default([]), collectives: Bl.default({}), annotations: He(ql).default([]), annotatedPurpose: O().optional(), annotatedIntroduce: O().optional(), generalRemarks: O().max(2e3).optional(), entryTimeSeconds: J().nonnegative().optional(), totalPoints: J().optional(), maxPoints: J().optional(), percentage: J().nullable().optional(), observationMarks: ia(O(), J()).optional(), place: J().int().positive().nullable().optional(), technicalPoints: J().optional(), technicalMaxPoints: J().optional(), artisticPoints: J().optional(), artisticMaxPoints: J().optional(), qualityPoints: J().optional(), qualityMaxPoints: J().optional(), judgeSignature: O().optional(), signature: te({ judgeId: O(), signatureHash: O(), signedAt: O() }).optional(), signatures: He(te({ judgeId: O(), signatureHash: O(), signedAt: O() })).optional(), compositeSignatures: He(te({ realJudgeId: O(), signatureHash: O(), signedAt: O() })).optional(), authoritative: Xe().optional(), contenderOf: O().nullable().optional(), contenderPending: O().optional(), createKey: O().optional(), provenance: te({ origin: we(["scribe", "admin", "fvd"]), author: O().nullable(), capturedAt: O(), device: O().nullable().optional() }).optional(), eliminations: He(te({ id: O(), reason: O(), movementNumber: J().int().positive().nullable().optional(), fromError: Xe().optional() })).optional(), errors: He(te({ id: O(), label: O(), points: J().nonnegative().optional(), percent: J().nonnegative().optional(), movementNumber: J().int().positive().nullable().optional(), amountSource: we([Bs.RULE, Bs.MANUAL]).optional() })).optional(), marksConfirmedAt: O().optional(), marksConfirmedBy: O().optional(), timeFault: te({ exceeded: Xe(), elapsedSeconds: J(), limitSeconds: J(), recordedAt: O() }).optional(), numericOnly: Xe().optional(), noSignatureNeeded: Xe().optional(), completedAt: O().optional(), version: J().int().nonnegative().optional() });
we(Xi);
var ai = te(Object.fromEntries(Xi.map(function(e) {
  return [e, He(O()).optional()];
})));
te({ id: O(), showId: O(), testId: O().optional(), className: O(), scheduledTime: O(), ring: O().optional(), judgeAssignments: ai.optional(), judgeIds: He(O()).optional(), scribeAssignments: ai.optional(), qualityJudging: te({ topology: we(["two-judge", "technical-only"]), qualityPosition: we(["E", "B"]).nullable().optional(), qualityJudge: O().nullable().optional() }).optional(), faultTimeLimitSeconds: J().int().positive().default(45), errorDeductionScheme: we(Object.values(Sn)).default(Sn.POINTS), sectionJudgeAssignments: te({ technical: O().nullable().optional(), quality: O().nullable().optional() }).optional(), walkTrotOnly: Xe().default(!1), hidden: Xe().optional(), hiddenAutoSetAt: O().optional(), order: J().optional(), testDisagreement: te({ flagged: aa(!0), signals: He(we(Object.values(pl))).min(1) }).nullable().optional(), sponsorId: O().nullable().optional(), prize: O().nullable().optional(), testOverrides: Hl.nullable().optional() });
var Wl = te({ id: O(), type: we(Object.values(us)), raisedByScribeId: O().nullable(), raisedAt: O(), acknowledged: te({ byScribeId: O().nullable(), at: O() }).nullable().optional() });
te({ type: we(Object.values(us)) });
var Jl = te({ eventId: O(), type: we(Object.values(us)), clearedByScribeId: O().nullable(), clearedAt: O() });
te({ id: O(), classId: O(), testId: O().optional(), horseId: O(), riderId: O(), rideNumber: J().int().positive(), scheduledTime: O().optional(), status: O().optional(), percentage: J().optional(), priorScore: J().nullable().optional(), allSheetsCompletedAt: O().nullable().optional(), adminConfirmedAt: O().nullable().optional(), adminConfirmedBy: O().nullable().optional(), compositePercentage: J().nullable().optional(), placing: J().int().positive().nullable().optional(), isManual: Xe().optional(), needsReview: Xe().optional(), judgeIds: He(O()).optional(), competitorNumber: O().optional(), horseName: O().optional(), riderName: O().optional(), trainerId: O().optional(), resolvedIntoRideId: O().nullable().optional(), filledFromRideId: O().nullable().optional(), utilityEvents: He(Wl).optional(), utilityEventClears: He(Jl).optional(), movementOverride: Gl.optional(), placingStaleAt: O().nullable().optional(), fvdWriteBackBlockedByOverride: Xe().nullable().optional(), terminationReason: te({ reason: we(Object.values(dl)), setAt: O(), setBy: O().nullable().optional(), source: O() }).nullable().optional() });
te({ classId: O(), showId: O().optional(), scheduledTime: O().optional(), testId: O().optional(), competitorNumber: O().optional(), horseName: O().optional(), riderName: O().optional() });
te({ id: O(), personType: we(["RIDER", "JUDGE", "SCRIBE"]), firstName: O(), lastName: O(), usefId: O().optional(), usdfId: O().optional(), email: O().optional(), unlockCode: O().regex(/^\d{4,6}$/, "unlockCode must be 4–6 digits").optional(), userId: O().optional() });
te({ id: O(), name: O(), breed: O().optional(), foalYear: J().int().optional(), usefId: O().optional(), usdfId: O().optional() });
const w = (oi = { default: () => Pi.default }, Pr = {}, bn.d(Pr, oi), Pr);
var oi, Pr;
function ha(e, s) {
  if (!(e instanceof s)) throw new TypeError("Cannot call a class as a function");
}
function es(e, s, r) {
  return es = ds() ? Reflect.construct : function(i, n, t) {
    var a = [null];
    a.push.apply(a, n);
    var o = new (Function.bind.apply(i, a))();
    return t && kn(o, t.prototype), o;
  }, es.apply(null, arguments);
}
function Xn(e, s, r) {
  return s in e ? Object.defineProperty(e, s, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[s] = r, e;
}
function On(e) {
  return On = Object.setPrototypeOf ? Object.getPrototypeOf : function(s) {
    return s.__proto__ || Object.getPrototypeOf(s);
  }, On(e);
}
function kn(e, s) {
  return kn = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, kn(e, s);
}
function ts(e) {
  var s = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return ts = function(r) {
    if (r === null || (i = r, Function.toString.call(i).indexOf("[native code]") === -1)) return r;
    var i;
    if (typeof r != "function") throw new TypeError("Super expression must either be null or a function");
    if (s !== void 0) {
      if (s.has(r)) return s.get(r);
      s.set(r, n);
    }
    function n() {
      return es(r, arguments, On(this).constructor);
    }
    return n.prototype = Object.create(r.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), kn(n, r);
  }, ts(e);
}
function ds() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ds = function() {
    return !!e;
  })();
}
var y = "http://localhost".replace(/\/+$/, ""), Ce = function e(s) {
  var r, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : y, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : w.default;
  ha(this, e), Xn(this, "basePath", void 0), Xn(this, "axios", void 0), Xn(this, "configuration", void 0), this.basePath = i, this.axios = n, s && (this.configuration = s, this.basePath = (r = s.basePath) !== null && r !== void 0 ? r : i);
}, Zl = function() {
  function e(s, r) {
    var i;
    return ha(this, e), Xn(i = function(n, t, a) {
      return t = On(t), o = n, !(u = ds() ? Reflect.construct(t, a || [], On(n).constructor) : t.apply(n, a)) || ((l = u) && typeof Symbol < "u" && l.constructor === Symbol ? "symbol" : typeof l) != "object" && typeof u != "function" ? function(c) {
        if (c === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return c;
      }(o) : u;
      var o, u, l;
    }(this, e, [r]), "field", void 0), i.field = s, i.name = "RequiredError", i;
  }
  return function(s, r) {
    if (typeof r != "function" && r !== null) throw new TypeError("Super expression must either be null or a function");
    s.prototype = Object.create(r && r.prototype, { constructor: { value: s, writable: !0, configurable: !0 } }), r && kn(s, r);
  }(e, ts(Error)), e;
}(), R = {};
function ui(e, s, r, i, n, t, a) {
  try {
    var o = e[t](a), u = o.value;
  } catch (l) {
    return void r(l);
  }
  o.done ? s(u) : Promise.resolve(u).then(i, n);
}
function Yl(e, s, r) {
  return s in e ? Object.defineProperty(e, s, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[s] = r, e;
}
var x = "https://example.com", S = function(e, s, r) {
  if (r == null) throw new Zl(s, "Required parameter ".concat(s, " was null or undefined when calling ").concat(e, "."));
}, C = function(e, s) {
  return (r = function() {
    var i, n;
    return function(t, a) {
      var o, u, l, c = { label: 0, sent: function() {
        if (1 & l[0]) throw l[1];
        return l[1];
      }, trys: [], ops: [] }, d = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
      return d.next = h(0), d.throw = h(1), d.return = h(2), typeof Symbol == "function" && (d[Symbol.iterator] = function() {
        return this;
      }), d;
      function h(m) {
        return function(j) {
          return function(E) {
            if (o) throw new TypeError("Generator is already executing.");
            for (; d && (d = 0, E[0] && (c = 0)), c; ) try {
              if (o = 1, u && (l = 2 & E[0] ? u.return : E[0] ? u.throw || ((l = u.return) && l.call(u), 0) : u.next) && !(l = l.call(u, E[1])).done) return l;
              switch (u = 0, l && (E = [2 & E[0], l.value]), E[0]) {
                case 0:
                case 1:
                  l = E;
                  break;
                case 4:
                  return c.label++, { value: E[1], done: !1 };
                case 5:
                  c.label++, u = E[1], E = [0];
                  continue;
                case 7:
                  E = c.ops.pop(), c.trys.pop();
                  continue;
                default:
                  if (!((l = (l = c.trys).length > 0 && l[l.length - 1]) || E[0] !== 6 && E[0] !== 2)) {
                    c = 0;
                    continue;
                  }
                  if (E[0] === 3 && (!l || E[1] > l[0] && E[1] < l[3])) {
                    c.label = E[1];
                    break;
                  }
                  if (E[0] === 6 && c.label < l[1]) {
                    c.label = l[1], l = E;
                    break;
                  }
                  if (l && c.label < l[2]) {
                    c.label = l[2], c.ops.push(E);
                    break;
                  }
                  l[2] && c.ops.pop(), c.trys.pop();
                  continue;
              }
              E = a.call(t, c);
            } catch (M) {
              E = [6, M], u = 0;
            } finally {
              o = l = 0;
            }
            if (5 & E[0]) throw E[1];
            return { value: E[0] ? E[1] : void 0, done: !0 };
          }([m, j]);
        };
      }
    }(this, function(t) {
      switch (t.label) {
        case 0:
          return s && s.accessToken ? typeof s.accessToken != "function" ? [3, 2] : [4, s.accessToken()] : [3, 5];
        case 1:
          return n = t.sent(), [3, 4];
        case 2:
          return [4, s.accessToken];
        case 3:
          n = t.sent(), t.label = 4;
        case 4:
          i = n, e.Authorization = "Bearer " + i, t.label = 5;
        case 5:
          return [2];
      }
    });
  }, function() {
    var i = this, n = arguments;
    return new Promise(function(t, a) {
      var o = r.apply(i, n);
      function u(c) {
        ui(o, t, a, u, l, "next", c);
      }
      function l(c) {
        ui(o, t, a, u, l, "throw", c);
      }
      u(void 0);
    });
  })();
  var r;
};
function ns(e, s) {
  var r, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  s != null && ((s === void 0 ? "undefined" : (r = s) && typeof Symbol < "u" && r.constructor === Symbol ? "symbol" : typeof r) == "object" ? Array.isArray(s) ? s.forEach(function(n) {
    return ns(e, n, i);
  }) : Object.keys(s).forEach(function(n) {
    return ns(e, s[n], "".concat(i).concat(i !== "" ? "." : "").concat(n));
  }) : e.has(i) ? e.append(i, s) : e.set(i, s));
}
var I = function(e) {
  for (var s = arguments.length, r = new Array(s > 1 ? s - 1 : 0), i = 1; i < s; i++) r[i - 1] = arguments[i];
  var n = new URLSearchParams(e.search);
  ns(n, r), e.search = n.toString();
}, L = function(e, s, r) {
  var i = typeof e != "string";
  return (i && r && r.isJsonMime ? r.isJsonMime(s.headers["Content-Type"]) : i) ? JSON.stringify(e !== void 0 ? e : {}) : e || "";
}, _ = function(e) {
  return e.pathname + e.search + e.hash;
}, T = function(e, s, r, i) {
  return function() {
    var n, t, a, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : s, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : r, l = (t = function(c) {
      for (var d = 1; d < arguments.length; d++) {
        var h = arguments[d] != null ? arguments[d] : {}, m = Object.keys(h);
        typeof Object.getOwnPropertySymbols == "function" && (m = m.concat(Object.getOwnPropertySymbols(h).filter(function(j) {
          return Object.getOwnPropertyDescriptor(h, j).enumerable;
        }))), m.forEach(function(j) {
          Yl(c, j, h[j]);
        });
      }
      return c;
    }({}, e.options), a = (a = { url: (o.defaults.baseURL ? "" : (n = i == null ? void 0 : i.basePath) !== null && n !== void 0 ? n : u) + e.url }) != null ? a : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : function(c) {
      var d = Object.keys(c);
      if (Object.getOwnPropertySymbols) {
        var h = Object.getOwnPropertySymbols(c);
        d.push.apply(d, h);
      }
      return d;
    }(Object(a)).forEach(function(c) {
      Object.defineProperty(t, c, Object.getOwnPropertyDescriptor(a, c));
    }), t);
    return o.request(l);
  };
};
function li(e, s, r, i, n, t, a) {
  try {
    var o = e[t](a), u = o.value;
  } catch (l) {
    return void r(l);
  }
  o.done ? s(u) : Promise.resolve(u).then(i, n);
}
function p(e) {
  return function() {
    var s = this, r = arguments;
    return new Promise(function(i, n) {
      var t = e.apply(s, r);
      function a(u) {
        li(t, i, n, a, o, "next", u);
      }
      function o(u) {
        li(t, i, n, a, o, "throw", u);
      }
      a(void 0);
    });
  };
}
function Ee(e, s, r) {
  return s = hr(s), i = e, !(n = fa() ? Reflect.construct(s, r || [], hr(e).constructor) : s.apply(e, r)) || ((t = n) && typeof Symbol < "u" && t.constructor === Symbol ? "symbol" : typeof t) != "object" && typeof n != "function" ? function(a) {
    if (a === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return a;
  }(i) : n;
  var i, n, t;
}
function Oe(e, s) {
  if (!(e instanceof s)) throw new TypeError("Cannot call a class as a function");
}
function Kl(e, s) {
  for (var r = 0; r < s.length; r++) {
    var i = s[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function ke(e, s, r) {
  return s && Kl(e.prototype, s), e;
}
function Ql(e, s, r) {
  return s in e ? Object.defineProperty(e, s, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[s] = r, e;
}
function hr(e) {
  return hr = Object.setPrototypeOf ? Object.getPrototypeOf : function(s) {
    return s.__proto__ || Object.getPrototypeOf(s);
  }, hr(e);
}
function Ae(e, s) {
  if (typeof s != "function" && s !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(s && s.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), s && rs(e, s);
}
function f(e) {
  for (var s = 1; s < arguments.length; s++) {
    var r = arguments[s] != null ? arguments[s] : {}, i = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (i = i.concat(Object.getOwnPropertySymbols(r).filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    }))), i.forEach(function(n) {
      Ql(e, n, r[n]);
    });
  }
  return e;
}
function rs(e, s) {
  return rs = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, rs(e, s);
}
function fa() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (fa = function() {
    return !!e;
  })();
}
function v(e, s) {
  var r, i, n, t = { label: 0, sent: function() {
    if (1 & n[0]) throw n[1];
    return n[1];
  }, trys: [], ops: [] }, a = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return a.next = o(0), a.throw = o(1), a.return = o(2), typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function o(u) {
    return function(l) {
      return function(c) {
        if (r) throw new TypeError("Generator is already executing.");
        for (; a && (a = 0, c[0] && (t = 0)), t; ) try {
          if (r = 1, i && (n = 2 & c[0] ? i.return : c[0] ? i.throw || ((n = i.return) && n.call(i), 0) : i.next) && !(n = n.call(i, c[1])).done) return n;
          switch (i = 0, n && (c = [2 & c[0], n.value]), c[0]) {
            case 0:
            case 1:
              n = c;
              break;
            case 4:
              return t.label++, { value: c[1], done: !1 };
            case 5:
              t.label++, i = c[1], c = [0];
              continue;
            case 7:
              c = t.ops.pop(), t.trys.pop();
              continue;
            default:
              if (!((n = (n = t.trys).length > 0 && n[n.length - 1]) || c[0] !== 6 && c[0] !== 2)) {
                t = 0;
                continue;
              }
              if (c[0] === 3 && (!n || c[1] > n[0] && c[1] < n[3])) {
                t.label = c[1];
                break;
              }
              if (c[0] === 6 && t.label < n[1]) {
                t.label = n[1], n = c;
                break;
              }
              if (n && t.label < n[2]) {
                t.label = n[2], t.ops.push(c);
                break;
              }
              n[2] && t.ops.pop(), t.trys.pop();
              continue;
          }
          c = s.call(e, t);
        } catch (d) {
          c = [6, d], i = 0;
        } finally {
          r = n = 0;
        }
        if (5 & c[0]) throw c[1];
        return { value: c[0] ? c[1] : void 0, done: !0 };
      }([u, l]);
    };
  }
}
var Xl = function(e) {
  return { listBreaks: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("listBreaks", "showId", s), n = new URL("/break", x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, i), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), s !== void 0 && (u.showId = s), r !== void 0 && (u.ring = r), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, i.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  } };
}, ec = function(e) {
  var s = Xl(e);
  return { listBreaks: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.listBreaks(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["BreaksApi.listBreaks"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "listBreaks", value: function(r, i, n) {
    var t = this;
    return ec(this.configuration).listBreaks(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }]), s;
})(Ce);
var tc = function(e) {
  return { getCatalogTest: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getCatalogTest", "id", s), i = "/catalog/{id}".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, listCatalog: function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return p(function() {
      var r, i, n, t, a, o;
      return v(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/catalog", x), e && (i = e.baseOptions), n = f({ method: "GET" }, i, s), a = {}, [4, C(t = {}, e)];
          case 1:
            return u.sent(), I(r, a), o = i && i.headers ? i.headers : {}, n.headers = f({}, t, o, s.headers), [2, { url: _(r), options: n }];
        }
      });
    })();
  }, patchCatalogTest: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("patchCatalogTest", "id", s), n = "/catalog/{id}".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PATCH" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  } };
}, jr = function(e) {
  var s = tc(e);
  return { getCatalogTest: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getCatalogTest(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["CatalogApi.getCatalogTest"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, listCatalog: function(r) {
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, s.listCatalog(r)];
          case 1:
            return t = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (n = R["CatalogApi.listCatalog"]) === null || n === void 0 || (i = n[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return T(t, w.default, y, e)(c, u || d);
            }];
        }
      });
    })();
  }, patchCatalogTest: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.patchCatalogTest(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["CatalogApi.patchCatalogTest"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "getCatalogTest", value: function(r, i) {
    var n = this;
    return jr(this.configuration).getCatalogTest(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "listCatalog", value: function(r) {
    var i = this;
    return jr(this.configuration).listCatalog(r).then(function(n) {
      return n(i.axios, i.basePath);
    });
  } }, { key: "patchCatalogTest", value: function(r, i, n) {
    var t = this;
    return jr(this.configuration).patchCatalogTest(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }]), s;
})(Ce);
var nc = function(e) {
  return { getChampionshipFillOptions: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getChampionshipFillOptions", "classId", s), i = "/class/{classId}/championship-fill-options".replace("{classId}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, getClass: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getClass", "classId", s), i = "/class/{classId}".replace("{classId}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, listClasses: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("listClasses", "showId", s), n = new URL("/class", x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, i), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), s !== void 0 && (u.showId = s), r !== void 0 && (u.mine = r), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, i.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, listClassesForShows: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return S("listClassesForShows", "listClassesForShowsRequest", s), i = new URL("/class/batch", x), e && (n = e.baseOptions), t = f({ method: "POST" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), t.data = L(s, t, e), [2, { url: _(i), options: t }];
        }
      });
    })();
  }, setClassDshbKindOverride: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setClassDshbKindOverride", "classId", s), S("setClassDshbKindOverride", "setClassDshbKindOverrideRequest", r), n = "/class/{classId}/dshb-kind-override".replace("{classId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setClassErrorDeductionScheme: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setClassErrorDeductionScheme", "classId", s), S("setClassErrorDeductionScheme", "setClassErrorDeductionSchemeRequest", r), n = "/class/{classId}/error-deduction-scheme".replace("{classId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setClassFaultTimeLimit: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setClassFaultTimeLimit", "classId", s), S("setClassFaultTimeLimit", "setClassFaultTimeLimitRequest", r), n = "/class/{classId}/fault-time-limit".replace("{classId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setClassFriendlyName: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setClassFriendlyName", "classId", s), S("setClassFriendlyName", "setClassFriendlyNameRequest", r), n = "/class/{classId}/friendly-name".replace("{classId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setClassHidden: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setClassHidden", "classId", s), S("setClassHidden", "setClassHiddenRequest", r), n = "/class/{classId}/hidden".replace("{classId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setClassPaperEntry: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setClassPaperEntry", "classId", s), S("setClassPaperEntry", "setClassPaperEntryRequest", r), n = "/class/{classId}/paper-entry".replace("{classId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setClassQualityJudging: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setClassQualityJudging", "classId", s), S("setClassQualityJudging", "setClassQualityJudgingRequest", r), n = "/class/{classId}/quality-judging".replace("{classId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setClassResultDwell: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setClassResultDwell", "classId", s), S("setClassResultDwell", "setClassResultDwellRequest", r), n = "/class/{classId}/result-dwell".replace("{classId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setClassResultLayout: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setClassResultLayout", "classId", s), S("setClassResultLayout", "setClassResultLayoutRequest", r), n = "/class/{classId}/result-layout".replace("{classId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setClassScribeAssignment: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setClassScribeAssignment", "classId", s), S("setClassScribeAssignment", "setClassScribeAssignmentRequest", r), n = "/class/{classId}/scribe-assignments".replace("{classId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setClassSectionJudgeAssignments: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setClassSectionJudgeAssignments", "classId", s), n = "/class/{classId}/section-judge-assignments".replace("{classId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setClassSkipUsefUpload: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setClassSkipUsefUpload", "classId", s), S("setClassSkipUsefUpload", "setClassSkipUsefUploadRequest", r), n = "/class/{classId}/skip-usef-upload".replace("{classId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setClassSponsorship: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setClassSponsorship", "classId", s), n = "/class/{classId}/sponsorship".replace("{classId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setClassTestOverrides: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setClassTestOverrides", "classId", s), n = "/class/{classId}/test-overrides".replace("{classId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setClassWalkTrotOnly: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setClassWalkTrotOnly", "classId", s), S("setClassWalkTrotOnly", "setClassWalkTrotOnlyRequest", r), n = "/class/{classId}/walk-trot-only".replace("{classId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setRingScribeAssignments: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setRingScribeAssignments", "ring", s), S("setRingScribeAssignments", "setRingScribeAssignmentsRequest", r), n = "/ring/{ring}/scribe-assignments".replace("{ring}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  } };
}, De = function(e) {
  var s = nc(e);
  return { getChampionshipFillOptions: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getChampionshipFillOptions(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ClassesApi.getChampionshipFillOptions"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, getClass: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getClass(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ClassesApi.getClass"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, listClasses: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.listClasses(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ClassesApi.listClasses"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, listClassesForShows: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.listClassesForShows(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ClassesApi.listClassesForShows"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, setClassDshbKindOverride: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setClassDshbKindOverride(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ClassesApi.setClassDshbKindOverride"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassErrorDeductionScheme: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setClassErrorDeductionScheme(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ClassesApi.setClassErrorDeductionScheme"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassFaultTimeLimit: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setClassFaultTimeLimit(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ClassesApi.setClassFaultTimeLimit"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassFriendlyName: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setClassFriendlyName(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ClassesApi.setClassFriendlyName"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassHidden: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setClassHidden(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ClassesApi.setClassHidden"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassPaperEntry: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setClassPaperEntry(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ClassesApi.setClassPaperEntry"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassQualityJudging: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setClassQualityJudging(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ClassesApi.setClassQualityJudging"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassResultDwell: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setClassResultDwell(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ClassesApi.setClassResultDwell"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassResultLayout: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setClassResultLayout(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ClassesApi.setClassResultLayout"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassScribeAssignment: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setClassScribeAssignment(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ClassesApi.setClassScribeAssignment"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassSectionJudgeAssignments: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setClassSectionJudgeAssignments(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ClassesApi.setClassSectionJudgeAssignments"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassSkipUsefUpload: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setClassSkipUsefUpload(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ClassesApi.setClassSkipUsefUpload"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassSponsorship: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setClassSponsorship(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ClassesApi.setClassSponsorship"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassTestOverrides: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setClassTestOverrides(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ClassesApi.setClassTestOverrides"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassWalkTrotOnly: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setClassWalkTrotOnly(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ClassesApi.setClassWalkTrotOnly"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setRingScribeAssignments: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setRingScribeAssignments(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ClassesApi.setRingScribeAssignments"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "getChampionshipFillOptions", value: function(r, i) {
    var n = this;
    return De(this.configuration).getChampionshipFillOptions(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "getClass", value: function(r, i) {
    var n = this;
    return De(this.configuration).getClass(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "listClasses", value: function(r, i, n) {
    var t = this;
    return De(this.configuration).listClasses(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "listClassesForShows", value: function(r, i) {
    var n = this;
    return De(this.configuration).listClassesForShows(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "setClassDshbKindOverride", value: function(r, i, n) {
    var t = this;
    return De(this.configuration).setClassDshbKindOverride(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setClassErrorDeductionScheme", value: function(r, i, n) {
    var t = this;
    return De(this.configuration).setClassErrorDeductionScheme(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setClassFaultTimeLimit", value: function(r, i, n) {
    var t = this;
    return De(this.configuration).setClassFaultTimeLimit(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setClassFriendlyName", value: function(r, i, n) {
    var t = this;
    return De(this.configuration).setClassFriendlyName(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setClassHidden", value: function(r, i, n) {
    var t = this;
    return De(this.configuration).setClassHidden(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setClassPaperEntry", value: function(r, i, n) {
    var t = this;
    return De(this.configuration).setClassPaperEntry(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setClassQualityJudging", value: function(r, i, n) {
    var t = this;
    return De(this.configuration).setClassQualityJudging(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setClassResultDwell", value: function(r, i, n) {
    var t = this;
    return De(this.configuration).setClassResultDwell(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setClassResultLayout", value: function(r, i, n) {
    var t = this;
    return De(this.configuration).setClassResultLayout(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setClassScribeAssignment", value: function(r, i, n) {
    var t = this;
    return De(this.configuration).setClassScribeAssignment(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setClassSectionJudgeAssignments", value: function(r, i, n) {
    var t = this;
    return De(this.configuration).setClassSectionJudgeAssignments(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setClassSkipUsefUpload", value: function(r, i, n) {
    var t = this;
    return De(this.configuration).setClassSkipUsefUpload(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setClassSponsorship", value: function(r, i, n) {
    var t = this;
    return De(this.configuration).setClassSponsorship(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setClassTestOverrides", value: function(r, i, n) {
    var t = this;
    return De(this.configuration).setClassTestOverrides(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setClassWalkTrotOnly", value: function(r, i, n) {
    var t = this;
    return De(this.configuration).setClassWalkTrotOnly(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setRingScribeAssignments", value: function(r, i, n) {
    var t = this;
    return De(this.configuration).setRingScribeAssignments(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }]), s;
})(Ce);
var rc = function(e) {
  return { getDaysheetReconcileStatus: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getDaysheetReconcileStatus", "showId", s), i = "/daysheet/{showId}/status".replace("{showId}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, reconcileDaysheet: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("reconcileDaysheet", "showId", s), i = "/daysheet/{showId}/reconcile".replace("{showId}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "POST" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  } };
}, ci = function(e) {
  var s = rc(e);
  return { getDaysheetReconcileStatus: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getDaysheetReconcileStatus(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["DaySheetApi.getDaysheetReconcileStatus"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, reconcileDaysheet: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.reconcileDaysheet(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["DaySheetApi.reconcileDaysheet"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "getDaysheetReconcileStatus", value: function(r, i) {
    var n = this;
    return ci(this.configuration).getDaysheetReconcileStatus(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "reconcileDaysheet", value: function(r, i) {
    var n = this;
    return ci(this.configuration).reconcileDaysheet(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }]), s;
})(Ce);
var sc = function(e) {
  return { reseedDemo: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return S("reseedDemo", "reseedDemoRequest", s), i = new URL("/demo/reseed", x), e && (n = e.baseOptions), t = f({ method: "POST" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), t.data = L(s, t, e), [2, { url: _(i), options: t }];
        }
      });
    })();
  } };
}, ic = function(e) {
  var s = sc(e);
  return { reseedDemo: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.reseedDemo(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["DemoApi.reseedDemo"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "reseedDemo", value: function(r, i) {
    var n = this;
    return ic(this.configuration).reseedDemo(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }]), s;
})(Ce);
var ac = function(e) {
  return { getHealth: function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return p(function() {
      var r, i, n, t, a;
      return v(this, function(o) {
        return r = new URL("/health", x), e && (i = e.baseOptions), n = f({ method: "GET" }, i, s), t = {}, I(r, {}), a = i && i.headers ? i.headers : {}, n.headers = f({}, t, a, s.headers), [2, { url: _(r), options: n }];
      });
    })();
  } };
}, oc = function(e) {
  var s = ac(e);
  return { getHealth: function(r) {
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, s.getHealth(r)];
          case 1:
            return t = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (n = R["HealthApi.getHealth"]) === null || n === void 0 || (i = n[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return T(t, w.default, y, e)(c, u || d);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "getHealth", value: function(r) {
    var i = this;
    return oc(this.configuration).getHealth(r).then(function(n) {
      return n(i.axios, i.basePath);
    });
  } }]), s;
})(Ce);
var uc = function(e) {
  return { getHorse: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getHorse", "id", s), i = "/horse/{id}".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, listHorses: function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return p(function() {
      var r, i, n, t, a, o;
      return v(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/horse", x), e && (i = e.baseOptions), n = f({ method: "GET" }, i, s), a = {}, [4, C(t = {}, e)];
          case 1:
            return u.sent(), I(r, a), o = i && i.headers ? i.headers : {}, n.headers = f({}, t, o, s.headers), [2, { url: _(r), options: n }];
        }
      });
    })();
  } };
}, di = function(e) {
  var s = uc(e);
  return { getHorse: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getHorse(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["HorsesApi.getHorse"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, listHorses: function(r) {
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, s.listHorses(r)];
          case 1:
            return t = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (n = R["HorsesApi.listHorses"]) === null || n === void 0 || (i = n[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return T(t, w.default, y, e)(c, u || d);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "getHorse", value: function(r, i) {
    var n = this;
    return di(this.configuration).getHorse(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "listHorses", value: function(r) {
    var i = this;
    return di(this.configuration).listHorses(r).then(function(n) {
      return n(i.axios, i.basePath);
    });
  } }]), s;
})(Ce);
var lc = function(e) {
  return { getInstanceConfig: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getInstanceConfig", "instanceId", s), i = "/instance/{instanceId}/config".replace("{instanceId}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, listInstances: function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return p(function() {
      var r, i, n, t, a, o;
      return v(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/instance", x), e && (i = e.baseOptions), n = f({ method: "GET" }, i, s), a = {}, [4, C(t = {}, e)];
          case 1:
            return u.sent(), I(r, a), o = i && i.headers ? i.headers : {}, n.headers = f({}, t, o, s.headers), [2, { url: _(r), options: n }];
        }
      });
    })();
  }, postInstanceStatus: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("postInstanceStatus", "instanceId", s), S("postInstanceStatus", "postInstanceStatusRequest", r), n = "/instance/{instanceId}/status".replace("{instanceId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "POST" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, putInstanceConfig: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("putInstanceConfig", "instanceId", s), S("putInstanceConfig", "putInstanceConfigRequest", r), n = "/instance/{instanceId}/config".replace("{instanceId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  } };
}, Wn = function(e) {
  var s = lc(e);
  return { getInstanceConfig: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getInstanceConfig(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["InstanceApi.getInstanceConfig"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, listInstances: function(r) {
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, s.listInstances(r)];
          case 1:
            return t = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (n = R["InstanceApi.listInstances"]) === null || n === void 0 || (i = n[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return T(t, w.default, y, e)(c, u || d);
            }];
        }
      });
    })();
  }, postInstanceStatus: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.postInstanceStatus(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["InstanceApi.postInstanceStatus"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, putInstanceConfig: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.putInstanceConfig(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["InstanceApi.putInstanceConfig"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "getInstanceConfig", value: function(r, i) {
    var n = this;
    return Wn(this.configuration).getInstanceConfig(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "listInstances", value: function(r) {
    var i = this;
    return Wn(this.configuration).listInstances(r).then(function(n) {
      return n(i.axios, i.basePath);
    });
  } }, { key: "postInstanceStatus", value: function(r, i, n) {
    var t = this;
    return Wn(this.configuration).postInstanceStatus(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "putInstanceConfig", value: function(r, i, n) {
    var t = this;
    return Wn(this.configuration).putInstanceConfig(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }]), s;
})(Ce);
var cc = function(e) {
  return { createCompositeJudgeMap: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return S("createCompositeJudgeMap", "createCompositeJudgeMapRequest", s), i = new URL("/composite-judge-map", x), e && (n = e.baseOptions), t = f({ method: "POST" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), t.data = L(s, t, e), [2, { url: _(i), options: t }];
        }
      });
    })();
  }, deleteCompositeJudgeMap: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("deleteCompositeJudgeMap", "id", s), i = "/composite-judge-map/{id}".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "DELETE" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, deleteJudgeSignature: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("deleteJudgeSignature", "id", s), i = "/judge/{id}/signature".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "DELETE" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, getCompositeJudgeMap: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getCompositeJudgeMap", "id", s), i = "/composite-judge-map/{id}".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, listCompositeJudgeMaps: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return S("listCompositeJudgeMaps", "showId", s), i = new URL("/composite-judge-map", x), e && (n = e.baseOptions), t = f({ method: "GET" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), s !== void 0 && (o.showId = s), I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), [2, { url: _(i), options: t }];
        }
      });
    })();
  }, listJudges: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return S("listJudges", "showId", s), i = new URL("/judge", x), e && (n = e.baseOptions), t = f({ method: "GET" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), s !== void 0 && (o.showId = s), I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), [2, { url: _(i), options: t }];
        }
      });
    })();
  }, putJudgeSignature: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("putJudgeSignature", "id", s), S("putJudgeSignature", "putJudgeSignatureRequest", r), n = "/judge/{id}/signature".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "POST" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, resolveJudgeComposite: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("resolveJudgeComposite", "id", s), i = "/judge/{id}/resolve".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, updateCompositeJudgeMap: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("updateCompositeJudgeMap", "id", s), n = "/composite-judge-map/{id}".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  } };
}, vt = function(e) {
  var s = cc(e);
  return { createCompositeJudgeMap: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.createCompositeJudgeMap(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["JudgesApi.createCompositeJudgeMap"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, deleteCompositeJudgeMap: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.deleteCompositeJudgeMap(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["JudgesApi.deleteCompositeJudgeMap"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, deleteJudgeSignature: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.deleteJudgeSignature(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["JudgesApi.deleteJudgeSignature"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, getCompositeJudgeMap: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getCompositeJudgeMap(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["JudgesApi.getCompositeJudgeMap"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, listCompositeJudgeMaps: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.listCompositeJudgeMaps(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["JudgesApi.listCompositeJudgeMaps"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, listJudges: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.listJudges(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["JudgesApi.listJudges"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, putJudgeSignature: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.putJudgeSignature(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["JudgesApi.putJudgeSignature"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, resolveJudgeComposite: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.resolveJudgeComposite(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["JudgesApi.resolveJudgeComposite"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, updateCompositeJudgeMap: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.updateCompositeJudgeMap(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["JudgesApi.updateCompositeJudgeMap"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "createCompositeJudgeMap", value: function(r, i) {
    var n = this;
    return vt(this.configuration).createCompositeJudgeMap(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "deleteCompositeJudgeMap", value: function(r, i) {
    var n = this;
    return vt(this.configuration).deleteCompositeJudgeMap(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "deleteJudgeSignature", value: function(r, i) {
    var n = this;
    return vt(this.configuration).deleteJudgeSignature(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "getCompositeJudgeMap", value: function(r, i) {
    var n = this;
    return vt(this.configuration).getCompositeJudgeMap(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "listCompositeJudgeMaps", value: function(r, i) {
    var n = this;
    return vt(this.configuration).listCompositeJudgeMaps(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "listJudges", value: function(r, i) {
    var n = this;
    return vt(this.configuration).listJudges(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "putJudgeSignature", value: function(r, i, n) {
    var t = this;
    return vt(this.configuration).putJudgeSignature(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "resolveJudgeComposite", value: function(r, i) {
    var n = this;
    return vt(this.configuration).resolveJudgeComposite(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "updateCompositeJudgeMap", value: function(r, i, n) {
    var t = this;
    return vt(this.configuration).updateCompositeJudgeMap(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }]), s;
})(Ce);
var dc = function(e) {
  return { createPerson: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/people", x), e && (n = e.baseOptions), t = f({ method: "POST" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), t.data = L(s, t, e), [2, { url: _(i), options: t }];
        }
      });
    })();
  }, deletePerson: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("deletePerson", "id", s), i = "/people/{id}".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "DELETE" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, getPerson: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getPerson", "id", s), i = "/people/{id}".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, listPeople: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/people", x), e && (n = e.baseOptions), t = f({ method: "GET" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), s !== void 0 && (o.personType = s), I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), [2, { url: _(i), options: t }];
        }
      });
    })();
  }, updatePerson: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("updatePerson", "id", s), n = "/people/{id}".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  } };
}, fn = function(e) {
  var s = dc(e);
  return { createPerson: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.createPerson(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["PeopleApi.createPerson"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, deletePerson: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.deletePerson(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["PeopleApi.deletePerson"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, getPerson: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getPerson(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["PeopleApi.getPerson"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, listPeople: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.listPeople(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["PeopleApi.listPeople"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, updatePerson: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.updatePerson(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["PeopleApi.updatePerson"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "createPerson", value: function(r, i) {
    var n = this;
    return fn(this.configuration).createPerson(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "deletePerson", value: function(r, i) {
    var n = this;
    return fn(this.configuration).deletePerson(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "getPerson", value: function(r, i) {
    var n = this;
    return fn(this.configuration).getPerson(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "listPeople", value: function(r, i) {
    var n = this;
    return fn(this.configuration).listPeople(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "updatePerson", value: function(r, i, n) {
    var t = this;
    return fn(this.configuration).updatePerson(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }]), s;
})(Ce);
var hc = function(e) {
  return { listPresence: function(s, r, i) {
    var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("listPresence", "showId", s), t = new URL("/presence", x), e && (a = e.baseOptions), o = f({ method: "GET" }, a, n), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), s !== void 0 && (l.showId = s), r !== void 0 && (l.ring = r), i !== void 0 && (l.classId = i), I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, n.headers), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, postHeartbeat: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return S("postHeartbeat", "postHeartbeatRequest", s), i = new URL("/presence/heartbeat", x), e && (n = e.baseOptions), t = f({ method: "POST" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), t.data = L(s, t, e), [2, { url: _(i), options: t }];
        }
      });
    })();
  } };
}, hi = function(e) {
  var s = hc(e);
  return { listPresence: function(r, i, n, t) {
    return p(function() {
      var a, o, u, l, c, d;
      return v(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, s.listPresence(r, i, n, t)];
          case 1:
            return u = h.sent(), c = (l = e == null ? void 0 : e.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = R["PresenceApi.listPresence"]) === null || o === void 0 || (a = o[c]) === null || a === void 0 ? void 0 : a.url, [2, function(m, j) {
              return T(u, w.default, y, e)(m, d || j);
            }];
        }
      });
    })();
  }, postHeartbeat: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.postHeartbeat(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["PresenceApi.postHeartbeat"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "listPresence", value: function(r, i, n, t) {
    var a = this;
    return hi(this.configuration).listPresence(r, i, n, t).then(function(o) {
      return o(a.axios, a.basePath);
    });
  } }, { key: "postHeartbeat", value: function(r, i) {
    var n = this;
    return hi(this.configuration).postHeartbeat(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }]), s;
})(Ce);
var fc = function(e) {
  return { quarantinePayload: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return S("quarantinePayload", "quarantinePayloadRequest", s), i = new URL("/quarantine", x), e && (n = e.baseOptions), t = f({ method: "POST" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), t.data = L(s, t, e), [2, { url: _(i), options: t }];
        }
      });
    })();
  } };
}, pc = function(e) {
  var s = fc(e);
  return { quarantinePayload: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.quarantinePayload(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["QuarantineApi.quarantinePayload"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "quarantinePayload", value: function(r, i) {
    var n = this;
    return pc(this.configuration).quarantinePayload(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }]), s;
})(Ce);
var vc = function(e) {
  return { getClassResults: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getClassResults", "classId", s), i = "/class/{classId}/results".replace("{classId}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, getClassResultsSummary: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getClassResultsSummary", "showId", s), S("getClassResultsSummary", "ring", r), n = new URL("/class-results-summary", x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, i), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), s !== void 0 && (u.showId = s), r !== void 0 && (u.ring = r), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, i.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, getRideResult: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getRideResult", "rideId", s), i = "/ride/{rideId}/results".replace("{rideId}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, getShowResultsSummary: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return S("getShowResultsSummary", "showId", s), i = new URL("/show-results-summary", x), e && (n = e.baseOptions), t = f({ method: "GET" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), s !== void 0 && (o.showId = s), I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), [2, { url: _(i), options: t }];
        }
      });
    })();
  }, setClassPlacings: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setClassPlacings", "classId", s), S("setClassPlacings", "setClassPlacingsRequest", r), n = "/class/{classId}/placings".replace("{classId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setRidePlacing: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setRidePlacing", "rideId", s), n = "/ride/{rideId}/placing".replace("{rideId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  } };
}, Vt = function(e) {
  var s = vc(e);
  return { getClassResults: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getClassResults(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ResultsApi.getClassResults"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, getClassResultsSummary: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.getClassResultsSummary(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ResultsApi.getClassResultsSummary"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, getRideResult: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getRideResult(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ResultsApi.getRideResult"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, getShowResultsSummary: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getShowResultsSummary(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ResultsApi.getShowResultsSummary"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, setClassPlacings: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setClassPlacings(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ResultsApi.setClassPlacings"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setRidePlacing: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setRidePlacing(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ResultsApi.setRidePlacing"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "getClassResults", value: function(r, i) {
    var n = this;
    return Vt(this.configuration).getClassResults(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "getClassResultsSummary", value: function(r, i, n) {
    var t = this;
    return Vt(this.configuration).getClassResultsSummary(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "getRideResult", value: function(r, i) {
    var n = this;
    return Vt(this.configuration).getRideResult(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "getShowResultsSummary", value: function(r, i) {
    var n = this;
    return Vt(this.configuration).getShowResultsSummary(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "setClassPlacings", value: function(r, i, n) {
    var t = this;
    return Vt(this.configuration).setClassPlacings(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setRidePlacing", value: function(r, i, n) {
    var t = this;
    return Vt(this.configuration).setRidePlacing(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }]), s;
})(Ce);
var gc = function(e) {
  return { listReviewQueue: function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return p(function() {
      var r, i, n, t, a, o;
      return v(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/review-queue", x), e && (i = e.baseOptions), n = f({ method: "GET" }, i, s), a = {}, [4, C(t = {}, e)];
          case 1:
            return u.sent(), I(r, a), o = i && i.headers ? i.headers : {}, n.headers = f({}, t, o, s.headers), [2, { url: _(r), options: n }];
        }
      });
    })();
  }, resolveReviewItem: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("resolveReviewItem", "itemId", s), S("resolveReviewItem", "resolveReviewItemRequest", r), n = "/review-queue/{itemId}/resolve".replace("{itemId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "POST" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  } };
}, fi = function(e) {
  var s = gc(e);
  return { listReviewQueue: function(r) {
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, s.listReviewQueue(r)];
          case 1:
            return t = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (n = R["ReviewQueueApi.listReviewQueue"]) === null || n === void 0 || (i = n[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return T(t, w.default, y, e)(c, u || d);
            }];
        }
      });
    })();
  }, resolveReviewItem: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.resolveReviewItem(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ReviewQueueApi.resolveReviewItem"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "listReviewQueue", value: function(r) {
    var i = this;
    return fi(this.configuration).listReviewQueue(r).then(function(n) {
      return n(i.axios, i.basePath);
    });
  } }, { key: "resolveReviewItem", value: function(r, i, n) {
    var t = this;
    return fi(this.configuration).resolveReviewItem(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }]), s;
})(Ce);
var mc = function(e) {
  return { addRideMovement: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("addRideMovement", "rideId", s), n = "/ride/{rideId}/movements".replace("{rideId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "POST" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, batchRideStatus: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return S("batchRideStatus", "batchRideStatusRequest", s), i = new URL("/rides/status", x), e && (n = e.baseOptions), t = f({ method: "POST" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), t.data = L(s, t, e), [2, { url: _(i), options: t }];
        }
      });
    })();
  }, createRide: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/ride", x), e && (n = e.baseOptions), t = f({ method: "POST" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), t.data = L(s, t, e), [2, { url: _(i), options: t }];
        }
      });
    })();
  }, createRideUtilityEvent: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("createRideUtilityEvent", "rideId", s), S("createRideUtilityEvent", "createRideUtilityEventRequest", r), n = "/ride/{rideId}/utility-events".replace("{rideId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "POST" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, deleteRideUtilityEvent: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("deleteRideUtilityEvent", "rideId", s), S("deleteRideUtilityEvent", "eventId", r), n = "/ride/{rideId}/utility-events/{eventId}".replace("{rideId}", encodeURIComponent(String(s))).replace("{eventId}", encodeURIComponent(String(r))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "DELETE" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, fillChampionshipSlot: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("fillChampionshipSlot", "rideId", s), S("fillChampionshipSlot", "fillChampionshipSlotRequest", r), n = "/ride/{rideId}/championship-slot".replace("{rideId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, getRide: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getRide", "rideId", s), i = "/ride/{rideId}".replace("{rideId}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, getRideExcused: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getRideExcused", "rideId", s), i = "/ride/{rideId}/excused".replace("{rideId}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, getRideNoShow: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getRideNoShow", "rideId", s), i = "/ride/{rideId}/no-show".replace("{rideId}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, listRideUtilityEvents: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("listRideUtilityEvents", "rideId", s), i = "/ride/{rideId}/utility-events".replace("{rideId}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, listRides: function(s, r, i, n, t, a, o, u, l) {
    var c = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : {};
    return p(function() {
      var d, h, m, j, E, M;
      return v(this, function(W) {
        switch (W.label) {
          case 0:
            return d = new URL("/ride", x), e && (h = e.baseOptions), m = f({ method: "GET" }, h, c), E = {}, [4, C(j = {}, e)];
          case 1:
            return W.sent(), s !== void 0 && (E.classId = s), r !== void 0 && (E.showId = r), i !== void 0 && (E.day = i), n !== void 0 && (E.ring = n), t !== void 0 && (E.needsReview = t), a !== void 0 && (E.riderId = a), o !== void 0 && (E.horseId = o), u !== void 0 && (E.fvdPushStatus = u), l !== void 0 && (E.unscheduled = l), I(d, E), M = h && h.headers ? h.headers : {}, m.headers = f({}, j, M, c.headers), [2, { url: _(d), options: m }];
        }
      });
    })();
  }, markRideExcused: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("markRideExcused", "rideId", s), i = "/ride/{rideId}/excused".replace("{rideId}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "POST" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, markRideNoShow: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("markRideNoShow", "rideId", s), i = "/ride/{rideId}/no-show".replace("{rideId}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "POST" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, removeRideMovement: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("removeRideMovement", "rideId", s), S("removeRideMovement", "movementNumber", r), n = "/ride/{rideId}/movements/{movementNumber}".replace("{rideId}", encodeURIComponent(String(s))).replace("{movementNumber}", encodeURIComponent(String(r))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "DELETE" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, repointRide: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("repointRide", "rideId", s), S("repointRide", "repointRideRequest", r), n = "/ride/{rideId}/repoint".replace("{rideId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "POST" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, reportFvdPushStatus: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return S("reportFvdPushStatus", "reportFvdPushStatusRequest", s), i = new URL("/rides/fvd-push-status", x), e && (n = e.baseOptions), t = f({ method: "POST" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), t.data = L(s, t, e), [2, { url: _(i), options: t }];
        }
      });
    })();
  }, requestRideReview: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("requestRideReview", "rideId", s), n = "/ride/{rideId}/review".replace("{rideId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "POST" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, resolveManualRide: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("resolveManualRide", "rideId", s), S("resolveManualRide", "resolveManualRideRequest", r), n = "/ride/{rideId}/resolve".replace("{rideId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "POST" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setRideStatus: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setRideStatus", "rideId", s), S("setRideStatus", "setRideStatusRequest", r), n = "/ride/{rideId}/status".replace("{rideId}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, undoRideExcused: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("undoRideExcused", "rideId", s), i = "/ride/{rideId}/excused".replace("{rideId}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "DELETE" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, undoRideNoShow: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("undoRideNoShow", "rideId", s), i = "/ride/{rideId}/no-show".replace("{rideId}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "DELETE" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  } };
}, Ne = function(e) {
  var s = mc(e);
  return { addRideMovement: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.addRideMovement(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["RidesApi.addRideMovement"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, batchRideStatus: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.batchRideStatus(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["RidesApi.batchRideStatus"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, createRide: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.createRide(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["RidesApi.createRide"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, createRideUtilityEvent: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.createRideUtilityEvent(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["RidesApi.createRideUtilityEvent"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, deleteRideUtilityEvent: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.deleteRideUtilityEvent(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["RidesApi.deleteRideUtilityEvent"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, fillChampionshipSlot: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.fillChampionshipSlot(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["RidesApi.fillChampionshipSlot"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, getRide: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getRide(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["RidesApi.getRide"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, getRideExcused: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getRideExcused(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["RidesApi.getRideExcused"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, getRideNoShow: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getRideNoShow(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["RidesApi.getRideNoShow"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, listRideUtilityEvents: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.listRideUtilityEvents(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["RidesApi.listRideUtilityEvents"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, listRides: function(r, i, n, t, a, o, u, l, c, d) {
    return p(function() {
      var h, m, j, E, M, W;
      return v(this, function(B) {
        switch (B.label) {
          case 0:
            return [4, s.listRides(r, i, n, t, a, o, u, l, c, d)];
          case 1:
            return j = B.sent(), M = (E = e == null ? void 0 : e.serverIndex) !== null && E !== void 0 ? E : 0, W = (m = R["RidesApi.listRides"]) === null || m === void 0 || (h = m[M]) === null || h === void 0 ? void 0 : h.url, [2, function(be, ee) {
              return T(j, w.default, y, e)(be, W || ee);
            }];
        }
      });
    })();
  }, markRideExcused: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.markRideExcused(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["RidesApi.markRideExcused"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, markRideNoShow: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.markRideNoShow(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["RidesApi.markRideNoShow"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, removeRideMovement: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.removeRideMovement(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["RidesApi.removeRideMovement"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, repointRide: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.repointRide(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["RidesApi.repointRide"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, reportFvdPushStatus: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.reportFvdPushStatus(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["RidesApi.reportFvdPushStatus"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, requestRideReview: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.requestRideReview(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["RidesApi.requestRideReview"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, resolveManualRide: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.resolveManualRide(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["RidesApi.resolveManualRide"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setRideStatus: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setRideStatus(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["RidesApi.setRideStatus"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, undoRideExcused: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.undoRideExcused(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["RidesApi.undoRideExcused"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, undoRideNoShow: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.undoRideNoShow(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["RidesApi.undoRideNoShow"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "addRideMovement", value: function(r, i, n) {
    var t = this;
    return Ne(this.configuration).addRideMovement(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "batchRideStatus", value: function(r, i) {
    var n = this;
    return Ne(this.configuration).batchRideStatus(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "createRide", value: function(r, i) {
    var n = this;
    return Ne(this.configuration).createRide(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "createRideUtilityEvent", value: function(r, i, n) {
    var t = this;
    return Ne(this.configuration).createRideUtilityEvent(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "deleteRideUtilityEvent", value: function(r, i, n) {
    var t = this;
    return Ne(this.configuration).deleteRideUtilityEvent(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "fillChampionshipSlot", value: function(r, i, n) {
    var t = this;
    return Ne(this.configuration).fillChampionshipSlot(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "getRide", value: function(r, i) {
    var n = this;
    return Ne(this.configuration).getRide(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "getRideExcused", value: function(r, i) {
    var n = this;
    return Ne(this.configuration).getRideExcused(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "getRideNoShow", value: function(r, i) {
    var n = this;
    return Ne(this.configuration).getRideNoShow(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "listRideUtilityEvents", value: function(r, i) {
    var n = this;
    return Ne(this.configuration).listRideUtilityEvents(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "listRides", value: function(r, i, n, t, a, o, u, l, c, d) {
    var h = this;
    return Ne(this.configuration).listRides(r, i, n, t, a, o, u, l, c, d).then(function(m) {
      return m(h.axios, h.basePath);
    });
  } }, { key: "markRideExcused", value: function(r, i) {
    var n = this;
    return Ne(this.configuration).markRideExcused(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "markRideNoShow", value: function(r, i) {
    var n = this;
    return Ne(this.configuration).markRideNoShow(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "removeRideMovement", value: function(r, i, n) {
    var t = this;
    return Ne(this.configuration).removeRideMovement(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "repointRide", value: function(r, i, n) {
    var t = this;
    return Ne(this.configuration).repointRide(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "reportFvdPushStatus", value: function(r, i) {
    var n = this;
    return Ne(this.configuration).reportFvdPushStatus(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "requestRideReview", value: function(r, i, n) {
    var t = this;
    return Ne(this.configuration).requestRideReview(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "resolveManualRide", value: function(r, i, n) {
    var t = this;
    return Ne(this.configuration).resolveManualRide(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setRideStatus", value: function(r, i, n) {
    var t = this;
    return Ne(this.configuration).setRideStatus(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "undoRideExcused", value: function(r, i) {
    var n = this;
    return Ne(this.configuration).undoRideExcused(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "undoRideNoShow", value: function(r, i) {
    var n = this;
    return Ne(this.configuration).undoRideNoShow(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }]), s;
})(Ce);
var bc = function(e) {
  return { clearRingState: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("clearRingState", "showId", s), S("clearRingState", "ring", r), n = "/ring-state/{ring}".replace("{ring}", encodeURIComponent(String(r))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "DELETE" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), s !== void 0 && (l.showId = s), I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, getRingState: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("getRingState", "showId", s), S("getRingState", "ring", r), n = "/ring-state/{ring}".replace("{ring}", encodeURIComponent(String(r))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "GET" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), s !== void 0 && (l.showId = s), I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, listRingStates: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return S("listRingStates", "showId", s), i = new URL("/ring-state", x), e && (n = e.baseOptions), t = f({ method: "GET" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), s !== void 0 && (o.showId = s), I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), [2, { url: _(i), options: t }];
        }
      });
    })();
  }, setRingState: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return S("setRingState", "setRingStateRequest", s), i = new URL("/ring-state", x), e && (n = e.baseOptions), t = f({ method: "PUT" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), t.data = L(s, t, e), [2, { url: _(i), options: t }];
        }
      });
    })();
  } };
}, Jn = function(e) {
  var s = bc(e);
  return { clearRingState: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.clearRingState(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["RingStateApi.clearRingState"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, getRingState: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.getRingState(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["RingStateApi.getRingState"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, listRingStates: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.listRingStates(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["RingStateApi.listRingStates"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, setRingState: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.setRingState(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["RingStateApi.setRingState"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "clearRingState", value: function(r, i, n) {
    var t = this;
    return Jn(this.configuration).clearRingState(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "getRingState", value: function(r, i, n) {
    var t = this;
    return Jn(this.configuration).getRingState(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "listRingStates", value: function(r, i) {
    var n = this;
    return Jn(this.configuration).listRingStates(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "setRingState", value: function(r, i) {
    var n = this;
    return Jn(this.configuration).setRingState(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }]), s;
})(Ce);
var Sc = function(e) {
  return { addScoreSheetAnnotation: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("addScoreSheetAnnotation", "id", s), S("addScoreSheetAnnotation", "addScoreSheetAnnotationRequest", r), n = "/scoresheet/{id}/annotations".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "POST" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, commitScoreSheetEdit: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("commitScoreSheetEdit", "id", s), S("commitScoreSheetEdit", "commitScoreSheetEditRequest", r), n = "/scoresheet/{id}/commit".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "POST" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, completeScoreSheet: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("completeScoreSheet", "id", s), i = "/scoresheet/{id}/complete".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "POST" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, confirmScoreSheetMarks: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("confirmScoreSheetMarks", "id", s), i = "/scoresheet/{id}/confirm-marks".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "POST" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, createScoreSheet: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/scoresheet", x), e && (n = e.baseOptions), t = f({ method: "POST" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), t.data = L(s, t, e), [2, { url: _(i), options: t }];
        }
      });
    })();
  }, discardScoreSheetDraft: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("discardScoreSheetDraft", "id", s), i = "/scoresheet/{id}/draft".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "DELETE" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, getRideAuditTrail: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getRideAuditTrail", "rideId", s), i = "/ride/{rideId}/audit".replace("{rideId}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, getScoreSheet: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getScoreSheet", "id", s), i = "/scoresheet/{id}".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, getScoreSheetAuditTrail: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getScoreSheetAuditTrail", "id", s), i = "/scoresheet/{id}/audit".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, getScoreSheetDraft: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getScoreSheetDraft", "id", s), i = "/scoresheet/{id}/draft".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, getScoreSheetSignature: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getScoreSheetSignature", "id", s), i = "/scoresheet/{id}/signature".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, listScoreSheets: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return n = new URL("/scoresheet", x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, i), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), s !== void 0 && (u.rideId = s), r !== void 0 && (u.judgeId = r), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, i.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, listScoreSheetsForRides: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return S("listScoreSheetsForRides", "listScoreSheetsForRidesRequest", s), i = new URL("/scoresheet/batch", x), e && (n = e.baseOptions), t = f({ method: "POST" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), t.data = L(s, t, e), [2, { url: _(i), options: t }];
        }
      });
    })();
  }, putScoreSheetDraft: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("putScoreSheetDraft", "id", s), n = "/scoresheet/{id}/draft".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, resolveStaleWriteConflict: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("resolveStaleWriteConflict", "id", s), S("resolveStaleWriteConflict", "resolveStaleWriteConflictRequest", r), n = "/scoresheet/{id}/resolve-stale-write-conflict".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "POST" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, restoreScoreSheetVersion: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("restoreScoreSheetVersion", "id", s), S("restoreScoreSheetVersion", "restoreScoreSheetVersionRequest", r), n = "/scoresheet/{id}/restore".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "POST" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, signScoreSheetPanel: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("signScoreSheetPanel", "id", s), S("signScoreSheetPanel", "signScoreSheetPanelRequest", r), n = "/scoresheet/{id}/panel-signature".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "POST" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, switchAuthoritativeScoreSheet: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("switchAuthoritativeScoreSheet", "id", s), i = "/scoresheet/{id}/switch-authoritative".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "POST" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, unlockScoreSheet: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("unlockScoreSheet", "id", s), S("unlockScoreSheet", "unlockScoreSheetRequest", r), n = "/scoresheet/{id}/unlock".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "POST" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, updateScoreSheet: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("updateScoreSheet", "id", s), n = "/scoresheet/{id}".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  } };
}, Fe = function(e) {
  var s = Sc(e);
  return { addScoreSheetAnnotation: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.addScoreSheetAnnotation(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ScoreSheetsApi.addScoreSheetAnnotation"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, commitScoreSheetEdit: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.commitScoreSheetEdit(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ScoreSheetsApi.commitScoreSheetEdit"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, completeScoreSheet: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.completeScoreSheet(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreSheetsApi.completeScoreSheet"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, confirmScoreSheetMarks: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.confirmScoreSheetMarks(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreSheetsApi.confirmScoreSheetMarks"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, createScoreSheet: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.createScoreSheet(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreSheetsApi.createScoreSheet"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, discardScoreSheetDraft: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.discardScoreSheetDraft(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreSheetsApi.discardScoreSheetDraft"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, getRideAuditTrail: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getRideAuditTrail(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreSheetsApi.getRideAuditTrail"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, getScoreSheet: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getScoreSheet(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreSheetsApi.getScoreSheet"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, getScoreSheetAuditTrail: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getScoreSheetAuditTrail(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreSheetsApi.getScoreSheetAuditTrail"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, getScoreSheetDraft: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getScoreSheetDraft(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreSheetsApi.getScoreSheetDraft"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, getScoreSheetSignature: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getScoreSheetSignature(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreSheetsApi.getScoreSheetSignature"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, listScoreSheets: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.listScoreSheets(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ScoreSheetsApi.listScoreSheets"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, listScoreSheetsForRides: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.listScoreSheetsForRides(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreSheetsApi.listScoreSheetsForRides"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, putScoreSheetDraft: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.putScoreSheetDraft(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ScoreSheetsApi.putScoreSheetDraft"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, resolveStaleWriteConflict: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.resolveStaleWriteConflict(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ScoreSheetsApi.resolveStaleWriteConflict"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, restoreScoreSheetVersion: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.restoreScoreSheetVersion(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ScoreSheetsApi.restoreScoreSheetVersion"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, signScoreSheetPanel: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.signScoreSheetPanel(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ScoreSheetsApi.signScoreSheetPanel"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, switchAuthoritativeScoreSheet: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.switchAuthoritativeScoreSheet(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreSheetsApi.switchAuthoritativeScoreSheet"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, unlockScoreSheet: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.unlockScoreSheet(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ScoreSheetsApi.unlockScoreSheet"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, updateScoreSheet: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.updateScoreSheet(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ScoreSheetsApi.updateScoreSheet"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "addScoreSheetAnnotation", value: function(r, i, n) {
    var t = this;
    return Fe(this.configuration).addScoreSheetAnnotation(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "commitScoreSheetEdit", value: function(r, i, n) {
    var t = this;
    return Fe(this.configuration).commitScoreSheetEdit(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "completeScoreSheet", value: function(r, i) {
    var n = this;
    return Fe(this.configuration).completeScoreSheet(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "confirmScoreSheetMarks", value: function(r, i) {
    var n = this;
    return Fe(this.configuration).confirmScoreSheetMarks(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "createScoreSheet", value: function(r, i) {
    var n = this;
    return Fe(this.configuration).createScoreSheet(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "discardScoreSheetDraft", value: function(r, i) {
    var n = this;
    return Fe(this.configuration).discardScoreSheetDraft(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "getRideAuditTrail", value: function(r, i) {
    var n = this;
    return Fe(this.configuration).getRideAuditTrail(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "getScoreSheet", value: function(r, i) {
    var n = this;
    return Fe(this.configuration).getScoreSheet(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "getScoreSheetAuditTrail", value: function(r, i) {
    var n = this;
    return Fe(this.configuration).getScoreSheetAuditTrail(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "getScoreSheetDraft", value: function(r, i) {
    var n = this;
    return Fe(this.configuration).getScoreSheetDraft(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "getScoreSheetSignature", value: function(r, i) {
    var n = this;
    return Fe(this.configuration).getScoreSheetSignature(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "listScoreSheets", value: function(r, i, n) {
    var t = this;
    return Fe(this.configuration).listScoreSheets(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "listScoreSheetsForRides", value: function(r, i) {
    var n = this;
    return Fe(this.configuration).listScoreSheetsForRides(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "putScoreSheetDraft", value: function(r, i, n) {
    var t = this;
    return Fe(this.configuration).putScoreSheetDraft(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "resolveStaleWriteConflict", value: function(r, i, n) {
    var t = this;
    return Fe(this.configuration).resolveStaleWriteConflict(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "restoreScoreSheetVersion", value: function(r, i, n) {
    var t = this;
    return Fe(this.configuration).restoreScoreSheetVersion(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "signScoreSheetPanel", value: function(r, i, n) {
    var t = this;
    return Fe(this.configuration).signScoreSheetPanel(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "switchAuthoritativeScoreSheet", value: function(r, i) {
    var n = this;
    return Fe(this.configuration).switchAuthoritativeScoreSheet(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "unlockScoreSheet", value: function(r, i, n) {
    var t = this;
    return Fe(this.configuration).unlockScoreSheet(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "updateScoreSheet", value: function(r, i, n) {
    var t = this;
    return Fe(this.configuration).updateScoreSheet(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }]), s;
})(Ce);
var wc = function(e) {
  return { copyScoreboardViewsFromShow: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("copyScoreboardViewsFromShow", "showId", s), S("copyScoreboardViewsFromShow", "sourceShowId", r), n = "/scoreboard/show/{showId}/views/copy-from/{sourceShowId}".replace("{showId}", encodeURIComponent(String(s))).replace("{sourceShowId}", encodeURIComponent(String(r))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "POST" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, createBrandAsset: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return S("createBrandAsset", "createBrandAssetRequest", s), i = new URL("/scoreboard/asset", x), e && (n = e.baseOptions), t = f({ method: "POST" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), t.data = L(s, t, e), [2, { url: _(i), options: t }];
        }
      });
    })();
  }, createScoreboardView: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/scoreboard/view", x), e && (n = e.baseOptions), t = f({ method: "POST" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), t.data = L(s, t, e), [2, { url: _(i), options: t }];
        }
      });
    })();
  }, deleteBrandAsset: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("deleteBrandAsset", "id", s), i = "/scoreboard/asset/{id}".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "DELETE" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, deleteScoreboardTheme: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("deleteScoreboardTheme", "id", s), i = "/scoreboard/theme/{id}".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "DELETE" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, deleteScoreboardView: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("deleteScoreboardView", "id", s), i = "/scoreboard/view/{id}".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "DELETE" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, deleteSponsor: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("deleteSponsor", "id", s), i = "/scoreboard/sponsor/{id}".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "DELETE" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, duplicateScoreboardView: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("duplicateScoreboardView", "id", s), i = "/scoreboard/view/{id}/duplicate".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "POST" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, getPublicClassResults: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        return S("getPublicClassResults", "showId", s), S("getPublicClassResults", "classId", r), n = "/public/scoreboard/{showId}/class/{classId}/results".replace("{showId}", encodeURIComponent(String(s))).replace("{classId}", encodeURIComponent(String(r))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "GET" }, a, i), u = {}, I(t, {}), l = a && a.headers ? a.headers : {}, o.headers = f({}, u, l, i.headers), [2, { url: _(t), options: o }];
      });
    })();
  }, getPublicScoreboard: function(s, r, i, n) {
    var t = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    return p(function() {
      var a, o, u, l, c, d, h;
      return v(this, function(m) {
        return S("getPublicScoreboard", "showId", s), S("getPublicScoreboard", "year", r), S("getPublicScoreboard", "slug", i), a = "/public/scoreboard/{showId}/{year}/{slug}".replace("{showId}", encodeURIComponent(String(s))).replace("{year}", encodeURIComponent(String(r))).replace("{slug}", encodeURIComponent(String(i))), o = new URL(a, x), e && (u = e.baseOptions), l = f({ method: "GET" }, u, t), c = {}, d = {}, n !== void 0 && (d.previewModeId = n), I(o, d), h = u && u.headers ? u.headers : {}, l.headers = f({}, c, h, t.headers), [2, { url: _(o), options: l }];
      });
    })();
  }, getPublicScoreboardDefaultView: function(s, r, i) {
    var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return p(function() {
      var t, a, o, u, l, c, d;
      return v(this, function(h) {
        return S("getPublicScoreboardDefaultView", "showId", s), S("getPublicScoreboardDefaultView", "year", r), t = "/public/scoreboard/{showId}/{year}".replace("{showId}", encodeURIComponent(String(s))).replace("{year}", encodeURIComponent(String(r))), a = new URL(t, x), e && (o = e.baseOptions), u = f({ method: "GET" }, o, n), l = {}, c = {}, i !== void 0 && (c.previewModeId = i), I(a, c), d = o && o.headers ? o.headers : {}, u.headers = f({}, l, d, n.headers), [2, { url: _(a), options: u }];
      });
    })();
  }, getPublicScreenCurrent: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        return S("getPublicScreenCurrent", "screenId", s), i = "/public/scoreboard/screen/{screenId}/current".replace("{screenId}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), o = {}, I(n, {}), u = t && t.headers ? t.headers : {}, a.headers = f({}, o, u, r.headers), [2, { url: _(n), options: a }];
      });
    })();
  }, listBrandAssets: function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return p(function() {
      var r, i, n, t, a, o;
      return v(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/scoreboard/assets", x), e && (i = e.baseOptions), n = f({ method: "GET" }, i, s), a = {}, [4, C(t = {}, e)];
          case 1:
            return u.sent(), I(r, a), o = i && i.headers ? i.headers : {}, n.headers = f({}, t, o, s.headers), [2, { url: _(r), options: n }];
        }
      });
    })();
  }, listScoreboardThemes: function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return p(function() {
      var r, i, n, t, a, o;
      return v(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/scoreboard/themes", x), e && (i = e.baseOptions), n = f({ method: "GET" }, i, s), a = {}, [4, C(t = {}, e)];
          case 1:
            return u.sent(), I(r, a), o = i && i.headers ? i.headers : {}, n.headers = f({}, t, o, s.headers), [2, { url: _(r), options: n }];
        }
      });
    })();
  }, listScoreboardViews: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return S("listScoreboardViews", "showId", s), i = new URL("/scoreboard/views", x), e && (n = e.baseOptions), t = f({ method: "GET" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), s !== void 0 && (o.showId = s), I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), [2, { url: _(i), options: t }];
        }
      });
    })();
  }, listSponsors: function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return p(function() {
      var r, i, n, t, a, o;
      return v(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/scoreboard/sponsors", x), e && (i = e.baseOptions), n = f({ method: "GET" }, i, s), a = {}, [4, C(t = {}, e)];
          case 1:
            return u.sent(), I(r, a), o = i && i.headers ? i.headers : {}, n.headers = f({}, t, o, s.headers), [2, { url: _(r), options: n }];
        }
      });
    })();
  }, putScoreboardTheme: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/scoreboard/theme", x), e && (n = e.baseOptions), t = f({ method: "POST" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), t.data = L(s, t, e), [2, { url: _(i), options: t }];
        }
      });
    })();
  }, putSponsor: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/scoreboard/sponsor", x), e && (n = e.baseOptions), t = f({ method: "POST" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), t.data = L(s, t, e), [2, { url: _(i), options: t }];
        }
      });
    })();
  }, releaseScoreboardViewPin: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("releaseScoreboardViewPin", "id", s), i = "/scoreboard/view/{id}/automatic".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "POST" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, resolveClassByNumber: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        return S("resolveClassByNumber", "showId", s), S("resolveClassByNumber", "classNumber", r), n = "/public/scoreboard/{showId}/class-number/{classNumber}".replace("{showId}", encodeURIComponent(String(s))).replace("{classNumber}", encodeURIComponent(String(r))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "GET" }, a, i), u = {}, I(t, {}), l = a && a.headers ? a.headers : {}, o.headers = f({}, u, l, i.headers), [2, { url: _(t), options: o }];
      });
    })();
  }, setScoreboardViewCurrentMode: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setScoreboardViewCurrentMode", "id", s), n = "/scoreboard/view/{id}/current-mode".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "POST" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, updateScoreboardView: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("updateScoreboardView", "id", s), n = "/scoreboard/view/{id}".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PATCH" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  } };
}, Pe = function(e) {
  var s = wc(e);
  return { copyScoreboardViewsFromShow: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.copyScoreboardViewsFromShow(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ScoreboardApi.copyScoreboardViewsFromShow"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, createBrandAsset: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.createBrandAsset(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreboardApi.createBrandAsset"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, createScoreboardView: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.createScoreboardView(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreboardApi.createScoreboardView"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, deleteBrandAsset: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.deleteBrandAsset(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreboardApi.deleteBrandAsset"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, deleteScoreboardTheme: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.deleteScoreboardTheme(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreboardApi.deleteScoreboardTheme"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, deleteScoreboardView: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.deleteScoreboardView(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreboardApi.deleteScoreboardView"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, deleteSponsor: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.deleteSponsor(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreboardApi.deleteSponsor"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, duplicateScoreboardView: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.duplicateScoreboardView(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreboardApi.duplicateScoreboardView"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, getPublicClassResults: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.getPublicClassResults(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ScoreboardApi.getPublicClassResults"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, getPublicScoreboard: function(r, i, n, t, a) {
    return p(function() {
      var o, u, l, c, d, h;
      return v(this, function(m) {
        switch (m.label) {
          case 0:
            return [4, s.getPublicScoreboard(r, i, n, t, a)];
          case 1:
            return l = m.sent(), d = (c = e == null ? void 0 : e.serverIndex) !== null && c !== void 0 ? c : 0, h = (u = R["ScoreboardApi.getPublicScoreboard"]) === null || u === void 0 || (o = u[d]) === null || o === void 0 ? void 0 : o.url, [2, function(j, E) {
              return T(l, w.default, y, e)(j, h || E);
            }];
        }
      });
    })();
  }, getPublicScoreboardDefaultView: function(r, i, n, t) {
    return p(function() {
      var a, o, u, l, c, d;
      return v(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, s.getPublicScoreboardDefaultView(r, i, n, t)];
          case 1:
            return u = h.sent(), c = (l = e == null ? void 0 : e.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = R["ScoreboardApi.getPublicScoreboardDefaultView"]) === null || o === void 0 || (a = o[c]) === null || a === void 0 ? void 0 : a.url, [2, function(m, j) {
              return T(u, w.default, y, e)(m, d || j);
            }];
        }
      });
    })();
  }, getPublicScreenCurrent: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getPublicScreenCurrent(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreboardApi.getPublicScreenCurrent"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, listBrandAssets: function(r) {
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, s.listBrandAssets(r)];
          case 1:
            return t = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (n = R["ScoreboardApi.listBrandAssets"]) === null || n === void 0 || (i = n[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return T(t, w.default, y, e)(c, u || d);
            }];
        }
      });
    })();
  }, listScoreboardThemes: function(r) {
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, s.listScoreboardThemes(r)];
          case 1:
            return t = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (n = R["ScoreboardApi.listScoreboardThemes"]) === null || n === void 0 || (i = n[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return T(t, w.default, y, e)(c, u || d);
            }];
        }
      });
    })();
  }, listScoreboardViews: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.listScoreboardViews(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreboardApi.listScoreboardViews"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, listSponsors: function(r) {
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, s.listSponsors(r)];
          case 1:
            return t = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (n = R["ScoreboardApi.listSponsors"]) === null || n === void 0 || (i = n[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return T(t, w.default, y, e)(c, u || d);
            }];
        }
      });
    })();
  }, putScoreboardTheme: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.putScoreboardTheme(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreboardApi.putScoreboardTheme"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, putSponsor: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.putSponsor(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreboardApi.putSponsor"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, releaseScoreboardViewPin: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.releaseScoreboardViewPin(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScoreboardApi.releaseScoreboardViewPin"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, resolveClassByNumber: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.resolveClassByNumber(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ScoreboardApi.resolveClassByNumber"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setScoreboardViewCurrentMode: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setScoreboardViewCurrentMode(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ScoreboardApi.setScoreboardViewCurrentMode"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, updateScoreboardView: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.updateScoreboardView(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ScoreboardApi.updateScoreboardView"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "copyScoreboardViewsFromShow", value: function(r, i, n) {
    var t = this;
    return Pe(this.configuration).copyScoreboardViewsFromShow(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "createBrandAsset", value: function(r, i) {
    var n = this;
    return Pe(this.configuration).createBrandAsset(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "createScoreboardView", value: function(r, i) {
    var n = this;
    return Pe(this.configuration).createScoreboardView(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "deleteBrandAsset", value: function(r, i) {
    var n = this;
    return Pe(this.configuration).deleteBrandAsset(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "deleteScoreboardTheme", value: function(r, i) {
    var n = this;
    return Pe(this.configuration).deleteScoreboardTheme(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "deleteScoreboardView", value: function(r, i) {
    var n = this;
    return Pe(this.configuration).deleteScoreboardView(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "deleteSponsor", value: function(r, i) {
    var n = this;
    return Pe(this.configuration).deleteSponsor(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "duplicateScoreboardView", value: function(r, i) {
    var n = this;
    return Pe(this.configuration).duplicateScoreboardView(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "getPublicClassResults", value: function(r, i, n) {
    var t = this;
    return Pe(this.configuration).getPublicClassResults(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "getPublicScoreboard", value: function(r, i, n, t, a) {
    var o = this;
    return Pe(this.configuration).getPublicScoreboard(r, i, n, t, a).then(function(u) {
      return u(o.axios, o.basePath);
    });
  } }, { key: "getPublicScoreboardDefaultView", value: function(r, i, n, t) {
    var a = this;
    return Pe(this.configuration).getPublicScoreboardDefaultView(r, i, n, t).then(function(o) {
      return o(a.axios, a.basePath);
    });
  } }, { key: "getPublicScreenCurrent", value: function(r, i) {
    var n = this;
    return Pe(this.configuration).getPublicScreenCurrent(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "listBrandAssets", value: function(r) {
    var i = this;
    return Pe(this.configuration).listBrandAssets(r).then(function(n) {
      return n(i.axios, i.basePath);
    });
  } }, { key: "listScoreboardThemes", value: function(r) {
    var i = this;
    return Pe(this.configuration).listScoreboardThemes(r).then(function(n) {
      return n(i.axios, i.basePath);
    });
  } }, { key: "listScoreboardViews", value: function(r, i) {
    var n = this;
    return Pe(this.configuration).listScoreboardViews(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "listSponsors", value: function(r) {
    var i = this;
    return Pe(this.configuration).listSponsors(r).then(function(n) {
      return n(i.axios, i.basePath);
    });
  } }, { key: "putScoreboardTheme", value: function(r, i) {
    var n = this;
    return Pe(this.configuration).putScoreboardTheme(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "putSponsor", value: function(r, i) {
    var n = this;
    return Pe(this.configuration).putSponsor(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "releaseScoreboardViewPin", value: function(r, i) {
    var n = this;
    return Pe(this.configuration).releaseScoreboardViewPin(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "resolveClassByNumber", value: function(r, i, n) {
    var t = this;
    return Pe(this.configuration).resolveClassByNumber(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setScoreboardViewCurrentMode", value: function(r, i, n) {
    var t = this;
    return Pe(this.configuration).setScoreboardViewCurrentMode(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "updateScoreboardView", value: function(r, i, n) {
    var t = this;
    return Pe(this.configuration).updateScoreboardView(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }]), s;
})(Ce);
var yc = function(e) {
  return { createScreen: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("createScreen", "id", s), n = "/venues/{id}/screens".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "POST" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, deleteScreen: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("deleteScreen", "id", s), i = "/screens/{id}".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "DELETE" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, getScreen: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getScreen", "id", s), i = "/screens/{id}".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, listScreens: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("listScreens", "id", s), i = "/venues/{id}/screens".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, updateScreen: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("updateScreen", "id", s), n = "/screens/{id}".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PATCH" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  } };
}, pn = function(e) {
  var s = yc(e);
  return { createScreen: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.createScreen(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ScreensApi.createScreen"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, deleteScreen: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.deleteScreen(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScreensApi.deleteScreen"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, getScreen: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getScreen(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScreensApi.getScreen"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, listScreens: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.listScreens(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ScreensApi.listScreens"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, updateScreen: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.updateScreen(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ScreensApi.updateScreen"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "createScreen", value: function(r, i, n) {
    var t = this;
    return pn(this.configuration).createScreen(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "deleteScreen", value: function(r, i) {
    var n = this;
    return pn(this.configuration).deleteScreen(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "getScreen", value: function(r, i) {
    var n = this;
    return pn(this.configuration).getScreen(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "listScreens", value: function(r, i) {
    var n = this;
    return pn(this.configuration).listScreens(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "updateScreen", value: function(r, i, n) {
    var t = this;
    return pn(this.configuration).updateScreen(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }]), s;
})(Ce);
var Rc = function(e) {
  return { getShow: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getShow", "id", s), i = "/show/{id}".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, listShows: function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return p(function() {
      var r, i, n, t, a, o;
      return v(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/show", x), e && (i = e.baseOptions), n = f({ method: "GET" }, i, s), a = {}, [4, C(t = {}, e)];
          case 1:
            return u.sent(), I(r, a), o = i && i.headers ? i.headers : {}, n.headers = f({}, t, o, s.headers), [2, { url: _(r), options: n }];
        }
      });
    })();
  }, setShowDefaultPlacingView: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setShowDefaultPlacingView", "id", s), n = "/show/{id}/default-placing-view".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setShowFriendlyName: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setShowFriendlyName", "id", s), S("setShowFriendlyName", "setShowFriendlyNameRequest", r), n = "/show/{id}/friendly-name".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setShowLogo: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setShowLogo", "id", s), n = "/show/{id}/logo".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setShowNoFoxbox: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setShowNoFoxbox", "id", s), S("setShowNoFoxbox", "setShowNoFoxboxRequest", r), n = "/show/{id}/no-foxbox".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setShowScribeUnlockPin: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setShowScribeUnlockPin", "id", s), n = "/show/{id}/scribe-unlock-pin".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setShowVenue: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setShowVenue", "id", s), n = "/show/{id}/venue".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  }, setShowVenueTimezone: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("setShowVenueTimezone", "id", s), n = "/show/{id}/venue-timezone".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  } };
}, gt = function(e) {
  var s = Rc(e);
  return { getShow: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getShow(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["ShowsApi.getShow"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, listShows: function(r) {
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, s.listShows(r)];
          case 1:
            return t = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (n = R["ShowsApi.listShows"]) === null || n === void 0 || (i = n[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return T(t, w.default, y, e)(c, u || d);
            }];
        }
      });
    })();
  }, setShowDefaultPlacingView: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setShowDefaultPlacingView(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ShowsApi.setShowDefaultPlacingView"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setShowFriendlyName: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setShowFriendlyName(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ShowsApi.setShowFriendlyName"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setShowLogo: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setShowLogo(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ShowsApi.setShowLogo"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setShowNoFoxbox: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setShowNoFoxbox(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ShowsApi.setShowNoFoxbox"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setShowScribeUnlockPin: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setShowScribeUnlockPin(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ShowsApi.setShowScribeUnlockPin"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setShowVenue: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setShowVenue(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ShowsApi.setShowVenue"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  }, setShowVenueTimezone: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.setShowVenueTimezone(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["ShowsApi.setShowVenueTimezone"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "getShow", value: function(r, i) {
    var n = this;
    return gt(this.configuration).getShow(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "listShows", value: function(r) {
    var i = this;
    return gt(this.configuration).listShows(r).then(function(n) {
      return n(i.axios, i.basePath);
    });
  } }, { key: "setShowDefaultPlacingView", value: function(r, i, n) {
    var t = this;
    return gt(this.configuration).setShowDefaultPlacingView(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setShowFriendlyName", value: function(r, i, n) {
    var t = this;
    return gt(this.configuration).setShowFriendlyName(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setShowLogo", value: function(r, i, n) {
    var t = this;
    return gt(this.configuration).setShowLogo(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setShowNoFoxbox", value: function(r, i, n) {
    var t = this;
    return gt(this.configuration).setShowNoFoxbox(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setShowScribeUnlockPin", value: function(r, i, n) {
    var t = this;
    return gt(this.configuration).setShowScribeUnlockPin(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setShowVenue", value: function(r, i, n) {
    var t = this;
    return gt(this.configuration).setShowVenue(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }, { key: "setShowVenueTimezone", value: function(r, i, n) {
    var t = this;
    return gt(this.configuration).setShowVenueTimezone(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }]), s;
})(Ce);
var xc = function(e) {
  return { listStationSnapshots: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("listStationSnapshots", "showId", s), i = "/show/{showId}/station-snapshot".replace("{showId}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, markStationReconcileReviewed: function(s, r, i, n) {
    var t = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    return p(function() {
      var a, o, u, l, c, d, h;
      return v(this, function(m) {
        switch (m.label) {
          case 0:
            return S("markStationReconcileReviewed", "showId", s), S("markStationReconcileReviewed", "deviceId", r), S("markStationReconcileReviewed", "scribeSub", i), S("markStationReconcileReviewed", "markStationReconcileReviewedRequest", n), a = "/show/{showId}/station-snapshot/{deviceId}/{scribeSub}/reconcile/review".replace("{showId}", encodeURIComponent(String(s))).replace("{deviceId}", encodeURIComponent(String(r))).replace("{scribeSub}", encodeURIComponent(String(i))), o = new URL(a, x), e && (u = e.baseOptions), l = f({ method: "POST" }, u, t), d = {}, [4, C(c = {}, e)];
          case 1:
            return m.sent(), c["Content-Type"] = "application/json", I(o, d), h = u && u.headers ? u.headers : {}, l.headers = f({}, c, h, t.headers), l.data = L(n, l, e), [2, { url: _(o), options: l }];
        }
      });
    })();
  }, postStationSnapshot: function(s, r, i) {
    var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return p(function() {
      var t, a, o, u, l, c, d;
      return v(this, function(h) {
        switch (h.label) {
          case 0:
            return S("postStationSnapshot", "showId", s), S("postStationSnapshot", "deviceId", r), t = "/show/{showId}/station-snapshot/{deviceId}".replace("{showId}", encodeURIComponent(String(s))).replace("{deviceId}", encodeURIComponent(String(r))), a = new URL(t, x), e && (o = e.baseOptions), u = f({ method: "POST" }, o, n), c = {}, [4, C(l = {}, e)];
          case 1:
            return h.sent(), l["Content-Type"] = "application/json", I(a, c), d = o && o.headers ? o.headers : {}, u.headers = f({}, l, d, n.headers), u.data = L(i, u, e), [2, { url: _(a), options: u }];
        }
      });
    })();
  }, reconcileStation: function(s, r, i) {
    var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return p(function() {
      var t, a, o, u, l, c, d;
      return v(this, function(h) {
        switch (h.label) {
          case 0:
            return S("reconcileStation", "showId", s), S("reconcileStation", "deviceId", r), S("reconcileStation", "scribeSub", i), t = "/show/{showId}/station-snapshot/{deviceId}/{scribeSub}/reconcile".replace("{showId}", encodeURIComponent(String(s))).replace("{deviceId}", encodeURIComponent(String(r))).replace("{scribeSub}", encodeURIComponent(String(i))), a = new URL(t, x), e && (o = e.baseOptions), u = f({ method: "POST" }, o, n), c = {}, [4, C(l = {}, e)];
          case 1:
            return h.sent(), I(a, c), d = o && o.headers ? o.headers : {}, u.headers = f({}, l, d, n.headers), [2, { url: _(a), options: u }];
        }
      });
    })();
  } };
}, Zn = function(e) {
  var s = xc(e);
  return { listStationSnapshots: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.listStationSnapshots(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["StationSnapshotApi.listStationSnapshots"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, markStationReconcileReviewed: function(r, i, n, t, a) {
    return p(function() {
      var o, u, l, c, d, h;
      return v(this, function(m) {
        switch (m.label) {
          case 0:
            return [4, s.markStationReconcileReviewed(r, i, n, t, a)];
          case 1:
            return l = m.sent(), d = (c = e == null ? void 0 : e.serverIndex) !== null && c !== void 0 ? c : 0, h = (u = R["StationSnapshotApi.markStationReconcileReviewed"]) === null || u === void 0 || (o = u[d]) === null || o === void 0 ? void 0 : o.url, [2, function(j, E) {
              return T(l, w.default, y, e)(j, h || E);
            }];
        }
      });
    })();
  }, postStationSnapshot: function(r, i, n, t) {
    return p(function() {
      var a, o, u, l, c, d;
      return v(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, s.postStationSnapshot(r, i, n, t)];
          case 1:
            return u = h.sent(), c = (l = e == null ? void 0 : e.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = R["StationSnapshotApi.postStationSnapshot"]) === null || o === void 0 || (a = o[c]) === null || a === void 0 ? void 0 : a.url, [2, function(m, j) {
              return T(u, w.default, y, e)(m, d || j);
            }];
        }
      });
    })();
  }, reconcileStation: function(r, i, n, t) {
    return p(function() {
      var a, o, u, l, c, d;
      return v(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, s.reconcileStation(r, i, n, t)];
          case 1:
            return u = h.sent(), c = (l = e == null ? void 0 : e.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = R["StationSnapshotApi.reconcileStation"]) === null || o === void 0 || (a = o[c]) === null || a === void 0 ? void 0 : a.url, [2, function(m, j) {
              return T(u, w.default, y, e)(m, d || j);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "listStationSnapshots", value: function(r, i) {
    var n = this;
    return Zn(this.configuration).listStationSnapshots(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "markStationReconcileReviewed", value: function(r, i, n, t, a) {
    var o = this;
    return Zn(this.configuration).markStationReconcileReviewed(r, i, n, t, a).then(function(u) {
      return u(o.axios, o.basePath);
    });
  } }, { key: "postStationSnapshot", value: function(r, i, n, t) {
    var a = this;
    return Zn(this.configuration).postStationSnapshot(r, i, n, t).then(function(o) {
      return o(a.axios, a.basePath);
    });
  } }, { key: "reconcileStation", value: function(r, i, n, t) {
    var a = this;
    return Zn(this.configuration).reconcileStation(r, i, n, t).then(function(o) {
      return o(a.axios, a.basePath);
    });
  } }]), s;
})(Ce);
var Ic = function(e) {
  return { createTest: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/test", x), e && (n = e.baseOptions), t = f({ method: "POST" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), t.data = L(s, t, e), [2, { url: _(i), options: t }];
        }
      });
    })();
  }, deleteTest: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("deleteTest", "id", s), i = "/test/{id}".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "DELETE" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, getTest: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getTest", "id", s), i = "/test/{id}".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, listTests: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/test", x), e && (n = e.baseOptions), t = f({ method: "GET" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), s !== void 0 && (o.showId = s), I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), [2, { url: _(i), options: t }];
        }
      });
    })();
  }, updateTest: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("updateTest", "id", s), n = "/test/{id}".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PUT" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  } };
}, vn = function(e) {
  var s = Ic(e);
  return { createTest: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.createTest(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["TestsApi.createTest"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, deleteTest: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.deleteTest(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["TestsApi.deleteTest"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, getTest: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getTest(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["TestsApi.getTest"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, listTests: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.listTests(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["TestsApi.listTests"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, updateTest: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.updateTest(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["TestsApi.updateTest"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "createTest", value: function(r, i) {
    var n = this;
    return vn(this.configuration).createTest(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "deleteTest", value: function(r, i) {
    var n = this;
    return vn(this.configuration).deleteTest(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "getTest", value: function(r, i) {
    var n = this;
    return vn(this.configuration).getTest(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "listTests", value: function(r, i) {
    var n = this;
    return vn(this.configuration).listTests(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "updateTest", value: function(r, i, n) {
    var t = this;
    return vn(this.configuration).updateTest(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }]), s;
})(Ce);
var _c = function(e) {
  return { createVenue: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/venues", x), e && (n = e.baseOptions), t = f({ method: "POST" }, n, r), o = {}, [4, C(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = n && n.headers ? n.headers : {}, t.headers = f({}, a, u, r.headers), t.data = L(s, t, e), [2, { url: _(i), options: t }];
        }
      });
    })();
  }, deleteVenue: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("deleteVenue", "id", s), i = "/venues/{id}".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "DELETE" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, getVenue: function(s) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return p(function() {
      var i, n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return S("getVenue", "id", s), i = "/venues/{id}".replace("{id}", encodeURIComponent(String(s))), n = new URL(i, x), e && (t = e.baseOptions), a = f({ method: "GET" }, t, r), u = {}, [4, C(o = {}, e)];
          case 1:
            return c.sent(), I(n, u), l = t && t.headers ? t.headers : {}, a.headers = f({}, o, l, r.headers), [2, { url: _(n), options: a }];
        }
      });
    })();
  }, listVenues: function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return p(function() {
      var r, i, n, t, a, o;
      return v(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/venues", x), e && (i = e.baseOptions), n = f({ method: "GET" }, i, s), a = {}, [4, C(t = {}, e)];
          case 1:
            return u.sent(), I(r, a), o = i && i.headers ? i.headers : {}, n.headers = f({}, t, o, s.headers), [2, { url: _(r), options: n }];
        }
      });
    })();
  }, updateVenue: function(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return p(function() {
      var n, t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return S("updateVenue", "id", s), n = "/venues/{id}".replace("{id}", encodeURIComponent(String(s))), t = new URL(n, x), e && (a = e.baseOptions), o = f({ method: "PATCH" }, a, i), l = {}, [4, C(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(t, l), c = a && a.headers ? a.headers : {}, o.headers = f({}, u, c, i.headers), o.data = L(r, o, e), [2, { url: _(t), options: o }];
        }
      });
    })();
  } };
}, gn = function(e) {
  var s = _c(e);
  return { createVenue: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.createVenue(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["VenuesApi.createVenue"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, deleteVenue: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.deleteVenue(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["VenuesApi.deleteVenue"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, getVenue: function(r, i) {
    return p(function() {
      var n, t, a, o, u, l;
      return v(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, s.getVenue(r, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (t = R["VenuesApi.getVenue"]) === null || t === void 0 || (n = t[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(a, w.default, y, e)(d, l || h);
            }];
        }
      });
    })();
  }, listVenues: function(r) {
    return p(function() {
      var i, n, t, a, o, u;
      return v(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, s.listVenues(r)];
          case 1:
            return t = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (n = R["VenuesApi.listVenues"]) === null || n === void 0 || (i = n[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return T(t, w.default, y, e)(c, u || d);
            }];
        }
      });
    })();
  }, updateVenue: function(r, i, n) {
    return p(function() {
      var t, a, o, u, l, c;
      return v(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, s.updateVenue(r, i, n)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = R["VenuesApi.updateVenue"]) === null || a === void 0 || (t = a[l]) === null || t === void 0 ? void 0 : t.url, [2, function(h, m) {
              return T(o, w.default, y, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function s() {
    return Oe(this, s), Ee(this, s, arguments);
  }
  return Ae(s, e), ke(s, [{ key: "createVenue", value: function(r, i) {
    var n = this;
    return gn(this.configuration).createVenue(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "deleteVenue", value: function(r, i) {
    var n = this;
    return gn(this.configuration).deleteVenue(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "getVenue", value: function(r, i) {
    var n = this;
    return gn(this.configuration).getVenue(r, i).then(function(t) {
      return t(n.axios, n.basePath);
    });
  } }, { key: "listVenues", value: function(r) {
    var i = this;
    return gn(this.configuration).listVenues(r).then(function(n) {
      return n(i.axios, i.basePath);
    });
  } }, { key: "updateVenue", value: function(r, i, n) {
    var t = this;
    return gn(this.configuration).updateVenue(r, i, n).then(function(a) {
      return a(t.axios, t.basePath);
    });
  } }]), s;
})(Ce);
function Tc(e, s) {
  for (var r = 0; r < s.length; r++) {
    var i = s[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function bt(e, s, r) {
  return s in e ? Object.defineProperty(e, s, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[s] = r, e;
}
function pi(e) {
  for (var s = 1; s < arguments.length; s++) {
    var r = arguments[s] != null ? arguments[s] : {}, i = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (i = i.concat(Object.getOwnPropertySymbols(r).filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    }))), i.forEach(function(n) {
      bt(e, n, r[n]);
    });
  }
  return e;
}
(function() {
  function e() {
    var i, n, t, a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (function(o, u) {
      if (!(o instanceof u)) throw new TypeError("Cannot call a class as a function");
    })(this, e), bt(this, "apiKey", void 0), bt(this, "username", void 0), bt(this, "password", void 0), bt(this, "accessToken", void 0), bt(this, "basePath", void 0), bt(this, "serverIndex", void 0), bt(this, "baseOptions", void 0), bt(this, "formDataCtor", void 0), this.apiKey = a.apiKey, this.username = a.username, this.password = a.password, this.accessToken = a.accessToken, this.basePath = a.basePath, this.serverIndex = a.serverIndex, this.baseOptions = (n = pi({}, a.baseOptions), t = (t = { headers: pi({}, (i = a.baseOptions) === null || i === void 0 ? void 0 : i.headers) }) != null ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : function(o) {
      var u = Object.keys(o);
      if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(o);
        u.push.apply(u, l);
      }
      return u;
    }(Object(t)).forEach(function(o) {
      Object.defineProperty(n, o, Object.getOwnPropertyDescriptor(t, o));
    }), n), this.formDataCtor = a.formDataCtor;
  }
  var s, r;
  return s = e, (r = [{ key: "isJsonMime", value: function(i) {
    var n = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return i !== null && (n.test(i) || i.toLowerCase() === "application/json-patch+json");
  } }]) && Tc(s.prototype, r), e;
})();
const Cc = {
  [pt.PENDING]: { color: "default", label: "Scheduled" },
  // #768 — stored pre-sheet, C's "Bell" press (#767). Same "info" color
  // family as IN_PROGRESS (both mean "the horse is at the ring"); the label
  // is what tells entering from actually in progress.
  [pt.ENTERING_RING]: { color: "info", label: "Entering ring" },
  [pt.IN_PROGRESS]: { color: "info", label: "In ring" },
  // #696 — score confirmed/frozen and released to the announcer + FVD, judge
  // may still be writing comments. Green like FINAL ("score ready"); the label
  // is what tells the two apart.
  [pt.CONFIRMED]: { color: "success", label: "Confirmed" },
  [pt.COMPLETED]: { color: "warning", label: "Scored" },
  [pt.FINAL]: { color: "success", label: "Final" },
  [pt.SCRATCHED]: { color: "error", label: "Scratched" },
  // #3088 - a scribe sent the ride to the scoreadmin review queue. Replaces
  // the scoring badge on every surface until an admin resolves the item.
  [pt.IN_REVIEW]: { color: "secondary", label: "In Review" },
  // #3099 - ridden and superseded in the ring, marks entered but never signed.
  // Warning (amber) so it reads as an outstanding to-do, not live "In ring".
  [pt.NEEDS_SIGNING]: { color: "warning", label: "Needs signing" }
}, Ec = { color: "default", label: "—" };
function oh({ status: e, labels: s, size: r = "small", ...i }) {
  const n = Cc[e] ?? Ec, t = (s == null ? void 0 : s[e]) ?? n.label;
  return /* @__PURE__ */ g.jsx(Lr, { size: r, color: n.color, label: t, ...i });
}
function uh(e, s, { intervalMs: r, enabled: i = !0 } = {}) {
  const [n, t] = q({}), [a, o] = q(!1), [u, l] = q(null), [c, d] = q(null), h = Array.from(new Set((e ?? []).filter(Boolean))), m = h.join(","), j = rt(s);
  j.current = s;
  const E = rt(h);
  E.current = h;
  const M = rt(m), W = i && h.length > 0 && typeof s == "function", B = ut(async () => {
    const be = E.current;
    if (!(!be.length || typeof j.current != "function")) {
      o(!0);
      try {
        const ee = await j.current(be), ue = {};
        for (const de of ee ?? []) ue[de.rideId] = de.status;
        t(ue), l(null), d(/* @__PURE__ */ new Date());
      } catch (ee) {
        l(ee);
      } finally {
        o(!1);
      }
    }
  }, []);
  return Ie(() => {
    if (M.current !== m && (M.current = m, d(null)), !h.length) {
      t({});
      return;
    }
    if (!W)
      return;
    if (!r) {
      B();
      return;
    }
    document.visibilityState !== "hidden" && B();
    let be = null;
    const ee = () => {
      document.visibilityState !== "hidden" && be == null && (be = setInterval(B, r));
    }, ue = () => {
      be != null && (clearInterval(be), be = null);
    }, de = () => {
      document.visibilityState === "hidden" ? ue() : (B(), ee());
    };
    return ee(), document.addEventListener("visibilitychange", de), () => {
      ue(), document.removeEventListener("visibilitychange", de);
    };
  }, [m, W, r, B]), { statuses: n, loading: a, error: u, refresh: B, lastUpdated: c };
}
function lh({
  judgeName: e,
  url: s,
  loading: r = !1,
  label: i = "Judge signature",
  ...n
}) {
  return r ? /* @__PURE__ */ g.jsxs(ir, { spacing: 1, alignItems: "center", sx: { mt: 3 }, ...n, children: [
    /* @__PURE__ */ g.jsx(sr, { variant: "rounded", width: 240, height: 90 }),
    /* @__PURE__ */ g.jsx(sr, { variant: "text", width: 140 })
  ] }) : s ? /* @__PURE__ */ g.jsxs(
    ir,
    {
      spacing: 1,
      alignItems: "center",
      "data-testid": "signature-box",
      sx: { mt: 3, pt: 2, borderTop: 1, borderColor: "divider" },
      ...n,
      children: [
        /* @__PURE__ */ g.jsx(xn, { variant: "caption", color: "text.secondary", children: i }),
        /* @__PURE__ */ g.jsx(
          Te,
          {
            sx: {
              border: 1,
              borderColor: "divider",
              borderRadius: 1,
              bgcolor: "#ffffff",
              p: 1,
              display: "flex",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ g.jsx(
              Te,
              {
                component: "img",
                src: s,
                alt: e || i,
                "data-testid": "signature-box-image",
                sx: { maxWidth: 240, maxHeight: 90, objectFit: "contain" }
              }
            )
          }
        ),
        e && /* @__PURE__ */ g.jsx(
          xn,
          {
            variant: "body2",
            color: "text.primary",
            fontWeight: 600,
            "data-testid": "signature-box-name",
            children: e
          }
        )
      ]
    }
  ) : null;
}
function ch(e, s, { enabled: r = !0 } = {}) {
  const [i, n] = q(null), [t, a] = q(!1), [o, u] = q(null), l = rt(s);
  l.current = s;
  const c = r && !!e && typeof s == "function";
  return Ie(() => {
    if (!c) {
      n(null);
      return;
    }
    let d = !1;
    return a(!0), u(null), (async () => {
      try {
        const h = await l.current(e);
        d || n(h ?? null);
      } catch (h) {
        d || u(h);
      } finally {
        d || a(!1);
      }
    })(), () => {
      d = !0;
    };
  }, [c, e]), { signature: i, loading: t, error: o };
}
const Oc = '[data-grid-cell="true"]', kc = { "data-grid-cell": "true" };
function dh(e, { selector: s = Oc, getOrderedCells: r } = {}) {
  const i = e.key === "Enter", n = e.key === "Tab";
  if (!i && !n || n && !r) return;
  const t = (r ? r() : Array.from(document.querySelectorAll(s))).filter((l) => l && !l.disabled), a = t.indexOf(e.target);
  if (i && e.preventDefault(), a === -1) return;
  const o = e.shiftKey ? -1 : 1, u = t[a + o];
  u && (n && e.preventDefault(), u.focus());
}
const ss = 64, Ac = 50, Pc = 2;
function jc(e) {
  return (e.match(/[0-9]/g) || []).length;
}
function Uc(e) {
  return /^[0-9]*\.?[0-9]*$/.test(e) ? jc(e) <= Pc : !1;
}
function Nc(e) {
  return e.endsWith(".") ? e.slice(0, -1) : e;
}
function vi({
  value: e,
  onChange: s,
  disabled: r,
  width: i = ss,
  borderless: n = !1,
  inputRef: t,
  onKeyDown: a,
  // #698 — true once this sheet's marks are confirmed (server-side, one-
  // way freeze). Renders the SAME success/green token RideStatusBadge uses
  // for its CONFIRMED status, so a locked-in mark reads as "confirmed", not
  // "broken/disabled".
  locked: o = !1,
  // #712 — granularity this field snaps to on blur (score-common
  // SCORE_STEP/ARTISTIC_SCORE_STEP/TENTH_SCORE_STEP, resolved per mark via
  // scoreStepFor). Defaults to the standard half-point step.
  step: u = pr,
  // #1755 — see the strict-mode doc above.
  strict: l = !1,
  // #1755 — static, already-translated tooltip text shown when `strict`
  // rejects the typed value. Required for `strict` to have
  // any visible effect; harmless (unused) otherwise.
  invalidLabel: c,
  // #1755 — fires with the current invalid boolean whenever it changes.
  // ScoreEntry's coefficient box uses this to turn its OWN border red too,
  // since the box's border replaces this field's outline (borderless) and
  // wouldn't otherwise reflect a rejected value.
  onValidityChange: d,
  // #2623 — stamps GRID_CELL_DATA_ATTR (data-grid-cell="true") on the native
  // input so a caller's Enter-as-Tab handler (common-fe's focusNextGridCell)
  // can find this field by DOM query, matching scribe-fe's class grid.
  // Purely a marker; it has no effect unless the caller also wires
  // `onKeyDown={focusNextGridCell}`. Uses the shared constant rather than a
  // second hardcoded copy of the literal, so the attribute name can't drift
  // from what focusNextGridCell's own GRID_CELL_SELECTOR looks for.
  gridCell: h = !1
}) {
  const [m, j] = q(!1), [E, M] = q(""), [W, B] = q(!1);
  Ie(() => {
    d == null || d(W);
  }, [W]);
  const be = m || W ? E : typeof e == "number" ? e.toFixed(1) : "", ee = /* @__PURE__ */ g.jsx(
    Wt,
    {
      size: "small",
      value: be,
      type: "text",
      inputRef: t,
      error: W,
      onKeyDown: a,
      inputProps: {
        inputMode: "decimal",
        pattern: "[0-9.]*",
        // #2656 — deliberately NO maxLength here. A native maxLength sits
        // in FRONT of the onChange gate below and TRUNCATES pasted text to
        // fit instead of rejecting it (browsers, and @testing-library/
        // user-event v14, both do this) — with maxLength: 3, pasting
        // "10.5" truncated to "10." (passes the digit gate, silently
        // stores 10.0) and "78.5" truncated to "78." (silently stores
        // 7.8/8.0). That is exactly the silent coercion this card exists
        // to prevent. Without it, a paste arrives whole at onChange, hits
        // isTypeableScoreDraft's real digit-count check, and is refused
        // cleanly instead of mangled. The onChange gate is the single
        // source of truth for what this field accepts.
        // #2623 — see the `gridCell` doc above.
        ...h && kc,
        // #221 — all number entry uses the same monospace typography as
        // the coefficient box (700, 0.875rem, centered) so every score
        // field reads consistently. The borderless in-box variant just
        // tightens its padding.
        style: {
          textAlign: "center",
          fontFamily: "monospace",
          fontWeight: 700,
          fontSize: "0.875rem",
          ...n && { padding: "4px 2px" }
        }
      },
      sx: (ue) => ({
        width: i,
        // #221 — borderless variant sits inside the coefficient box, so
        // it drops its own outline (the box provides the border).
        ...n && {
          "& .MuiOutlinedInput-notchedOutline": { border: "none" }
        },
        // #698 — locked (confirmed) numeric entry renders green, not the
        // washed-out default disabled grey.
        ...o && {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: ue.palette.success.main
          },
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: ue.palette.success.main,
            color: ue.palette.success.main
          }
        }
      }),
      disabled: r,
      onFocus: (ue) => {
        M(typeof e == "number" ? String(e) : ""), B(!1), j(!0), ue.target.select();
      },
      onBlur: () => {
        const ue = Nc(E);
        if (l) {
          if (ue === "") {
            if (E === "") {
              B(!1), j(!1), e !== void 0 && s(void 0);
              return;
            }
            B(!1), j(!1);
            return;
          }
          const Z = ta(ue);
          if (Z === null || Z < hl || Z > Jt) {
            B(!0), j(!1);
            return;
          }
          B(!1);
          const Ve = ea(Z, u);
          Ve !== e && s(Ve), j(!1);
          return;
        }
        const de = vl(ue, u);
        de === null ? E === "" && e !== void 0 && s(void 0) : de !== e && s(de), j(!1);
      },
      onChange: (ue) => {
        const de = ue.target.value;
        Uc(de) && (M(de), W && B(!1));
      }
    }
  );
  return /* @__PURE__ */ g.jsx(
    eo,
    {
      title: W ? c ?? "" : "",
      open: !!(W && c),
      arrow: !0,
      placement: "top",
      children: ee
    }
  );
}
function hh({
  value: e,
  onChange: s,
  disabled: r,
  coefficient: i = 1,
  inputRef: n,
  onKeyDown: t,
  // #698 — see ScoreInput's `locked` doc above; threaded through unchanged.
  locked: a = !1,
  // #712 — see ScoreInput's `step` doc above; threaded through unchanged.
  step: o = pr,
  // #1755 — see ScoreInput's `strict`/`invalidLabel` doc above; threaded
  // through unchanged.
  strict: u = !1,
  invalidLabel: l,
  // #1755 continuation — save-gating (driver decision, card comment):
  // fires with the current invalid boolean whenever it changes, so
  // RideEditor can disable Save/Commit while any score cell is in error
  // instead of silently committing the last-known-good value under a
  // visibly-errored field.
  onValidityChange: c,
  // #2623 — see ScoreInput's `gridCell` doc above; threaded through unchanged.
  gridCell: d = !1
}) {
  const [h, m] = q(!1), j = (E) => {
    m(E), c == null || c(E);
  };
  return i && i !== 1 ? /* @__PURE__ */ g.jsxs(
    ae,
    {
      "data-testid": "coefficient-entry",
      onClick: r ? void 0 : (E) => {
        var M;
        return (M = E.currentTarget.querySelector("input")) == null ? void 0 : M.focus();
      },
      sx: (E) => ({
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: ss,
        height: 40,
        px: 0.75,
        borderRadius: 1,
        border: 1,
        cursor: r ? "default" : "text",
        // Match MUI's outlined-input border in both themes. #1755 — a
        // strict-mode rejected value wins over everything (the borderless
        // inner field's own red outline is suppressed, so this box is the
        // only place a coefficient row can show the error visibly). #698 —
        // locked (confirmed) otherwise wins over the plain-disabled divider
        // color so a coefficient row visibly freezes green too.
        borderColor: h ? E.palette.error.main : a ? E.palette.success.main : r ? E.palette.divider : E.palette.mode === "dark" ? "rgba(255, 255, 255, 0.23)" : "rgba(0, 0, 0, 0.23)"
      }),
      children: [
        /* @__PURE__ */ g.jsx(
          vi,
          {
            value: e,
            onChange: s,
            disabled: r,
            width: Ac,
            borderless: !0,
            inputRef: n,
            onKeyDown: t,
            locked: a,
            step: o,
            strict: u,
            invalidLabel: l,
            onValidityChange: j,
            gridCell: d
          }
        ),
        /* @__PURE__ */ g.jsxs(
          ze,
          {
            component: "span",
            "data-testid": "coefficient-segment",
            "aria-label": `Coefficient ×${i}`,
            sx: {
              position: "absolute",
              right: 4,
              bottom: 1,
              fontFamily: "monospace",
              fontWeight: 700,
              fontSize: "0.7rem",
              lineHeight: 1,
              color: "warning.main"
            },
            children: [
              "×",
              i
            ]
          }
        )
      ]
    }
  ) : /* @__PURE__ */ g.jsx(
    vi,
    {
      value: e,
      onChange: s,
      disabled: r,
      width: ss,
      inputRef: n,
      onKeyDown: t,
      locked: a,
      step: o,
      strict: u,
      invalidLabel: l,
      onValidityChange: c,
      gridCell: d
    }
  );
}
function fh({ buildId: e, testId: s = "build-badge" }) {
  const r = Mi(e);
  return r ? /* @__PURE__ */ g.jsx(
    ae,
    {
      "data-testid": s,
      "aria-hidden": "true",
      sx: {
        position: "fixed",
        bottom: 2,
        left: 86,
        // Above AppBar/NavRail (both 1300/1200 in common-fe) so it's never
        // hidden by app chrome, but below modals/dialogs so it doesn't cover
        // interactive overlays. It's pointer-events:none anyway.
        zIndex: 1250,
        pointerEvents: "none",
        userSelect: "none",
        // A subtle themed pill so the text reads on top of any content —
        // proven legible in both light and dark (mirrors PinLock's approach).
        px: 0.5,
        py: "1px",
        borderRadius: 0.5,
        bgcolor: "background.paper",
        opacity: 0.75,
        // text.secondary reads on both light and dark backgrounds; never MUI
        // `primary` (dark-grey, vanishes on dark).
        color: "text.secondary",
        fontFamily: "monospace",
        fontSize: "9px",
        lineHeight: 1.2,
        letterSpacing: 0,
        whiteSpace: "nowrap"
      },
      children: r
    }
  ) : null;
}
function Lc({ testId: e = "usa-badge", variant: s = "fixed" }) {
  const r = s === "static";
  return /* @__PURE__ */ g.jsxs(
    ae,
    {
      "data-testid": e,
      "aria-hidden": "true",
      sx: {
        position: r ? "static" : "fixed",
        ...r ? {} : { bottom: 2, left: 2, zIndex: 1250 },
        width: 80,
        pointerEvents: "none",
        userSelect: "none",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        opacity: 0.75
      },
      children: [
        /* @__PURE__ */ g.jsx(
          ae,
          {
            component: "svg",
            viewBox: "0 0 1200 1200",
            "aria-label": "Made in the USA",
            sx: {
              width: 28,
              height: 28,
              // text.secondary reads on both light and dark backgrounds; never
              // MUI `primary` (dark-grey, vanishes on dark) — same rule as
              // BuildBadge.
              color: "text.secondary",
              fill: "currentColor"
            },
            children: /* @__PURE__ */ g.jsx("path", { d: "m60.84 823.92h1078.4v-49.801h-1078.4zm0-99.48h1078.4v-49.801h-1078.4zm1078.3-398.16v-49.801h-1078.3v348.61h1078.4v-49.801l-647.16-0.003906v-49.801h647.04v-49.801h-647.04v-49.801h647.04v-49.801h-647.04v-49.801zm-718.92 0.95703 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.238 6.3633 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm12.363 107.52-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm0 69.719-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.883-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.879-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.879 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.8398-9.7227 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-32.16-93.121 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68zm283.8-11.398-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm0 69.598-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-28.32-58.199-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.562 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.2773-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-26.043 25.078-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.559 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.3984-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-25.922 25.078-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.559 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.4023-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm199.56-81.48 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188zm-29.762 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.758 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.758 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.762 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.8359 13.801-2.0391zm-42.117-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm0 69.719 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm0 69.719 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.363-6.4766-12.359 6.4805 2.3984-13.68-9.957-9.8398zm0 69.602 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9648 9.7227 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.7227zm18.477 95.16-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.957-9.8398 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.238 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.238 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.637-41.281-12.238 6.3594 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.2812-83.398 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.723 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.598 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.723 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-405.36 606.96h1078.4v-49.801h-1078.4z" })
          }
        ),
        /* @__PURE__ */ g.jsx(
          ae,
          {
            sx: {
              mt: "1px",
              fontSize: "12px",
              fontWeight: 600,
              lineHeight: 1.15,
              letterSpacing: "0.2px",
              textAlign: "center",
              textTransform: "uppercase",
              whiteSpace: "normal",
              // text.secondary reads on both light and dark backgrounds; never
              // MUI `primary` (dark-grey, vanishes on dark).
              color: "text.secondary"
            },
            children: "Made in the USA"
          }
        )
      ]
    }
  );
}
function ph({ testId: e = "badge-footer" }) {
  return /* @__PURE__ */ g.jsx(
    ae,
    {
      component: "footer",
      "data-testid": e,
      sx: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        py: 2
      },
      children: /* @__PURE__ */ g.jsx(Lc, { variant: "static" })
    }
  );
}
const Dc = "5432";
function vh({
  pin: e = Dc,
  onUnlock: s,
  testId: r = "pin-lock",
  ariaLabel: i = "Unlock"
}) {
  const [n, t] = q(!1), [a, o] = q(""), [u, l] = q(!1), c = rt(null);
  return Ie(() => {
    n || (o(""), l(!1));
  }, [n]), Ie(() => {
    if (!n || a.length !== e.length) return;
    const d = setTimeout(() => {
      a === e ? (t(!1), s == null || s()) : (l(!0), setTimeout(() => {
        var h;
        o(""), l(!1), (h = c.current) == null || h.focus();
      }, 600));
    }, 80);
    return () => clearTimeout(d);
  }, [a, n, e, s]), /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
    /* @__PURE__ */ g.jsx(
      rr,
      {
        onClick: () => t(!0),
        "aria-label": i,
        "data-testid": r,
        sx: {
          position: "fixed",
          bottom: 12,
          right: 12,
          zIndex: 1300,
          // #628 — discreet, but actually findable and tappable: a scribe has to
          // hit it on a tablet when an admin walks over, so it can't be a 16px
          // ghost. Themed text color reads on both light and dark backgrounds.
          color: "text.secondary",
          bgcolor: "background.paper",
          border: 1,
          borderColor: "divider",
          width: 40,
          height: 40,
          "&:hover": { bgcolor: "action.hover" }
        },
        children: /* @__PURE__ */ g.jsx(xo, { sx: { fontSize: 20 } })
      }
    ),
    /* @__PURE__ */ g.jsxs(
      Yn,
      {
        open: n,
        onClose: () => t(!1),
        maxWidth: "xs",
        fullWidth: !0,
        children: [
          /* @__PURE__ */ g.jsx(Kn, { children: /* @__PURE__ */ g.jsx(ae, { sx: { pt: 1 }, children: /* @__PURE__ */ g.jsx(
            Wt,
            {
              inputRef: c,
              autoFocus: !0,
              fullWidth: !0,
              type: "password",
              value: a,
              onChange: (d) => (
                // Strip non-digits + cap to PIN length so paste-overflow
                // doesn't sneak past the auto-submit threshold.
                o(
                  d.target.value.replace(/\D/g, "").slice(0, e.length)
                )
              ),
              inputProps: {
                inputMode: "numeric",
                pattern: "[0-9]*",
                maxLength: e.length,
                style: {
                  textAlign: "center",
                  fontFamily: "monospace",
                  fontSize: 24,
                  letterSpacing: 8
                }
              },
              error: u,
              helperText: u ? "Wrong PIN" : " "
            }
          ) }) }),
          /* @__PURE__ */ g.jsx(Nr, { children: /* @__PURE__ */ g.jsx($e, { color: "inherit", onClick: () => t(!1), children: "Cancel" }) })
        ]
      }
    )
  ] });
}
const wn = /* @__PURE__ */ new Map();
function gh() {
  wn.clear();
}
const gi = (e) => e != null ? wn.get(e) : null;
function Fc(e, s) {
  if (e.length !== s.length) return !1;
  for (let r = 0; r < s.length; r++)
    if (!Object.is(e[r], s[r])) return !1;
  return !0;
}
function mh(e, s, r = [], i = !0, n = null, t = null) {
  const [a, o] = q(() => {
    const M = gi(n);
    return M ? { data: M.data, loading: !1, error: null, settled: !0 } : { data: void 0, loading: !0, error: null, settled: !1 };
  }), [u, l] = q(!1), [c, d] = q(0), h = [...r, i], [m, j] = q(h);
  if (!Fc(m, h)) {
    j(h);
    const M = gi(n);
    M ? o({ data: M.data, loading: !1, error: null, settled: !0 }) : a.settled && o((W) => ({ ...W, settled: !1 }));
  }
  Ie(() => {
    if (t != null && n != null && c === 0) {
      const B = wn.get(n);
      if (B && Date.now() - B.at < t) {
        o({ data: B.data, loading: !1, error: null, settled: !0 });
        return;
      }
    }
    let M = !1;
    const W = new AbortController();
    return (async () => {
      let B;
      try {
        B = await e();
      } catch {
        B = void 0;
      }
      const be = B != null;
      if (!M && be && (o({ data: B, loading: !1, error: null, settled: !0 }), n != null && wn.set(n, { data: B, at: -1 / 0 })), i)
        try {
          const ee = await s(W.signal);
          M || (o({ data: ee, loading: !1, error: null, settled: !0 }), n != null && wn.set(n, { data: ee, at: Date.now() }));
        } catch (ee) {
          if (W.signal.aborted) return;
          !M && !be && o({ data: null, loading: !1, error: ee, settled: !0 });
        } finally {
          M || l(!1);
        }
      else
        !M && !be && o({ data: null, loading: !1, error: null, settled: !0 }), M || l(!1);
    })(), () => {
      M = !0, W.abort();
    };
  }, [...r, i, c]);
  const E = ut(() => {
    l(!0), d((M) => M + 1);
  }, []);
  return { ...a, refetch: E, refreshing: u };
}
function bh(e, s = []) {
  const [r, i] = q({ data: null, loading: !0, error: null });
  return Ie(() => {
    let n = !1;
    return i({ data: null, loading: !0, error: null }), e().then((t) => {
      n || i({ data: t, loading: !1, error: null });
    }).catch((t) => {
      n || i({ data: null, loading: !1, error: t });
    }), () => {
      n = !0;
    };
  }, s), r;
}
function Mc({ clientId: e, cognitoDomain: s, logoutUri: r }) {
  if (e && s && r) {
    const i = `https://${s}/logout?client_id=${e}&logout_uri=${encodeURIComponent(r)}`;
    window.location.replace(i);
  }
}
function Sh() {
  const { mode: e, setMode: s } = Ii();
  return { mode: e, toggleTheme: () => {
    s(e === "dark" ? "light" : "dark");
  } };
}
function wh({ t: e, mode: s, toggleTheme: r, navigate: i, cognitoConfig: n, settingsLink: t = "/settings" }) {
  return [
    {
      icon: /* @__PURE__ */ g.jsx(_i, {}),
      text: e("navigation.homeLink"),
      onClick: () => i("/")
    },
    {
      icon: /* @__PURE__ */ g.jsx(Ti, {}),
      text: e("navigation.settingsLink"),
      onClick: () => window.location.href = t
    },
    {
      icon: s === "dark" ? /* @__PURE__ */ g.jsx(ki, { fontSize: "small" }) : /* @__PURE__ */ g.jsx(Oi, { fontSize: "small" }),
      text: e(s === "dark" ? "navigation.theme.switchToLightMode" : "navigation.theme.switchToDarkMode"),
      onClick: r
    },
    {
      icon: /* @__PURE__ */ g.jsx(Ai, {}),
      text: e("navigation.logoutLink"),
      onClick: () => Mc(n)
    }
  ];
}
const Vc = "Server Error";
let mi = !1;
function yh(e = yo) {
  mi || (mi = !0, e.interceptors.response.use(
    (s) => s,
    (s) => {
      var n, t, a;
      const r = (n = s == null ? void 0 : s.response) == null ? void 0 : n.data, i = ((t = r == null ? void 0 : r.data) == null ? void 0 : t.message) || (r == null ? void 0 : r.message) || (r == null ? void 0 : r.error) || (r == null ? void 0 : r.code) || (s == null ? void 0 : s.message);
      return console.error("[api error]", (a = s == null ? void 0 : s.response) == null ? void 0 : a.status, i, r), s && (s.serverErrorDetail = i, s.message = Vc), Promise.reject(s);
    }
  ));
}
export {
  To as AccountMenu,
  Jd as ActiveOrgProvider,
  Kd as ActiveShowProvider,
  Eo as AppBar,
  Ad as AppFooter,
  Pd as AppLayout,
  ph as BadgeFooter,
  fh as BuildBadge,
  Ud as CallbackPage,
  Ld as CognitoAuthProvider,
  Dd as ConfirmButton,
  It as DEFAULT_VENUE_TIMEZONE,
  Fr as FullScreenLoader,
  kc as GRID_CELL_DATA_ATTR,
  Oc as GRID_CELL_SELECTOR,
  nh as GateHeader,
  Wd as ItemCard,
  Md as LoggedOutPage,
  Vd as LogoutPage,
  ko as MainContent,
  rh as MockAuthProvider,
  ih as MockLoginPage,
  sh as MockProtectedRoute,
  Gd as MuiThemeProvider,
  Hd as NavRail,
  qd as NewItemCard,
  xu as OrgSwitcher,
  $d as PageLayout,
  Xd as PermissionProvider,
  vh as PinLock,
  zd as ProtectedRoute,
  Cc as RIDE_STATUS_DISPLAY,
  Zu as ReportList,
  Xu as ReportParamsForm,
  ol as ReportViewer,
  ah as Reports,
  oh as RideStatusBadge,
  il as RunHistory,
  ss as SCORE_ENTRY_WIDTH,
  Ac as SCORE_FIELD_WIDTH,
  Vc as SERVER_ERROR_MESSAGE,
  hh as ScoreEntry,
  vi as ScoreInput,
  Qd as ShowSwitcher,
  lh as SignatureBox,
  Bd as StyledBreadcrumb,
  Fd as TableSkeleton,
  Dc as UNLOCK_PIN,
  Lc as UsaBadge,
  Ru as UserDisplayName,
  gh as _resetWarmCacheForTests,
  jd as basenameFromRedirectUri,
  Nd as beginSignOut,
  dh as focusNextGridCell,
  Zd as formatVenueTime,
  wh as getDefaultAccountMenuItems,
  yh as installServerErrorInterceptor,
  Vo as isCypressTestMode,
  cu as isShowInActiveWindow,
  js as isSigningOut,
  Mc as logoutCognito,
  Mi as resolveBuildId,
  as as resolveVenueTimeZone,
  Bt as unwrapReport,
  is as useActiveOrg,
  pu as useActiveShow,
  Bu as useApiConfig,
  bh as useApiResource,
  mh as useCachedResource,
  Yi as useMockAuth,
  Li as useNavRailState,
  eh as usePermission,
  qu as useReportApi,
  uh as useRideStatuses,
  ch as useSheetSignature,
  Sh as useThemeSwitcher,
  wu as userDisplayName,
  th as userFirstName,
  uu as venueDayKey,
  Yd as venueZoneLabel
};
//# sourceMappingURL=common-fe.js.map
